import { DatePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import {
  DomSanitizer
} from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { saveAs } from 'file-saver';
import { Observable, ReplaySubject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import Swal from 'sweetalert2';
import { PhoneNoFormatPipe } from '../pipes/phone-no-format.pipe';
import { api } from '../../app/URL/api-url';
import { adjustWith2DecimalsForUI, sumBy } from "../CommonFunctions/common-functions";
import { CustomDatePipe } from '../pipes/custom-date.pipe';

import moment from 'moment';
import { normalizeDateFields, parseDateOnly, toApiDate, toDisplayDate, toLegacyUsDate } from '../CommonFunctions/date-utils';
import { HeaderComponent } from '../../app/header/header.component';
import { SideBarComponent } from '../../app/side-bar/side-bar.component';

@Component({
  selector: 'app-add-dependent',
  templateUrl: './add-dependent.component.html',
  styleUrls: ['./add-dependent.component.css'],
  providers: [DatePipe, TitleCasePipe, DecimalPipe, PhoneNoFormatPipe, CustomDatePipe],
  encapsulation: ViewEncapsulation.None
})
export class AddDependentComponent implements OnInit {
  planobjdata1: any = {};
  planobjdataobj: any = {};
  addbenificaryData: any = []
  modifiedBlocksCoveredByCompany: any;
  modifiedBlocksPaidByCompany: any;
  mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = [];
  public specialplans: any;
  public specialpackages: any;
  public formData: any;
  public allFormData: any = {};
  public packagesInBlocks: any;
  public basepackages: any;
  public customerSelectedPlans: any;
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  public companypaidproductid: any = [];
  public disabledcompanypaidproductid: any = [];
  public removedisabledcompanypaidproductid: any = [];
  public adddisabledcompanypaidproductid: any = [];
  public isDisabledplan: boolean = false;
  isExecutiveCP: boolean = false;
  employercheck: any = false;


  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;
  public alloptinplans: any = [];
  public showPaymenthMethod: boolean = false;
  public showPaymenthMethod1: boolean = true;
  public creditcardform: boolean = false;
  public bankpaymentmethod: any;
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public backdatedReasonsArr: any = [];


  public companySelectedPlans: any = [];
  public companyCoveredPlans: any = [];
  public EmployeeSelectedPlans: any = [];
  public allSelectedPlans: any = [];
  public companyDealingPlans: any = [];

  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  deltaCompanyTax: any;
  spouseDob: Date = new Date();
  spouseDob_: any;
  beneficiaries: any = [];
  beneficiaries1: any = [];
  beneficiariesConst: any = [];
  beneficiary: any = {};
  hoverStates: {
    [index: number]: boolean
  } = {};
  currencySymbol: string = "$";
  currentBeneficiary: any = { customerType: '', type: '' };
  benficiaryIsMemberDetails: any = {};
  benficiaryIsSpouseDetails: any = {};
  beneficiaryReload: number = 0;


  addPlanForm: FormGroup = new FormGroup({

    planEnrollmentDate: new FormControl(''),

  });
  cancelPlanForm: FormGroup = new FormGroup({

    terminationDate: new FormControl(''),

  });
  provianceList: any;
  isBackdated: any = false;
  planChanges: any = false;
  addressform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    line1: new FormControl(''),
    line2: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
    province: new FormControl(''),
    postalCode: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    email: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
  });

  phoneform: FormGroup = new FormGroup({
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
  });


  dependentTypeForm: FormGroup = new FormGroup({
    dependentType: new FormControl(''),
    marriageType: new FormControl(''),
    marriageDate: new FormControl(''),
    childrenCountData: new FormControl('0'),
    effectiveDate: new FormControl('')
  });
  dependentTypeForm1: FormGroup = new FormGroup({
    effectiveDate: new FormControl('')
  });

  showFirst: any = true;
  showSecond: any = false;
  spouseform: FormGroup = new FormGroup({
    dependentType: new FormControl(null, Validators.required),
    fullName: new FormControl('', [Validators.required, Validators.minLength(2), this.fullNameValidator]),
    dob: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    coveredByAnotherPlan: new FormControl('', Validators.required),
    insurer: new FormControl(''), // conditional validation may apply here
    dateOfMarriage: new FormControl('', Validators.required),
    maritalStatus: new FormControl('', Validators.required),
    reasonForLate: new FormControl('', Validators.required)
  });

  cobform: FormGroup = new FormGroup({
    insurer: new FormControl('', Validators.required),
    cobCoverage: new FormControl('', Validators.required),
  });

  maritalStatusform!: FormGroup;

  underWritingMessage1: any;
  underWritingMessage2: any;
  isExcludeSpouse: boolean = false;
  isExcludeChild: boolean = false;
  isExcludeChildAndSpouse: boolean = false;
  isExcludeAll: boolean = false;
  cobcoverage: any;
  needToUpdate: any;
  isNeedToUpdate: boolean = false;
  cobeventType: any;
  cobevent: any;
  childEffectiveDate: any;
  finalEffectiveDate: any = null;
  customerQueues: any;
  isSpouseInUnderwriting: any = false;
  underwritingHeading: any;
  voluntryplansCheck: any;
  upgradeplansCheck: any;
  planssummarymainLife: any;
  showCorpPlansTable: any = false;
  isDirectUpdate: any = false;
  upcomingamountWithoutTax: any;
  currentamountWithoutTax: any;
  upcomingamountTax: any;
  currentamountTax: any;
  proceedDeleteButtonDisabled: any;
  backdatedDependentsChild: any = [];
  backdatedDependentsSpouse: any = [];
  normalDependentDeletion: any = false;
  isSpecialCondition: any = false;
  maxEnrollmentDate: any;
  specialConditionMessage: any;
  childrenApprovalNeed: any = [];
  customerOldPlans: any = [];
  showSpouseDropDownForDelete: any = false;
  isDependentSelected: any = false;
  secondTarget: any;
  canShowPlans: any = false;
  initialCoverage: any;
  initialData: any;
  notInitialLoad: any = false;
  deleteDependentConfirmation: any = false;
  currClient: any = '';

  fullNameValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) return { required: true };

    const words = value.split(/\s+/);
    if (words.length < 2) {
      return { fullNameInvalid: true }; // Must contain at least two words
    }

    return null;
  }

  updatespouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(toApiDate(this.spouseDob)),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
    status: new FormControl('')
  });

  deletespouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(toApiDate(this.spouseDob)),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    martialStatus: new FormControl(''),
    effectiveDate: new FormControl(''),
    gender: new FormControl(''),
    status: new FormControl(''),
    reason: new FormControl('')
  });

  deleteForm: FormGroup = new FormGroup({
    deletionReason: new FormControl('', Validators.required),
    otherReason: new FormControl(''),
    selectedDepId: new FormControl('')
  });

  availableFirstNames: any = []; // example names

  deletedependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    effectiveDate: new FormControl(''),
  });

  dependentform: FormGroup = new FormGroup({
    fullName: new FormControl('', [Validators.required, Validators.minLength(2), this.fullNameValidator]),
    dob: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
    reasonForLate: new FormControl(''),
  });

  pureDependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
  });

  paymentform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  ccform: FormGroup = new FormGroup({
    cutomerId: new FormControl(''),
    Id: new FormControl(''),
    PublicApiKey: new FormControl(''),
    SuccessUri: new FormControl(''),
    FailUri: new FormControl(''),
    FirstName: new FormControl(''),
    LastName: new FormControl(''),
    email: new FormControl(''),
    CardNumber: new FormControl(''),
    ExpirationMonth: new FormControl(''),
    ExpirationYear: new FormControl(''),
    Cvv: new FormControl(''),
    nameonthecard: new FormControl(''),
    aptcheck: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl(''),
    postalcode: new FormControl(''),
    recaptchaReactive: new FormControl(''),
  });

  padform: FormGroup = new FormGroup({
    bankcode: new FormControl(''),
    transitNumber: new FormControl(''),
    accountNo: new FormControl(''),
    bankdetails: new FormControl(''),
    file: new FormControl(''),
  });

  paymentMethodForm: FormGroup = new FormGroup({
    bankCode: new FormControl(''),
    branchCode: new FormControl(''),
    accountNumber: new FormControl(''),
    files: new FormControl(''),
    paymentmethod: new FormControl(''),
  });

  valisignform: FormGroup = new FormGroup({
    code: new FormControl(''),
  });

  invoicesList: any[] = [];
  hicList: any[] = [];
  @Input() customerId: any;
  customerData: any;
  childrenInfo: any[] = [];
  childrenId: any;
  paymentMethod: any;
  spouseInsurer: any;
  roe: any;
  viewRoe: boolean = true;
  formConfiguration: any;
  beneficiaryValidations: any = [];
  selectedTab: any = 'tab1';
  healthCard: any = false;
  src: any;
  spouseCoverage: any;
  childCoverage: any;
  specialNeeds: any;
  postSecondaryStudent: any;
  graduationDate = true;
  coverage: any = 'open';
  isDependentPlanChange: any = true;
  dependentCoverage = 'close';
  bookletList: any[] = [];
  bookletList1: any[] = [];
  isDeleteDisabled: any = true;
  displayStyle = 'none';
  displayBooklet = 'none';
  roeUrl: any;
  secondaryPhone: any;
  invalidpostalcodeprivince: boolean = false;
  configprovinceres: any;
  openUpdatePaymentForm: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  postalvalue: any;
  resetButton = false;
  resetbutton = false;
  uploadCheque = false;
  bankInfo: any;
  bank: any;
  bankAddress: any[] = [];
  displayTimer: any;
  showTimer: any;
  startTimer: any;
  customerid: any;
  accessToken: any;
  invoiceResponse: any;
  creditCardNo: any;
  expire: any;
  bookletLink: any;
  booklet_link: any;
  support_link: any;
  health_card: any;
  hidebooklet: any = false;
  upcomingInvoice: any;
  spouseId: any;
  fusebillId: any;
  advisor: any;
  corporateDetails: any;
  paymentVoidCheque: any;
  imagedisplay: any;
  address: any;
  fileExtension: any;
  signatureImg: any;
  encBank: any;
  showIAFG: any;
  iafgSubscriptionPendingNotification: any;
  iafgSubscriptionConfirmation: any;
  medicalQuestionaireStatus: any;
  pendingMedicalQuestionaire: any;
  pendingMedicalQuestionaireCoverage: any;
  iafg: any;
  signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 700,
    'canvasHeight': 300
  };
  deleteBenfIds: any = [];
  deleteBenfIds1: any = [];
  spouseData: any;
  spouseUpdate: any;
  spouseStatus: any;
  spouseInfo: any;
  dependentData: any;
  dependentUpdate: any;
  dependentStatus: any;
  currentDeleteMember: any = "spouse";
  selectedBase64: any;
  expireMonth: any;
  expireYear: any;
  invalidExpiration = false;
  showImage = false;
  bankDetails = false;
  bankinfo = false;
  cheque = false;
  additionalDetails: any;
  pad: any;
  iafgplansCheck: any = [];
  signedPad: any;
  PADdetails: any;
  bankCode: any;
  transitNumber: any;
  accountNumber: any;
  banknameres: any;
  items: any = 1;
  cardNumber: any;
  currentIndex = 1;
  link: any;
  showconfirm: any = false;
  selectedLanguage: any;


  @ViewChild('closePhonemodal') closePhonemodal: any;
  @ViewChild('closeAddressmodal') closeAddressmodal: any;
  @ViewChild('closeSpousemodal') closeSpousemodal: any;
  @ViewChild('closeDependentmodal') closeDependentmodal: any;
  @ViewChild('closePaymentmodal') closePaymentmodal: any;
  @ViewChild('openRoe') openRoe: any;
  @ViewChild('videoPopup') openPopup: any;
  @ViewChild('iframePopup') openiframe: any;
  @ViewChild('equitablePopup') openequitable: any;
  @ViewChild('supportPopup') opensupport: any;
  @ViewChild('closePaymenttoPAD') closePaymenttoPAD: any;
  filename: any;
  padfilename: any;
  ext: any;
  mimetype: any;
  previewbutton: boolean = false;
  updatepreviewbutton: boolean = false;
  changetopad: boolean = false;
  invoicedraftData: any;
  paymentUri: any;
  paymentsuccessuri: any;
  publicapikey: any;
  paymentform2: any;
  recaptchaResponse: any;
  fusbillinfocaptchavalue: any;
  fullName: any;
  voidCheque1: any;
  voidCheque2: any;
  bankinformation: any;
  paymentMethodId: any;
  padAgreement: any;
  existVoid: any;
  review: any;
  fuseBillKey: any;
  voidCheckImage: any;
  voidCheckFileType: any;
  ccDetails: any;
  stateId: any;
  countryId: any;
  customerID: any;
  card: any;
  spouse: any;
  index: any = 1;
  lang: any = {};
  lang1: any = {};
  gender: any;
  dependentBackgroundColor: any[] = [];
  plans: any;
  benefits: any;
  unlistener: any;
  videoLink: any;
  videoTitle: any;
  videoPopup: any = 'none';
  iframeLink: any;
  iframeTitle: any;
  customerInvoices: any[] = [];
  registrationDate: any;
  iafgDays: any;
  enactMode: any = "add";

  currentIndexOfSwipperDependents: any = 1;

  currentIndexOfSwipperDownload: any = 1;

  currentIndexOfSwipperPlan: any = 1;

  currentIndexOfSwipperBenifits: any = 1;
  @ViewChild('videoPlayer') videoplayer: any;

  public startedPlay: boolean = false;

  public show: boolean = false;
  logo: any;
  editSpouse: boolean = true;
  editChild: boolean = false;
  logoimage: any;
  headerName: any;
  voidCheckPdf: any;
  url: any;
  minDate: any;
  maxDate: any;
  minDatechild: any;
  minDateHire: any;
  maxDatechild: any;
  memberportalgreensShildCheck: any;
  memberportalEquitabelCheck: any;
  secondaryphonecheck: boolean = false;
  failedsignature: any;
  showinvoiceMessage: any;
  isCorporateAccount: any = false;
  invoiceslink: any;
  getCustomerDraftDetails: any;
  getCustomerDraftDate: any = "";
  showViewPlansLoading: boolean = true;
  loading: boolean = true;
  showROES: any[] = [];
  waddelCustomer: any;
  showupdatesignatue: boolean = true;
  memberDOB: any;
  cardType: string = '';
  public invalidcreditcard: boolean = false;
  invalidcreditcarddetails: boolean = false;
  customerFinalInvoices: any[] = [];
  customerFinalInvoicesIGBMS: any[] = [];
  allCustomerFinalInvoices: any = [];
  allCustomerFinalInvoicesIGBMS: any = [];
  getCustomerDraftDate1: any = "";
  filterDateSelection: any = "";
  filteredInvoices: any = [];
  filterInvoice: any = "All";
  maxDateForPicker: Date = new Date();
  @Input() formConfig!: any;
  @Input() customerDataInput: any;
  currentYear: any;
  @ViewChild(HeaderComponent) header!: HeaderComponent;
  @ViewChild(SideBarComponent) sidebar!: SideBarComponent;

  criticalInsurance: any = [{
    title: 'Subscription Details',
    logo: 'img_link',
    data: '30 days'
  },
  {
    title: 'Questions Details',
    logo: 'img_link',
    data: 'questions data'
  }
  ]
  normalSpouseRegistration: any = true;
  noReason: any = ''
  normalDependentRegistration: any = true;
  dependentType: any = '';
  isMarried: any;
  isCommonLaw: any;
  showDependent: any;
  dummyDependentData: any;
  marriageType: any;
  isInsuranceCheck: boolean = false;
  childCount: any = 0;
  showChildForm: boolean = false;
  childrenDetails: any = [];
  childrenDetailsForNormalReg: any = [];
  editChildUpdate: boolean = false;
  childIndex: any = 0;
  mode: any;
  dummyPlanAndPriceChangeData: any;
  validateCheck: any = true;
  showValidatePlans: boolean = false;
  combinedPlanAndPriceChangeData: any;
  customerRegisteredServices: any = [];
  todayDate: any;
  validatePlansData: any;
  displayPackage: any;
  role: any = '';
  plansError: boolean = false;
  cartcheckvalue: any;
  plansObj: any;
  addPlansConfigData: any;
  warningsData: any;
  addPlanEnrollmentDate: any;
  unselected: any = [];
  selectedPlans_: any = [];
  obj: any = {};
  obj1: any = [];
  downgradePlans: any = [];
  unSelectedPlans_: any = [];
  newlySelectedPlans: any = [];
  planobjdata!: { packageId: any; packageName: any; planproductname: any; groupid: any; groupName: any; id: any; name: any; planLevel: any; planLevelParent: any; fusebillPlanID: any; planFrequencyID: any; isBundle: any; coverage: any; planCoverage: any; bundledProducts: any[]; products: any[]; };
  planssummaryopt: any;
  planAmount: any;
  plansskumain: any = [];
  planssummarymain: any;
  plandetailsobjvalue: any;
  optionstitle: any;
  showoptions: any;
  showPlanDetails: any = false;
  showAfterPlanDetails: any = false;
  showSpouseInfo: any = false;
  maritalStatus: any = "";
  reasonForLate: any = "";
  handlePlanUpgrade: any;
  priceChangeText: any;
  coverageChangeText: any;
  provisioningSites: any;
  coverageChange: any;
  coverageChange2: any;
  hasSpouse: any = false;
  hasChildren: any = false;
  planEnrollmentDates: any;
  showROAS: any[] = [];
  addDependentWithSpouse: boolean = false;
  coveredByAnotherPlan: any;
  selectedDepId: any;
  addToPolicy: any;
  dependentChildCoverage: string = 'undefined';
  plansSummaryObj: any = [];
  firstColumn = ['Plan Name', 'Coverage', 'Price', 'Tax']
  signaturecheckvalue1cc: any;
  public signaturemessagecc: boolean = false;
  public signaturecheckvaluecc: boolean = false;
  public signaturecheckcc: boolean = true;
  spouseCovered: any = false;
  childCovered: any = false;
  totalCount: number = 0;
  totalSummaryPrice: any = 0;
  oldExistingPlans: any = [];
  selectedTrues: any = [];
  isSpouseExists: any = false;
  isUpgradeOrDowngrade: any = '';
  productobj: any = {};
  selectedDependentDetails: any = {};
  customerPlans: any;
  upgradeorDowngradeplans: any = []
  upgradeorDowngradeplansSelected: any = []
  isCorpCustomer: boolean = false;
  Displayproducts: any;

  applicantSpousename: any;
  spouseName: any;
  applicantfirstname: any;
  applicantChildrenname: any;
  lecHistory: any = [];
  marriedDate: any;
  padView: any;
  spouseMarriedDate: any;
  genders: any;
  showDependentForm: any = false;
  firstMessage: any = '';
  secondMessage: any = '';
  currentamount: any = 0;
  upcomingamount: any = 0;
  backdatedamount: any = 0;
  currentamountUI: any = 0;
  upcomingamountUI: any = 0;
  backdatedamountUI: any = 0;
  firstConfirmMessage: any;
  secondConfirmMessage: any;
  thirdConfirmMessage: any;
  effectedPackages: any = [];
  effectedPackageNames: any = [];
  existingSpouse: any;
  existingChildren: any;
  isSpouseExistsBefore: boolean = false;
  isChildExistsBefore: boolean = false;
  showAddToPolicyError: boolean = false;
  isGradError: boolean = false;
  corpMessage: any;
  payrollDeduction: any = false;
  isSpouseSelected: any = {};
  isChildSelected: any = {};

  constructor(
    private renderer: Renderer2,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public elementRef: ElementRef,
    private _decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private titleCase: TitleCasePipe,
    private phoneNoFormat: PhoneNoFormatPipe,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private renderer2: Renderer2,
    private router: Router,
    public _LoaderService: LoaderService,
    private _CustomDatePipe: CustomDatePipe
  ) {

  }
  @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  disabledelement: any;
  ngOnInit() {
    this.getLanguageTokens();

    this.showDependent = false;

    let client = sessionStorage.getItem('currClient');
    if (client) {
      this.currClient = client;
    }

    this.planEnrollmentDates = [
      moment().subtract(1, 'months').startOf('month').format('MMM-DD-YYYY'), // Previous month
      moment().startOf('month').format('MMM-DD-YYYY'),
      moment().add(1, 'months').startOf('month').format('MMM-DD-YYYY'),
      moment().add(2, 'months').startOf('month').format('MMM-DD-YYYY')
    ]
    this.currentYear = Number(new Date().getFullYear());

    this.minDate = moment().subtract(100, "years").calendar();
    this.maxDate = moment().subtract(16, "years").calendar();

    this.minDate = new Date(this.minDate);

    this.maxDate = new Date(this.maxDate);

    this.minDateHire = moment().subtract(60, "years").calendar();


    this.minDatechild = new Date();
    const today = new Date();
    this.minDatechild.setFullYear(today.getFullYear() - 21);
    this.minDatechild.setMonth(0); // January
    this.minDatechild.setDate(1); // 1st
    this.maxDatechild = new Date();
    this.dependentBackgroundColor = ["#E6D1FF",
      "#FFE2FB",
      "#E2F1FF",
      "#E6D1FF",]
    this.customerid = sessionStorage.getItem('customerId');
    this.accessToken = sessionStorage.getItem('accessToken');


    this.route.queryParams.subscribe(params => {
    })
    this.logoimage = sessionStorage.getItem("logo")
    this.unlistener = this.renderer2.listen("document", "click", event => {
      let element = event.target
      var attribute = element.getAttribute("href");
      var heading = element.innerText;
      if (event.target.className == 'video') {
        event.preventDefault();
        this.videoLink = attribute;
        this.videoTitle = heading;
        var video = document.getElementsByTagName('video')[0];

        this.openVideoPopup();
        video.load();
        video.play();
      }
      if (event.target.className == 'shortlink') {
        this.openSupportPopup();
        this.support_link = this.sanitizer.bypassSecurityTrustResourceUrl(attribute);
        event.preventDefault();
      }
      if (event.target.className == 'booklet') {
        this.openequitablePopup();
        event.preventDefault();
        this.booklet_link = element.getAttribute("href");
      }
      if (event.target.className == 'healthcard') {
        this.downloadCard();
        event.preventDefault();
        this.health_card = element.getAttribute("href");
      }
      if (event.target.classList.contains('closevideo')) {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'closevideo') {
        var video = document.getElementsByTagName('video')[0];
        video.pause();
      }
      if (event.target.className == 'drugsmart') {
        event.preventDefault();
        window.open("https://drugsmart-pharmacy.myshopify.com/account/register",
          "Register Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.className == 'bedrugsmart') {
        event.preventDefault();
        window.open("https://bedrugsmart.ca/pages/direct2u",
          "Direct2U pharma", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
      }
      if (event.target.classList.contains('site')) {
        if (attribute == 'unsafe: https://www.myfriendlylawyer.com/subscriptions') {
          attribute = 'https://www.myfriendlylawyer.com/subscriptions';
        }
        this.iframeLink = this.sanitizer.bypassSecurityTrustResourceUrl(attribute)
        this.iframeTitle = heading;
        if (this.iframeLink.changingThisBreaksApplicationSecurity != 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://groupbenefitz.lifespeak.com' && this.iframeLink.changingThisBreaksApplicationSecurity != 'http://my.norton.com/' && this.iframeLink.changingThisBreaksApplicationSecurity != 'https://clients.cowangroup.ca/') {
          this.openiframePopup();
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en') {
          window.open("https://secure.kiihealth.ca/register?eac=BNFZ1222&locale=en", "CloudMDKii", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://groupbenefitz.lifespeak.com') {
          window.open("https://groupbenefitz.lifespeak.com", "LifeSpeak", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'http://my.norton.com/') {
          window.open("http://my.norton.com/", "Norton", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }

        if (this.iframeLink.changingThisBreaksApplicationSecurity == 'https://clients.cowangroup.ca/') {
          window.open("https://clients.cowangroup.ca/", "Cowin", "menubar=1,toolbar=yes,resizable=0,width=800,height=465,left=220,top=170");
        }
        event.preventDefault();
      }







    });

    this.fusbillinfocaptchavalue = '6LfVtGwUAAAAALHn9Ycaig9801f6lrPmouzuKF11';
    this.url = window.origin + "/";
    this.paymentUri = this.url + "home";

    this.paymentsuccessuri = this.url + "home";



    this.customerid = sessionStorage.getItem("customerId");


    this.phoneform = this.formBuilder.group({
      primaryPhone: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
      secondaryPhone: ['', [Validators.minLength(16), Validators.maxLength(16)]],
    });

    this.dependentTypeForm = this.formBuilder.group({
      dependentType: ['', [Validators.required]],
      marriageType: ['', [Validators.required]],
      marriageDate: ['', [Validators.required]],
      childrenCountData: [{ value: 0, disabled: true }],
      effectiveDate: ['', [Validators.required]]
    })
    this.dependentTypeForm1 = this.formBuilder.group({
      effectiveDate: ['', [Validators.required]]
    })



    this.addressform = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      line1: ['', [Validators.required]],
      line2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      province: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      primaryPhone: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
      secondaryPhone: ['', [Validators.minLength(16), Validators.maxLength(16)]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9._%+-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
          ),
        ],
      ],
    });



    this.spouseform = this.formBuilder.group({
      fullName: ['', [Validators.required, Validators.minLength(2), this.fullNameValidator]],
      dependentType: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      insurer: [''],
      dateOfMarriage: ['', [Validators.required]],
      maritalStatus: [''],
      reasonForLate: ['']
    });



    this.spouseform.get('coveredByAnotherPlan')?.valueChanges.subscribe(value => {
      const insurerControl = this.spouseform.get('insurer');

      if (value === true || value === 'true') {
        insurerControl?.setValidators([Validators.required]);
      } else {
        insurerControl?.clearValidators();
      }

      insurerControl?.updateValueAndValidity();
    });



    this.cobform = this.formBuilder.group({
      insurer: ['', [Validators.required]],
      cobCoverage: ['', [Validators.required]],
    });

    this.maritalStatusform = this.formBuilder.group({
      maritalStatus: ['', Validators.required],
      reason: [''],
      deleteForm: this.formBuilder.group({
        deletionReason: [''],
        otherReason: [''],
        selectedDepId: [''],
      })
    });


    this.maritalStatusform.get('maritalStatus')?.valueChanges.subscribe(value => {
      const reason = this.maritalStatusform.get('reason');

      if (value === 'other') {
        reason?.setValidators([Validators.required]);
      } else {
        reason?.clearValidators();
      }

      reason?.updateValueAndValidity();
    });


    this.updatespouseform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      healthPlan: ['', [Validators.required]],
      insurer: ['', [Validators.required]],
      martialStatus: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      status: [''],
    });


    this.deletespouseform = this.formBuilder.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      dob: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      coveredByAnotherPlan: [{ value: '', disabled: true }],
      healthPlan: [{ value: '', disabled: true }],
      insurer: [{ value: '', disabled: true }],
      martialStatus: [{ value: '', disabled: true }],
      effectiveDate: [{ value: '', disabled: true }],
      gender: [{ value: '', disabled: true }],
      status: [{ value: '', disabled: true }],
      reason: [{ value: '' }]
    });

    this.deleteForm = this.formBuilder.group({
      deletionReason: ['', Validators.required],
      otherReason: [''],
      selectedDepId: [''],
    });

    const deletionReasonControl = this.deleteForm.get('deletionReason');
    if (deletionReasonControl) {
      deletionReasonControl.valueChanges.subscribe(value => {
        const otherReasonControl = this.deleteForm.get('otherReason');
        if (otherReasonControl) {
          if (value === 'other') {
            otherReasonControl.setValidators(Validators.required);
          } else {
            otherReasonControl.clearValidators();
          }
          otherReasonControl.updateValueAndValidity();
        }
      });
    }

    this.deletedependentform = this.formBuilder.group({
      firstName: [{ disabled: true }],
      lastName: [{ disabled: true }],
      dob: [{ disabled: true }],
      email: [{ disabled: true }],
      coveredByAnotherPlan: [{ disabled: true }],
      carrierName: [{ disabled: true }],
      postSecondaryStudent: [{ disabled: true }],
      effectiveDate: [{ disabled: true }],
      gender: [{ disabled: true }],
      age: [{ disabled: true }],
      phoneNum: [{ disabled: true }],
      graduationDate: [{ disabled: true }],
    });



    if (this.dependentType === 'child' && this.showChildForm) {
      this.pureDependentform = this.formBuilder.group({
        firstName: ['', [Validators.required, Validators.minLength(1)]],
        lastName: ['', [Validators.required, Validators.minLength(1)]],
        gender: ['', [Validators.required]],
        dob: ['', Validators.compose([Validators.required, childrenminimumAgeValidator, this.validateDateforGraduationandBirth])],
        age: [''],
        phoneNum: [''],
        coveredByAnotherPlan: ['', [Validators.required]],
        graduationDate: [''],
        carrierName: ['', [Validators.required]],
        specialNeeds: [''],
        postSecondaryStudent: [''],
        effectiveDate: ['', [Validators.required]],
      });
    }
    this.dependentform = this.formBuilder.group({
      fullName: ['', [Validators.required, Validators.minLength(2), this.fullNameValidator]],
      dob: ['', [Validators.required]],
      age: [''],
      phoneNum: [''],
      coveredByAnotherPlan: ['', [Validators.required]],
      graduationDate: [''],
      carrierName: ['', [Validators.required]],
      specialNeeds: [''],
      postSecondaryStudent: [''],
      reasonForLate: ['']
    });

    // Subscribe to value changes of effectiveDate
    this.dependentTypeForm1.get('effectiveDate')?.valueChanges.subscribe((newDate) => {
      console.log(newDate);
      if (newDate) {
        this.handleContinue('remove');
      }
    });


    this.paymentform = this.formBuilder.group({
      cutomerId: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: ["", Validators.compose([Validators.required, Validators.pattern('^(?!\\s)[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      recaptchaReactive: ["", Validators.required],
    })

    this.ccform = this.formBuilder.group({
      cutomerId: [""],
      Id: [""],
      PublicApiKey: [""],
      SuccessUri: [""],
      FailUri: [""],
      FirstName: ["", [Validators.required]],
      LastName: ["", [Validators.required]],
      email: [""],
      CardNumber: ["", [Validators.required]],
      ExpirationMonth: ["", Validators.required],
      ExpirationYear: ["", Validators.required],
      Cvv: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      nameonthecard: [""],
      aptcheck: [""],
      streetaddress: [""],
      streetaddressline2: [""],
      city: [""],
      countryId: [""],
      stateId: [""],
      postalcode: [""],
      recaptchaReactive: ["", Validators.required],
    });

    this.padform = this.formBuilder.group({
      bankcode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      transitNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      bankdetails: [''],
      file: [''],
    })

    this.paymentMethodForm = this.formBuilder.group({
      bankCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      branchCode: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      accountNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      files: [''],
      paymentmethod: [''],
    })

    this.valisignform = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(6)]],
    })

    this.route.queryParams.subscribe((params) => {
      if (params["success"]) {
        if (params["success"] == "False") {

          setTimeout(() => {
          }, 10);
          Swal.fire({
            allowOutsideClick: false,
            title: this.lang?.An_error_occurred_while_processing_the_transaction_possible_failure_reasons_are || 'An error occurred while processing the transaction. possible failure reasons are',
            text: this.lang?.The_payment_information_could_not_be_verified || "The payment information could not be verified",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              if (this.currClient) {
                this.router.navigate([`${this.currClient}/home`]);
              } else {
                this.router.navigate(['home']);
              }
            }
          });
        }
        else {
          let oldCardDetails = JSON.parse(localStorage.getItem("oldCardDetails") ?? "{}")
          let newCardDetails = JSON.parse(localStorage.getItem("newCardDetails") ?? "{}")

          let cardDetails = {
            old: oldCardDetails,
            new: newCardDetails
          }
          let Endpoint = '/customer/' + this.customerid + '/paymentType/CREDIT_CARD/change';
          this.http.post(api.url + Endpoint, { "paymentId": parseInt(params["paymentMethodId"]), "cardDetails": cardDetails }, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
            }
          }).subscribe((response: any) => {
            if (this.currClient) {
              this.router.navigate([`${this.currClient}/home`]);
            } else {
              this.router.navigate(['home']);
            }
            localStorage.removeItem("oldCardDetails")
            localStorage.removeItem("newCardDetails")
            if (response.status == 200) {
              if (response.message == "Payment method updated successfully. Any changes related to plans and member-cards if applicable, will be reflected soon.") {
                setTimeout(() => {
                  window.location.reload()
                }, 40000);
                let existingCreditCards = JSON.parse(sessionStorage.getItem('existingCreditCards') || '')
                if (existingCreditCards && existingCreditCards?.length > 0) {
                  for (let i = 0; i < existingCreditCards.length; i++) {
                    this.http.delete(api.url + `/payment/cc/${existingCreditCards[i]?.id}/remove`, {
                      headers: {
                        Authorization: 'Bearer ' + this.accessToken,
                        'Content-Type': 'application/json',
                      }
                    })
                      .subscribe((response: any) => {
                        if (response.status != 200) {
                        }
                      })
                  }
                  sessionStorage.removeItem('existingCreditCards')
                }
              }
              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
            }
            else {
              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
            }
          }, (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
          });


        }
      }
    });


    this.adjudicationQueues()

  }



  validateDateforGraduation = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.dependentform) {
      let dobControl = this.dependentform.get('dob');
      if (dobControl) {
        const dob = parseDateOnly(dobControl.value);
        const value = parseDateOnly(control.value);
        if (dob && value && value < dob) {
          return { validGraduationDate: true };
        }
      }
    }
    return null;
  };
  validateDateforGraduationandBirth = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.dependentform) {
      let gradeControl = this.dependentform.get('graduationDate');
      if (gradeControl) {
        const grade = parseDateOnly(gradeControl.value);
        const value = parseDateOnly(control.value);
        if (grade && value && value > grade) {
          return { validGraduationDateBirth: true };
        }
      }
    }
    return null;
  };

  public adjudicationQueues() {
    let endPoint = '/customer/get-adjudication-queues/' + this.customerid
    this.http.get(api.url + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200 || response.statusCode == 200) {
        this.customerQueues = response.data.queues ?? []
        for (const queue of this.customerQueues) {
          if (queue.status == 'Review' && queue.process.includes("Spouse")) {
            this.isSpouseInUnderwriting = true;
          }
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.error?.message })
    })
  }


  public handleActionMode(value: any) {
    this.needToUpdate = ''
    this.cobevent = ''
    this.showCorpPlansTable = false;
    this.cobeventType = ''
    this.enactMode = value;
    this.isExcludeSpouse = false;
    this.isExcludeAll = false;
    this.isExcludeChild = false;
    this.isExcludeChildAndSpouse = false;
    this.finalEffectiveDate = null;
    this.clearAllMessages();
    this.dependentType = ''
    this.maritalStatus = ''
    this.needToUpdate = false;
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.deleteForm.reset()
    this.spouseform.reset()
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.addToPolicy = ''
    this.secondMessage = ''
    this.dependentform.reset()
    this.cobform.reset()
  }

  public handleMaritalStatus(value: any) {
    this.maritalStatus = value;
  }


  public splitPackages() {
    const currentCoverage = this.coverageChange2;
    let splitPackages: any = [];
    switch (currentCoverage) {
      case "STF":
        splitPackages.push('STC')
        splitPackages.push('CTF')
        break;
      case "FTS":
        splitPackages.push('FTC')
        splitPackages.push('CTS')
        break;
      default:
        break;
    }
    return splitPackages;
  }



  public ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const dob = control.value;
      if (!dob) {
        return null; // No DOB provided
      }

      const today = new Date();
      const birthDate = parseDateOnly(dob);
      if (!birthDate) {
        return null;
      }
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age < minAge ? { 'ageError': true } : null; // Return an error if under 18
    };
  }

  public handleContinue(response: any) {
    this.showPlanDetails = true;
    this.showAfterPlanDetails = false;
    console.log(this.dependentType, "slug889")
    this.dependentType = this.dependentType ?? 'spouse'
    console.log(this.dependentTypeForm.get('effectiveDate')?.value)
    console.log(this.dependentform.get('effectiveDate')?.value)
    let effectiveDate: any;

    console.log('this.dependentCoverage990', this.childrenDetails)
    let childCovered = 'none';
    let childCoveredCount = 0;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      for (const cd of this.childrenDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.childrenDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    console.log(this.isCorporateAccount, 'isCorporateAccount')

    if (response.status == 200 && !this.isCorporateAccount) {
      console.log(response?.data, 'asda')
      this.coverageChange = response?.data?.coverageChange;
      let prs = response?.data?.gsOrEqMemberStatus ?? {}
      let prsStatus: any = []
      const prsKeys = Object.keys(prs);
      if (prsKeys.length > 0) {
        for (const prk of prsKeys) {
          if (prs[prk] == true) {
            if (prk == 'greenShildCustomer') {
              prsStatus.push('GreenShield')
            }
            if (prk == 'hcdSecuremePlans') {
              prsStatus.push('HCD Secureme')
            }
            if (prk == 'equitableCustomer') {
              prsStatus.push('Equitable')
            }
            if (prk == 'phrCustomer') {
              prsStatus.push('PHR')
            }
            if (prk == 'waddelCustomer') {
              prsStatus.push('Waddel')
            }
          }
        }
      }
      this.provisioningSites = prsStatus.toString() ?? ""


      console.log("calledoooo")
      let data__ = response?.data?.packages
      this.customerPlans = response?.data?.customerPlans;

      console.log(this.customerPlans, "custplans889")
      setTimeout(() => {

        const coverageMap: { [key: string]: string } = {
          STC: 'COUPLE',
          STF: 'FAMILY',
          CTF: 'FAMILY',
          CTS: 'SINGLE',
          FTS: 'SINGLE',
          FTC: 'COUPLE',
          F: 'FAMILY'
        };

        console.log(this.showAfterPlanDetails)
        console.log(this.secondTarget)

        let targetCoverage = this.showAfterPlanDetails ? this.secondTarget : coverageMap[this.coverageChange];
        this.customerPlans.forEach(element => {
          const dom: HTMLElement = this.elementRef.nativeElement;


          console.log(element, "jiihhsh")
          if (element.isBundle) {


            let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
            let clicked = false;


            if ($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length == 0) {
              for (const cov of coverages) {
                const selector = "#plancheck" + element.planId + ".coverage" + cov.toUpperCase();
                if ($(selector).length > 0 && !clicked) {
                  $(selector).click();
                  $(selector).prop("disabled", true);
                  clicked = true;
                }
              }
            } else {
              const selector = "#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase();
              $(selector).click();
              $(selector).prop("disabled", true);
            }


          }
          else {
            console.log(targetCoverage, "after else")
            if (targetCoverage && targetCoverage != '-') {

              console.log("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase())
              $("#plancheck" + element.planSelectionId2).click()
              $("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).prop("disabled", true);
            }
            else {
              console.log($("#plancheck" + element.planSelectionId2))
              $("#plancheck" + element.planSelectionId2).click()
              $("#plancheck" + element.planSelectionId2).prop("disabled", true);

            }
          }



        });
      }, 1000);

      this.selectedPlans_ = [];
      this.oldExistingPlans = []
      this.selectedTrues = []
      this.unSelectedPlans_ = []
      this.totalSummaryPrice = 0;

      for (let package_ of data__) {
        console.log(package_, 'asdaas2');

        let groupKeys_ = Object.keys(package_.groups);
        for (let i = 0; i < groupKeys_.length; i++) {
          let groups = groupKeys_[i];

          for (let j = 0; j < package_.groups[groups].length; j++) {
            let group = package_.groups[groups][j];

            for (let k = 0; k < group.plans.length; k++) {
              let plan = group.plans[k];
              let pan = plan.productAddonssNames;
              console.log(plan.isBundle, "bundled")

              for (let product of pan) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product];

                  const selectedAddons = paon.filter((item: any) => item.selected);



                  if (selectedAddons && selectedAddons.length > 0) {
                    const unSelectedAddon = paon.find((item: any) => !item.selected);

                    console.log(unSelectedAddon)
                    if (!!unSelectedAddon && plan.selected) {
                      this.upgradeorDowngradeplans.push({
                        'name': unSelectedAddon?.name,
                        'addon': unSelectedAddon,
                        'isBundle': plan.isBundle
                      })
                    }
                    if (!unSelectedAddon && plan.selected) {
                      for (const selectedAddon of selectedAddons) {
                        const customerPlan = this.customerPlans.find((item: any) => (item.planId == selectedAddon.planId && (item.terminationDate == null || item.terminationDate == "")))
                        console.log(customerPlan, selectedAddon)
                        if (customerPlan.coverage1.toUpperCase() == selectedAddon.planCoverage) {
                          this.upgradeorDowngradeplans.push({
                            'name': selectedAddon?.name,
                            'addon': selectedAddon,
                            'isBundle': plan.isBundle
                          })
                        }
                      }
                    }
                    if (plan.selected) {
                      //check for the termination date
                      for (const selectedAddon of selectedAddons) {
                        this.upgradeorDowngradeplansSelected.push({
                          'name': selectedAddon?.name,
                          'addon': selectedAddon,
                          'isBundle': plan.isBundle
                        })

                      }
                    }
                  }
                  // Loop over the addonss for the plan
                  for (const paon_ of paon) {
                    console.log(paon_, '12345');

                    if (paon_.selected === true) {
                      // We can call the onCheckboxChange



                      this.selectedTrues.push({
                        id: paon_.id,
                        productId: paon_.productId,
                        planId: paon_.planId
                      });

                      paon_['checked'] = true;  // Mark the plan as checked
                      this.totalSummaryPrice += paon_.calculatedTax.total;
                      this.selectedPlans_.push(paon_);
                      this.oldExistingPlans.push(paon_);
                    } else {
                      this.unSelectedPlans_.push(paon_);
                    }
                  }
                }
              }
            }
          }
        }






        console.log(this.selectedPlans_, 'asd2342');
        console.log(this.unSelectedPlans_, 'asd23421');
        this.getPlanSummaryObject();
      }


      console.log('selectedTrues', this.selectedTrues)


      this.specialpackages = data__ ?? []


      //get the selected coverages



    }

    if (response.status == 200 && this.isCorporateAccount) {
      this.coverageChange = response?.data?.coverageChange;
      sessionStorage.setItem(
        "customerTierId",
        response.data.customer.customerTierId
      );
      sessionStorage.setItem("employeeshare", "0");
      this.mainarray = [];
      this.mainarrayValues = [];
      this.mainarrayFinal = [];
      this.modifiedBlocksPaidByCompany = '',
        this.modifiedBlocksCoveredByCompany = '',

        sessionStorage.setItem("planDetailsArrayBlock", "[]");
      this.effectiveEmployeeTotalContibution = 0;
      sessionStorage.setItem("totalAmount", "0");
      sessionStorage.setItem("totalAmountUI", "0");

      sessionStorage.setItem("allSelectedPlans", "[]");

      sessionStorage.setItem("plansummary", "[]");
      sessionStorage.setItem("selectedPlans", "{}");
      sessionStorage.setItem("selectedPlansLife", "{}");
      sessionStorage.setItem("plansummarymain", "[]");
      sessionStorage.setItem("plansummaryopt", "[]");
      sessionStorage.removeItem("Spousesignature")

      this.addbenificaryData = []


      this.allFormData = {}
      this.formData = {}
      sessionStorage.setItem('plansummaryLife', '[]');
      sessionStorage.setItem('planssummarymainLife', '[]');







      setTimeout(() => {




        setTimeout(() => {

          const coverageMap: { [key: string]: string } = {
            STC: 'COUPLE',
            STF: 'FAMILY',
            CTF: 'FAMILY',
            CTS: 'SINGLE',
            FTS: 'SINGLE',
            FTC: 'COUPLE',
            F: 'FAMILY'
          };

          let targetCoverage = coverageMap[this.coverageChange];




          this.customerSelectedPlans.forEach(element => {
            const dom: HTMLElement = this.elementRef.nativeElement;


            console.log(element, "jiihhsh")
            if (element.isBundle) {


              let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
              let clicked = false;
              console.log(targetCoverage, "targetCoverage9998")
              console.log($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()))
              console.log($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length)
              if ($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length == 0) {
                for (const cov of coverages) {
                  const selector = "#plancheck" + element.planId + ".coverage" + cov.toUpperCase();
                  if ($(selector).length > 0 && !clicked) {
                    $(selector).click();
                    $(selector).prop("disabled", true);
                    clicked = true;
                  }
                }
              } else {
                const selector = "#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase();
                console.log($(selector))
                $(selector).click();
                $(selector).prop("disabled", true);
              }


            }
            else {
              console.log(targetCoverage, "after else")
              if (targetCoverage && targetCoverage != '-') {

                console.log("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase())
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).prop("disabled", true);
              }
              else {
                console.log($("#plancheck" + element.planSelectionId2))
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planSelectionId2).prop("disabled", true);

              }
            }



          });







        }, 6000);


        this.autoSelectCompanyPaidPlans();



        sessionStorage.setItem(
          "enrollmentdate",
          response.data.planEnrollmentDate
        );

      }, 1000);

      ///here
      sessionStorage.removeItem("paymentfail");
      this.companypaidproductid = [];
      this.disabledcompanypaidproductid = [];
      this.removedisabledcompanypaidproductid = [];
      this.adddisabledcompanypaidproductid = [];



      console.log(response)
      this.specialpackages = [];
      this.packagesInBlocks = response.data.blocks;
      this.basepackages = response.data.packages;
      this.customerSelectedPlans = response.data.customerPlans



      let companyplans = this.convertpackagesToPlans2(
        this.packagesInBlocks
      )[1];
      let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
      this.calculateBasePlanDeltasforCCplans(
        this.packagesInBlocks.coveredByCompany,
        baseplans,
        companyplans
      );
      this.calculateBasePlanCPplans(
        this.packagesInBlocks.paidByCompany,
        baseplans,
        companyplans
      );

      // //console.log(this.packagesInBlocks.paidByCompany)
      // //console.log(this.modifiedBlocksPaidByCompany)
      this.mainarrayValues = this.cobminedcommonfunction(
        this.modifiedBlocksPaidByCompany,
        this.modifiedBlocksCoveredByCompany,
        this.packagesInBlocks.paidByEmployee
      );

      let allPackages: any = [];
      for (let key in this.mainarrayValues) {
        allPackages.push(this.mainarrayValues[key]);
      }

      console.log(allPackages)





      let filteredMainArray = allPackages
        .map((element: any) => {
          // Map the groups
          let filteredGroups = element.groups.map((group: any) => {
            // Map the plans
            let filteredPlans = group.plans.map((plan: any) => {
              // Filter the productAddonss


              let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                (acc: any, key) => {

                  const containsOnlyEmptyObjects = plan.productAddonss[key].every(
                    (product: any) => Object.keys(product).length === 0
                  );

                  if (containsOnlyEmptyObjects) {
                    console.log("filteredProducts contains only empty objects.");
                  } else {
                    acc[key] = plan.productAddonss[key];
                    console.log("filteredProducts contains non-empty objects.");
                  }
                  return acc;
                },
                {}
              );
              return {
                ...plan,
                productAddonss: filteredProductAddonss,
              };
            }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

            return {
              ...group,
              plans: filteredPlans,
            };
          }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

          return {
            ...element,
            groups: filteredGroups,
          };
        })
        .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


      console.log(filteredMainArray)

      this.mainarrayFinal = filteredMainArray

      console.log(this.mainarrayFinal)

      // this code needs to comment for single single in
      this.mainarrayFinal.forEach((element: any) => {
        element.groups.forEach((group: any) => {
          group.plans.forEach((plan: any) => {
            if (plan.productAddonss) {
              Object.keys(plan.productAddonss).forEach((key) => {
                const keys = ['planCoverage'];
                const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                  self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                );
                plan.productAddonss[key] = filteredData
              });
            }
          });

        });
      });

      this.mainarrayFinal.forEach((element: any) => {
        element.groups.forEach((group: any) => {
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: any) => {
              let pl = { ...plan, ...group.categorization }
              Object.keys(plan.productAddonss).forEach((key) => {
                let productLength = plan.productAddonss[key]?.display
                let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length

                plan.productAddonss[key].forEach((product: any) => {

                  if (pl.isBundle) {
                    this.companypaidproductid.push(pl);
                  }
                  else {
                    this.companypaidproductid.push(product.planlevel);
                  }


                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                });
              });
            });
          }

          setTimeout(() => {
            if (group.categorization.coveredByCompany == 1) {
              group.plans.forEach((plan: any) => {
                Object.keys(plan.productAddonss).forEach((key) => {
                  plan.productAddonss[key].forEach((product: any) => {
                    const dom: HTMLElement = this.elementRef.nativeElement;

                    const plan: any = dom.querySelector("#plancheck" + product.id);

                    if (plan) {
                      plan.checked = false;
                    }
                  });
                });
              });
            }
            if (group.categorization.paidByEmployee == 1) {
              group.plans.forEach((plan: any) => {

                if (plan.productAddonss) {
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      const dom: HTMLElement = this.elementRef.nativeElement;

                      const plan: any = dom.querySelector("#plancheck" + product.id);

                      if (plan) {
                        plan.checked = false;
                      }
                    });
                  });
                }
              });
            }
          }, 1000);




        });
      });

      console.log(this.mainarrayFinal)
      this.mainarrayFinal.forEach((element: any) => {
        let coveragerray: any = []
        element.groups.forEach((group: any) => {

          group.plans.forEach((plan: any) => {
            let pl = { ...plan, ...group.categorization }
            Object.keys(plan.productAddonss).forEach((key) => {

              plan.productAddonss[key].forEach((product: any) => {
                coveragerray.push(product.planCoverage)

                if (pl.isBundle) {

                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + pl.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + pl.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + pl.id);
                    // //console.log(plan)


                    if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("COUPLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("COUPLE")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("COUPLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (product.planCoverage === "SINGLE") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (product.planCoverage === "COUPLE") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (product.planCoverage === "FAMILY") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    } else {
                      // Default case - hide all plans if coverage doesn't match expected
                    }



                  }, 1000);

                }
                else {
                }


              });
            });
          });







        });
      });

      this.planAmount = ''

      sessionStorage.setItem("stateid", response.data.province.id);


      sessionStorage.setItem(
        "planDetailsArray",
        JSON.stringify(this.specialpackages)
      );
      sessionStorage.setItem(
        "planDetailsArrayBlock",
        JSON.stringify(this.mainarrayFinal)
      );
      console.log("called88888")



    }
    else {
    }

    if (this.specialpackages && this.specialpackages.length > 0) {
      let filteredPackages_: any = [];
      console.log("called")
      //filter the repeated packages for medcan care
      for (let package_ of this.specialpackages) {
        console.log(package_, 'asdaas2')
        let groupKeys_ = Object.keys(package_.groups);
        for (let groups of groupKeys_) {
          for (let group of package_.groups[groups]) {
            for (let plan of group.plans) {
              let pan = plan.productAddonssNames
              for (let product of plan.productAddonssNames) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product]
                  for (const paon_ of paon) {
                    if (paon_.selected == true) {
                      this.selectedPlans_.push(paon_);
                    }
                  }
                }
              }

            }
          }
        }
        console.log(this.selectedPlans_, 'asd2342')
        if (package_.id == 5) {
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {

                  // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                  if (filteredPackages_[product]) {
                    if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                      let index = pan.indexOf(product);
                      if (index !== -1) {
                        pan.splice(index, 1);
                      }
                    }
                  } else {
                    filteredPackages_[product] = { 'planProductIds': [] }
                    filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                  }

                  console.log(plan.productAddonss, product);

                }

                plan.productAddonssNames = pan;
              }
            }
          }
        }
      }

    }
  }


  public autoSelectCompanyPaidPlans() {
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);


    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;

        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    console.log("disabled click")
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    console.log("click")
                    console.log(elementSelector)
                    console.log($(elementSelector).length)
                    setTimeout(function () {
                      $(elementSelector).click();
                    }, 1000);
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }

              }

            }

          }
        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }
      }, 100);

    });

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";


      console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

      }, 100);
    });
  }
  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;


        modifiedCPgroup.plans = [];
        let baseplans: any = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
          let selectedCPplanProductarray: any
          if (CPplan.isBundle == true) {
            selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
          } else {
            selectedCPplanProductarray = Object.keys(CPplan.productAddonss)
          }

          console.log(selectedCPplanProductarray)


          /* this is filtering other products which are not to be displayed */
          selectedCPplanProductarray = selectedCPplanProductarray.filter((prop: any) => prop.display)



          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans




            let selectedBasePlan: any;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

              }
              else {

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method

              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }
              else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)



              if (selectedBaseplanProduct.name == 'NA') {
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0;
                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };



              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
            }

          }
          else {

            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                let products = selectedBasePlan.productAddonss[planname];
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                } else {
                }
              }
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
              } else {
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              if (selectedBaseplanProduct.name == 'NA') {
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

    }
  }
  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        pckg.groups = pckg.groupsCC;


        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }

  cancelDeletion() {
    this.deleteForm.reset();
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.closeDependentmodal.nativeElement.click(); // Close the modal
    this.needToUpdate = ''
    this.cobevent = ''
    this.cobeventType = ''
    this.dependentType = ''
    this.maritalStatus = ''
    this.selectedDepId = ""
    this.needToUpdate = false;
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.deleteForm.reset()
    this.spouseform.reset()
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.addToPolicy = ''
    this.secondMessage = ''
    this.dependentform.reset()
    this.cobform.reset()
  }


  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            const coverages = ['SINGLE', 'COUPLE', 'FAMILY'];

            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }
  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    let modifiedCCplanPackages: any = [];
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"


        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        let CCplans = CCplangroup.plans;

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {

            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });


            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];



            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            if (selectedBasePlan) {
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2: any = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            if (selectedCompnayPlan) {
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2: any = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

              }
              else {

                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)




              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );



              if (selectedBaseplanProduct.name == 'NA') {
                companyTax = 0  ////when there is no base planproduct
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };


              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });


            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    if (selectedBaseplanProduct.name == 'NA') {
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );



      if (selectedBaseplanProduct.name == 'NA') {
        companyTax = 0  ////when there is no base planproduct
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };


      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

    }

    return modifiedCCplan
  }

  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {


        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }

    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
      }
      if (!productCoverageFound) {

        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);

      }

    }

    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
      }
      if (!productCoverageFound) {
        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);
      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;

      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public handleGenerateNotes(plansData: any = [], approvalStatus: any, event: any, eventType: any, marriedDate: any) {
    let notesObj = {
      plans: plansData, // old plans and new plans data
      status: approvalStatus, // will be the approval stauts
      event: event,
      eventType: eventType,
      marriedDate: marriedDate
    }

    return notesObj;
  }


  public handleShowText(product: any, coverage: any) {
    if (coverage == 'STC') {
      this.coverageChangeText = 'Plan coverage will change from SINGLE to COUPLE'
    }
    if (coverage == 'CTS') {
      this.coverageChangeText = 'Plan coverage will change from COUPLE to SINGLE'
    }
    this.priceChangeText = `old price - $${product.oldPrice} | new price - $${product.newPrice} | change in amount - ${product.newPrice - product.oldPrice < 0 ? '- $' + Math.abs(product.newPrice - product.oldPrice) : '$' + (product.newPrice - product.oldPrice)}`
    return this.coverageChangeText + '\n' + this.priceChangeText;
  }





  public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called109", coverage, this.initialCoverage, this.notInitialLoad, this.initialData, this.cobeventType)
    if (coverage.toLowerCase() == this.initialCoverage.toLowerCase()) {
      this.clearAllMessages()
      if (this.enactMode == "add") {
        this.addToPolicy = 'close';
        this.isNeedToUpdate = false;
        this.showPlanDetails = false;
        this.isDirectUpdate = true;
        this.firstMessage = `No need to update the coverage, as it is already included under the current plan.`
      }
    }
    setTimeout(() => {
      if (this.enactMode == "add") {
        if (this.notInitialLoad && coverage.toLowerCase() != this.initialCoverage.toLowerCase()) {
          let allData: any = JSON.parse(JSON.stringify(this.initialData));
          let oldCov = this.currentCoverage(allData.data.coverageChange)
          let newCov = coverage;
          console.log(oldCov, newCov)
          let newCovGenerated = this.coverageGenerator(oldCov.toLowerCase(), newCov.toLowerCase());

          let oldCov2 = this.currentCoverage(allData.data.coverageChange2)
          let newCov2 = coverage;
          let newCovGenerated2 = this.coverageGenerator(oldCov2.toLowerCase(), newCov2.toLowerCase());
          console.log(newCovGenerated, newCovGenerated2)
          allData.data.coverageChange = newCovGenerated
          allData.data.coverageChange2 = newCovGenerated2
          this.coverageChange = newCovGenerated
          console.log(allData)
          this.initialData = allData;

          this.handleUpdateCoverageForCob(this.finalEffectiveDate, this.addToPolicy, this.cobevent, this.cobeventType, this.initialData)
        }
      }
    }, 1000);

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId
      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;

        if (element.checked) {
          element.checked = false;
          this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);

        }
      }
      e.target.checked = true
      e.target.disabled = true
    } else {
    }

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  }


                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }

            }
          }
        }
      }
    }

    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)

    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);



    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      }
    }, 10);
  }



  public coverageGenerator(oldCov: any, newCov: any) {
    let coverage: any = 'STC';
    if (oldCov == 'single' && newCov == 'couple') {
      coverage = 'STC'
    }
    if (oldCov == 'single' && newCov == 'family') {
      coverage = 'STF'
    }
    if (oldCov == 'couple' && newCov == 'family') {
      coverage = 'CTF'
    }
    if (oldCov == 'couple' && newCov == 'single') {
      coverage = 'CTS'
    }
    if (oldCov == 'family' && newCov == 'couple') {
      coverage = 'FTC'
    }
    if (oldCov == 'family' && newCov == 'single') {
      coverage = 'FTS'
    }

    return coverage;
  }


  public onCheckboxChange_v3(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called1", e)

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId

      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;

        if (element.checked) {
          element.checked = false;
          this.unselectplan_v3(elem);

        }
      }
      e.target.checked = true
      e.target.disabled = true
    }

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan_v3(elem);
                  }

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan_v3(elem);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan_v3(elem);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan_v3(elem);
                }
              }

            }
          }
        }
      }
    }

    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)

    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);



    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan_v3(elem)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan_v3(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan_v3(e.target);
      }
    }, 10);
  }

  public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(options)

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? toLegacyUsDate(
          this.dependentTypeForm.get('effectiveDate')?.value
        )
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    this._LoaderService.show()
    this.addtoplansummary(obj, obj1);
    setTimeout(() => {




    }, 1000);

  }


  public selectplan_v3(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(options)

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? toLegacyUsDate(
          this.dependentTypeForm.get('effectiveDate')?.value
        )
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);

    this.addtoplansummary_v3(obj, obj1);
    setTimeout(() => {




    }, 1000);

  }





  public addtoplansummary_v3(obj: any, obj1: any) {
    console.log("summary3 called", obj, obj1)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');


    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');


    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));

    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {

          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck2792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
              }, 1000);
            }
            break;
          }
          else {

            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck2792" + ".coverage" + obj.coverage);

            console.log(plan)
            setTimeout(() => {
              plan.click()
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }


      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }

    }, 100);
  }


  public addtoplansummary(obj: any, obj1: any) {
    this._LoaderService.show()
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');


    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));

    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {
          console.log(this.planssummarymain[i].planLevel, "assssiiiooo")
          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              console.log(dom.querySelector("#plancheck792" + ".coverage" + obj.coverage), "iiiooooouu")
              $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()).click()
            }
            break;
          }
          else {

            console.log(obj.coverage, "ioasaddahhdh", $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()))
            setTimeout(() => {
              $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()).click()
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }


      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }



      this.showPlanDetails = false;
      this.showAfterPlanDetails = true;
      this._LoaderService.hide()
      // here we can call the select plans one sudeep
    }, 100);
  }








  public capitalizeFirstLetter(str: string): string {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    return ''; // Return an empty string if the input is falsy (null, undefined, or empty)
  }

  public addtosum(amount: any) {


    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount')?.replace(/,/g, '') ?? '0'
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');
    return selectedPlansAmount;
  }


  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }


  public removeslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeremoveplans")
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );

    ////this.consoleMessage(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      ////this.consoleMessage(planid)
      ////this.consoleMessage(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    ////this.consoleMessage("adjustedselectedPlans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }



  public getslectedplans(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }








  public unselectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {
    console.log(elementcv, "unselected")


    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? toLegacyUsDate(this.dependentTypeForm.get('effectiveDate')?.value)
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);

    this.handleDisableCheckAndUnCheck(true, false, obj)
    this.removeplansummary(obj);
    setTimeout(() => {



    }, 1000);
  }


  public handleDisableCheckAndUnCheck_v2(unchecked: any, checked: any, obj: any) {
    console.log(obj)

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }


    if (planSummary && planSummary.length > 0) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      console.log(index)
      console.log(planSummary)

      if (index > -1) {
        let element = planSummary[index];
        if (element.isBundle) {

          $("#plancheck2" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          console.log($("#2" + element.id + ".coverage" + element.coverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element?.coverage, "after else")
          if (element?.coverage) {

            $("#plancheck2" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          }
          else {
            // check here once
            $("#plancheck2" + element.id).prop("disabled", false);

          }
        }

      } else {
        return;
      }
    }

  }

  public handleDisableCheckAndUnCheck(unchecked: any, checked: any, obj: any) {
    console.log(obj)

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }


    if (planSummary && planSummary.length > 0) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      console.log(index)
      console.log(planSummary)

      if (index > -1) {
        let element = planSummary[index];
        if (element.isBundle) {

          $("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          console.log($("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element?.coverage, "after else")
          if (element?.coverage) {

            $("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          }
          else {
            // check here once
            $("#plancheck" + element.id).prop("disabled", false);

          }
        }

      } else {
        return;
      }
    }

  }

  public unselectplan_v3(elementcv: any) {


    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      enrollmentDate: this.dependentTypeForm.get('effectiveDate')?.value
        ? toLegacyUsDate(this.dependentTypeForm.get('effectiveDate')?.value)
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }
    this.handleDisableCheckAndUnCheck_v2(true, false, obj)
    this.removeplansummary_v3(obj);
    setTimeout(() => {




    }, 1000);
  }


  public removeplansummary(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    console.log(obj);


    this.getPlanSummaryObject()
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        planSummary.splice(index, 1);

      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      console.log("setting here2");

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;

      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
  }

  public removeplansummary_v3(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    console.log(obj);


    this.getPlanSummaryObject()
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        planSummary.splice(index, 1);

      } else {
        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      console.log("setting here2");

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck2${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
  }

  public isGroupsNotEmpty(groups: any): boolean {
    if (Object.keys(groups).length > 0) {
      Object.keys(groups).forEach(element => {

        if (groups[element].length > 0) {
          groups[element].map(ele => {

            if (ele.plans?.length > 0) {
              this.displayPackage = true;
              return this.displayPackage
            }
          });
        }
      })
    }

    return this.displayPackage
  }




  public onCheckboxChangeCorporate(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any
  ) {
    console.log(plan, "plan889")
    let multiple = allow_multiple == true ? true : false;


    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)



      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      let targetClassName = 'cp_plan'
      if (e.target.className.includes('cp_plan')) {
        targetClassName = 'cp_plan'
      }
      else if (e.target.className.includes('cc_plan')) {
        targetClassName = 'cc_plan'
      }
      else if (e.target.className.includes('ep_plan')) {
        targetClassName = 'ep_plan'
      }

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;


        if (element.checked && element.className.includes(targetClassName)) {
          element.checked = false;
          element.disabled = false;  //need to change here for flex bronze disabled
          this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);

        }
      }
      e.target.checked = true

    } else {

    }



    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(",");
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );


      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {
          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

          }


          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }

            }
          }
        }


      }
    }





    //////this.consoleMessage(e)
    // //console.log(`newPlan${plan.id}`)

    let sameplanclassname = `newPlan${plan.id}`
    // //console.log(e.target.className)/////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '');
    // //console.log(classname)
    classname = e.target.className.split(' ').join('.');
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(classname);

    const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);
    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {
            this.unselectplanCorp(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {

      }
    } else {
    }
    setTimeout(() => {
      if (e.target.checked) {

        console.log(group)
        console.log(pckage)

        let removedisabledcompanypaidproductid: any = []
        let removedisabledcoveredpaidproductid: any = []
        let removedisabledemployedpaidproductid: any = []
        if (
          group.categorization.coveredByCompany == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcompanypaidproductid.push(
                          pl
                        );
                      }
                      else {
                        removedisabledcompanypaidproductid.push(

                          product.planLevel,

                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcompanypaidproductid.push(
                            pl
                          );
                        }
                        else {
                          removedisabledcompanypaidproductid.push(

                            product.planLevel,

                          );
                        }

                      });
                    });
                  });
                }
              }
            }

          });
        } else {
        }

        if (
          group.categorization.paidByCompany == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcoveredpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledcoveredpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcoveredpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledcoveredpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        if (
          group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {

              if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledemployedpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledemployedpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {


              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledemployedpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledemployedpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        console.log(removedisabledcompanypaidproductid)
        console.log(removedisabledcoveredpaidproductid)
        console.log(removedisabledemployedpaidproductid)

        removedisabledcompanypaidproductid = removedisabledcompanypaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcoveredpaidproductid = removedisabledcoveredpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledemployedpaidproductid = removedisabledemployedpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcompanypaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;

            let planId: any;

            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)
                  planId = product.planId
                  plan.forEach((element: any) => {
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })

            }
            else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              plan.disabled = false;
              planId = element.id
              plan.forEach((element: any) => {
                element.disabled = false;
                element.checked = false
              });
            }






            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {

              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                    /* //console.log(plan) */

                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);


              if (elem.isBundle) {

                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {


                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();

          }, 1000);
        });
        removedisabledcoveredpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let plan: any = ''
            let planId: any;


            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)

                  planId = product.planId
                  plan.forEach((element: any) => {
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              planId = element.id
              plan.forEach((element: any) => {
                element.disabled = false;
                element.checked = false
              });
            }



            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });
        removedisabledemployedpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;

            let plan: any = ''

            let planId: any;
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)

                  planId = product.planId
                  plan.forEach((element: any) => {
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              planId = element.id
              plan.forEach((element: any) => {
                element.disabled = false;
                element.checked = false
              });
            }



            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)

                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)

                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });

        console.log(plan, 'plannn', product)

        this.selectplanCorp(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      } else {


        this.unselectplanCorp(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      }
    }, 10);
  }



  public selectplanCorp(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {

    this.planobjdata1 = {};
    this.planobjdataobj = {}

    console.log(disallowedPlanLevels)

    let details: any = elementcv.attributes.data.value;

    let detailsObj: any = details.split("##");


    let categorization = {}

    if (group.categorization.paidByCompany == 1) {

      categorization = {
        paidByCompany: detailsObj[22] == "true" ? 0 : 1,
        coveredByCompany: detailsObj[22] == "true" ? 1 : 0,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    } else {
      categorization = {
        paidByCompany: group.categorization.paidByCompany,
        coveredByCompany: group.categorization.coveredByCompany,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    }


    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    let obj = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: '',
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI: "$" + parseFloat(product.calculatedTax.price),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,

      planProductId: product.planProductId,

      price: adjustWith2DecimalsForUI(product.price1 || product.price),
      tax: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.tax : 0
      ),
      total: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.total : 0
      ),

      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel
        ? product.planlevel.id
        : plan.planLevel
          ? plan.planLevel
          : group.id,
      planLevelParent: product.planlevel
        ? product.planlevel.parentId
        : group.parentId,
      description: product.description,
      coverage: coverage,
      version: product.version
    };
    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
      upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    };

    obj1.products.push(this.productobj);
    let finalobj1: any = { ...obj1, ...categorization };



    this.addtoplansummaryCorp(obj, finalobj1, elementcv);

    setTimeout(() => {


      this.openplanoptionsCorp(elementcv)



    }, 1000);
  }

  public unselectplanCorp(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {


    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      isBundle: plan.isBundle,
      enrollmentDate: '',
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      disallowedPlanLevels: plandetailsobj[11],
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryCorp(obj, group, pckage, elementcv);
    setTimeout(() => {


      this.openplanoptionsCorp(elementcv)


    }, 1000);
  }

  public addtoplansummaryCorp(obj: any, obj1: any, e: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");

    console.log(obj)
    console.log(obj1)

    /* This code mainly for flex plan silver and gold */


    for (let i = 0; i < planSummary.length; i++) {
      if (obj1.planLevelParent) {
        if (planSummary[i].planLevelParent == obj1.planLevelParent && planSummary[i].coveredByCompany == obj1.coveredByCompany) {

          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("#plancheck" + planSummary[i].id + ".coverage" + planSummary[i].coverage);
          if (plan.checked) {
            plan.checked = false
          }
          planSummary.splice(i, 1)
        }
      }
    }




    let planId;
    if (obj.isBundle == true) {
      planId = obj.id
    } else {
      planId = obj1.products[0].planLevel
    }

    console.log(planId)
    setTimeout(() => {
      console.log(planId)
      const dom: HTMLElement = this.elementRef.nativeElement;


      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
      // //console.log(plan)

      if (obj.coverage === "SINGLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "COUPLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "FAMILY") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
      } else {
        // Default case - hide all plans if coverage doesn't match expected
      }



    }, 2000);

    this.addtoslectplansCorp(obj.id, planSummary.length);
    //check if already obj.id exists in planSummary
    let getExistingObj: any = planSummary.find((item: any) => item.id == obj.id);
    if (getExistingObj) {
      console.log("object already exists")
    } else {
      planSummary.push(obj);
    }

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.options && obj.options.length > 0) {
      obj["disallowedPlanLevels"] = obj1.disallowedPlanLevels

    }

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;

      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(hstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;


      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    obj['tax'] = obj1.products[0]
      ? this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2") : 0;
    obj['tax'] = parseFloat(obj['tax']);
    // obj["products"] =obj1

    obj["coverage"] = obj1.coverage;
    obj["planCoverage"] = obj1.planCoverage;
    obj["planLevelParent"] = obj1.planLevelParent;
    obj["planproductname"] = obj1.planproductname;

    obj["products"] = obj1.products;
    obj["upgradeCalculation"] = obj1.upgradeCalculation;
    obj["paidByCompany"] = obj1.paidByCompany;
    obj["coveredByCompany"] = obj1.coveredByCompany;
    obj["paidByEmployee"] = obj1.paidByEmployee;



    let pricecal = obj1.products[0].calculatedTax.total;
    obj["totalPrice"] = pricecal;

    obj["totalUI"] = "$" + pricecal;

    (obj["total"] = pricecal),
      (obj["skuTotalPrice"] = parseFloat(
        obj1.products.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.total;
        }, 0)
      ));

    let updatedSum = this.addtosum(obj.skuTotalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem("plansskumain", JSON.stringify(this.plansskumain));

    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary", JSON.stringify(planSummary));

    this.planCoverafeFunction();


    if (planSummary.length > 0) {
    } else {
    }

    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }
    setTimeout(() => {
      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      this.companypaidproductid = this.companypaidproductid.filter(
        (item: any) => item !== undefined && item !== null
      );

      var result = this.companypaidproductid.reduce((unique: any, o: any) => {
        if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log(result);
      const filteredPlans = result.filter((result: any) => result.planLevel === 18);

      console.log(filteredPlans);


      if (filteredPlans.length > 0) {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
              }, 1000);
            }



          }
        }
      }

      else {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                }, 1000);
              }
              break;
            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
              }, 1000);
            }
            break;
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.planAmount = parseFloat(total.toString());
      sessionStorage.setItem("totalAmount", this.planAmount);
    }, 100);

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";



      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);

          const samePlanIdElements = dom.querySelectorAll('#' + e.id);
          let targetClassName = 'cp_plan'
          if (e.className.includes('cp_plan')) {
            targetClassName = 'cp_plan'
          }
          else if (e.className.includes('cc_plan')) {
            targetClassName = 'cc_plan'
          }
          else if (e.className.includes('ep_plan')) {
            targetClassName = 'ep_plan'
          }

          for (let i = 0; i < samePlanIdElements.length; i++) {
            let elem = samePlanIdElements[i];
            let element: any = elem;
            // //console.log(elem)
            // //console.log(elem.className.includes('cp_plan'))
            if (elem.className.includes('cp_plan')) {
              element.disabled = false;
              if (element.checked) {
                element.disabled = true;

              }
            }
          }
          if (plan) {

          }
        }
      });
    }, 1000);

  }

  public getindexofplanCorp(obj: any) {

    let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    for (let i = 0; i < plansproductarray.length; i++) {
      if (obj.isBundle == false) {
        if (plansproductarray[i].id == obj.id) {

          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
              }
            })

          }
          return i;
        }
      } else {
        if (plansproductarray[i].id == obj.id) {
          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                plan.disabled = false;
              }
            })

          }
          return i;
        }
      }
    }
  }
  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }

  public removeplansummaryCorp(obj: any, group: any, pckage: any, e: any) {

    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {

      let index: any = this.getindexofplanCorp(obj);
      if (index > -1) {
        planSummary.splice(index, 1);
      } else {

        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;


        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;




        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(hstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);

      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;


        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);




      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // ////this.consoleMessage(object["taxUI"])



      obj['tax'] = gstprice + hstprice + pstprice + qstprice
        ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
        : 0;
      obj['tax'] = parseFloat(obj['tax']);
      (obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj["totalUI"] =
          "$" +
          parseFloat(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice
          ));

      obj["total"] = parseFloat(
        obj.planPrice + gstprice + hstprice + pstprice + qstprice
      );

      let updatedSum = this.removetosumCorp(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem("plansummary", JSON.stringify(planSummary));
      if (planSummary.length > 0) {
      } else {
      }


      this.planCoverafeFunction();


      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }





      setTimeout(() => {
        let selectplans =
          JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";


        let adddisabledcompanypaidproductid: any = []

        if (
          group.categorization.coveredByCompany == 1
          ||
          group.categorization.paidByEmployee == 1
        ) {
          pckage.groups.forEach((element: any) => {
            if (element.categorization.paidByCompany == 1) {
              if (group?.parentId == element?.parentId) {
                element.plans.forEach((plan: any) => {

                  let pl = { ...plan, ...element.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        adddisabledcompanypaidproductid.push(
                          pl,
                        );
                      } else {
                        adddisabledcompanypaidproductid.push(product.planlevel);
                      }

                    });
                  });
                });
              }
            }
          });



          adddisabledcompanypaidproductid = adddisabledcompanypaidproductid.filter(
            (item: any) => item !== undefined && item !== null
          );
          console.log(adddisabledcompanypaidproductid);

          for (let i = 0; i < adddisabledcompanypaidproductid.length; i++) {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let selectPlanCheck;
            if (obj?.isBundle == true) {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId && el.planLevelParent == adddisabledcompanypaidproductid[i].planLevel_parentId;
              })
            }
            else {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId;
              })



              let planData: any = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
              let targetClassName = 'cp_plan'
              if (e.className.includes('cp_plan')) {
                targetClassName = 'cp_plan'
              }
              else if (e.className.includes('cc_plan')) {
                targetClassName = 'cc_plan'
              }
              else if (e.className.includes('ep_plan')) {
                targetClassName = 'ep_plan'
              }

              for (let i = 0; i < planData.length; i++) {
                console.log(planData[i])
                if (planData[i].className.includes('cp_plan')) {
                  planData[i].click()
                  return false;

                }
              }


            }

            if (selectPlanCheck) {

              selectplans.forEach((products: any) => {

                if (products.packageId == adddisabledcompanypaidproductid[i].packageId) {

                  products.products.forEach((prod: any) => {
                    if (prod.planLevel == adddisabledcompanypaidproductid[i].id) {
                    } else {
                    }
                  });
                } else {
                  // //this.consoleMessage("CheckHere1")

                }
              });
            } else {


              const dom: HTMLElement = this.elementRef.nativeElement;

              let coverage = adddisabledcompanypaidproductid[i].companyPaidCoverage?.replace("SELECTIVE_", "")

              let planData;
              if (coverage && coverage != "DIRECT") {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id + ".coverage" + coverage)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    element.click()
                  }
                });
                break;
              }
              else {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    element.click()
                  }
                });
              }


            }
          }
        }




        setTimeout(() => {
          let selectplans =
            JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

          selectplans.forEach((products: any) => {
            if (products.paidByCompany == 1) {
              products.products.forEach((element: any) => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);


                if (plan) {

                }


                const samePlanIdElements = dom.querySelectorAll('#' + e.id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                for (let i = 0; i < samePlanIdElements.length; i++) {
                  let elem = samePlanIdElements[i];
                  let element: any = elem;
                  if (elem.className.includes('cp_plan')) {
                    element.disabled = false;
                    if (element.checked) {
                      element.disabled = true;

                    }
                  }

                }
              });
            }
          });
        }, 1000);
      }, 100);



      setTimeout(() => {
        let selectplansInfo =
          JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";


        console.log(obj)

        if (selectplansInfo.length > 0) {
          for (let i = 0; i < selectplansInfo.length; i++) {


            let planId;
            if (selectplansInfo[i].isBundle == true) {
              planId = selectplansInfo[i].id
            } else {
              planId = selectplansInfo[i].products[0].planLevel
            }
            if (selectplansInfo[i].id == obj.id) {

            }

            else {
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + planId);
                const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + planId);
                const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + planId);
                /*  //console.log(plan) */


                plan.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });

                plan2.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });
                plan3.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });



              }, 1000);
            }
          }



        }
        else {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
            const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
            const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
            /*  //console.log(plan) */


            plan.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });

            plan2.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });
            plan3.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });



          }, 1000);
        }
      }, 1000);

      setTimeout(() => {
        let selectplansInfo = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";
        if (selectplansInfo.length === 0) {
          if (obj.groupName != "Complete Executive Care") {
            this.autoSelectCompanyPaidPlans()
          }


        }
      }, 1000);
    }
  }

  public addtoslectplansCorp(planid: number, plansumamryindex: number) {

    let selectedPlans = JSON.parse(
      sessionStorage.getItem("selectedPlans") || "{}"
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }

  public removetosumCorp(amount: number) {

    let selectedPlansAmount: any = parseFloat(sessionStorage.getItem("totalAmount") || '0')
    selectedPlansAmount = selectedPlansAmount - amount;
    let finaltotalAmount: any = this._decimalPipe.transform(selectedPlansAmount, "1.2-2")?.replace(/,/g, "")
    sessionStorage.setItem(
      "totalAmount", finaltotalAmount)
    sessionStorage.setItem(
      "totalAmountUI",
      "$" +
      this._decimalPipe
        .transform(selectedPlansAmount, "1.2-2")
        ?.replace(/,/g, "")
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, "1.2-2")
      ?.replace(/,/g, "");
    return selectedPlansAmount;
  }

  public openplanoptionsCorp(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");

    let modifiedOptions: any = [];
    let optionumber: any = [];

    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');


    console.log(optionsValue)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }

    }

    this.plandetailsobjvalue = plandetails;

    optionsValue.forEach((element: any) => {
      element.planOptionsValues.forEach((options: any) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    this.isExecutiveCP = plandetailsobj[19]
      ? parseInt(plandetailsobj[19]) == 1
        ? true
        : false
      : false;
  }

  public planCoverafeFunction() {
    this.paidEmployeeShare = 0;
    this.coveredEmployeeShare = 0;

    var package_plans = this.convertpackagesToPlans2(this.basepackages);

    let planSummaryMain = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
    let planSummaryLife = JSON.parse(sessionStorage.getItem("plansummaryLife") || "[]");

    this.iafgplansCheck = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    let planSummary = planSummaryMain.concat(planSummaryLife)

    var all_selected_plans: any = [];
    var payrollCCplans: any = [];
    var directpayCCplans: any = [];
    var employeeDealingPlans: any = [];
    var companyDealingPlans: any = [];
    var alloptinplans: any = [];
    var company_selected_plans: any = [];
    var employee_selected_plans: any = [];
    var company_paid_selected_plans: any = [];
    var company_covered_selected_plans: any = [];


    var selected_cp_plans = planSummary.filter(function (plan: any) {
      return plan.paidByCompany == 1 || plan.categorization?.paidByCompany == true;
    });

    var selected_cc_plans = planSummary.filter(function (plan: any) {
      return plan.coveredByCompany == 1 || plan.categorization?.coveredByCompany == true;
    });

    var selected_ep_plans = planSummary.filter(function (plan: any) {
      return plan.paidByEmployee == 1 || plan.categorization?.paidByEmployee == true;
    });

    for (var cp = 0; cp < selected_cp_plans.length; cp++) {
      var current_cp_plan: any = selected_cp_plans[cp];

      current_cp_plan.amount = adjustWith2DecimalsForUI(current_cp_plan.amount)

      // //this.consoleMessage("rakesh",current_cp_plan.amount)
      current_cp_plan["amounts"] = {
        company: current_cp_plan.amount,
        employee: 0,
        total: current_cp_plan.amount,
      };
      current_cp_plan["categorization"] = {
        paidByCompany: true,
        coveredByCompany: false,
        paidByEmployee: false,
      };

      console.log("you are here broo")
      current_cp_plan["type"] = "100% Company Paid";

      current_cp_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
      current_cp_plan["employeeAmountUI"] =
        "$" + current_cp_plan["amounts"].employee;
      current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
      current_cp_plan["companyAmountUI"] =
        "$" + current_cp_plan["amounts"].company;
      current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

      if (
        current_cp_plan.id == 429 ||
        current_cp_plan.packageId == 8 ||
        current_cp_plan.planLevel == 16
      ) {
        alloptinplans.push(current_cp_plan);
      } else {
        all_selected_plans.push(current_cp_plan);
        company_selected_plans.push(current_cp_plan);
        company_paid_selected_plans.push(current_cp_plan);
      }
    }

    for (var cc = 0; cc < selected_cc_plans.length; cc++) {
      var current_cc_plan: any = selected_cc_plans[cc];

      current_cc_plan["amounts"] = {
        company: current_cc_plan.upgradeCalculation.baseplanPrice,
        employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
        total: current_cc_plan.upgradeCalculation.combinedplanPrice,
      };

      current_cc_plan["companyCoveredBasePlan"] =
        current_cc_plan.upgradeCalculation.basePlanDetails;

      current_cc_plan["companyCoveredBasePlan"].companyTax =
        current_cc_plan.upgradeCalculation.baseplanTax;
      current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage =
        current_cc_plan.upgradeCalculation.companyTaxPercentage;

      current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage =
        current_cc_plan.upgradeCalculation.employeeTaxPercentage;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect =
        "0%";
      current_cc_plan["companyCoveredBasePlan"].specialTax =
        current_cc_plan["companyCoveredBasePlan"].companyTax +
        current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
      current_cc_plan["companyCoveredBasePlan"].tax2 =
        current_cc_plan["companyCoveredBasePlan"].companyTax;

      //this.consoleMessage(current_cc_plan);
      ///
      //deleta plan things
      current_cc_plan["employeeDeductions"] = {
        amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
        tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
        taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
      };

      current_cc_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: true,
        paidByEmployee: false,
      };

      current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type;

      current_cc_plan["planGrandTotal"] = {
        amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
        tax: current_cc_plan.upgradeCalculation.combinedplanTax,
        total: current_cc_plan.upgradeCalculation.combinedplanTotal,
        taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
      };
      // planid,planname,planlevelid,planlevename,amount
      current_cc_plan.amount = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.amountUI = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax;
      current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI;
      current_cc_plan.total = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI;
      current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total;


      current_cc_plan["companyShareTotal"] =
        current_cc_plan["companyCoveredBasePlan"].total;
      current_cc_plan["employeeShareTotal"] =
        current_cc_plan["employeeDeductions"].total;

      current_cc_plan["companySharePlanAmountTotal"] =
        current_cc_plan["companyCoveredBasePlan"].amount;
      current_cc_plan["employeeSharePlanAmountTotal"] =
        current_cc_plan["employeeDeductions"].amount;

      current_cc_plan["companyShareTaxTotal"] =
        current_cc_plan["companyCoveredBasePlan"].tax;
      current_cc_plan["employeeShareTaxTotal"] =
        current_cc_plan["employeeDeductions"].tax;

      current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
      current_cc_plan["employeeAmountUI"] =
        "$" + current_cc_plan["amounts"].employee;
      current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
      current_cc_plan["companyAmountUI"] =
        "$" + current_cc_plan["amounts"].company;
      this.coveredEmployeeShare += parseFloat(
        current_cc_plan["amounts"].employee
      );

      this.coveredEmployeeShare = parseFloat(this.coveredEmployeeShare)
      all_selected_plans.push(current_cc_plan);
      company_selected_plans.push(current_cc_plan);
      company_covered_selected_plans.push(current_cc_plan);

      if (current_cc_plan.upgradeCalculation.payroll) {
        payrollCCplans.push(current_cc_plan);
      } else {
        directpayCCplans.push(current_cc_plan);
      }
    }

    for (var ep = 0; ep < selected_ep_plans.length; ep++) {
      var current_ep_plan: any = selected_ep_plans[ep];


      current_ep_plan.amount = adjustWith2DecimalsForUI(current_ep_plan.products[0].price);

      current_ep_plan["amounts"] = {
        company: 0,
        employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
        total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
      };

      current_ep_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: false,
        paidByEmployee: true,
      };

      current_ep_plan["type"] = "Voluntary Opt In";

      current_ep_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
      current_ep_plan["employeeAmountUI"] =
        "$" + current_ep_plan["amounts"].employee;
      current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
      current_ep_plan["companyAmountUI"] =
        "$" + current_ep_plan["amounts"].company;
      this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
      all_selected_plans.push(current_ep_plan);
      employee_selected_plans.push(current_ep_plan);
    }

    employeeDealingPlans = directpayCCplans.concat(employee_selected_plans);

    companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans);

    this.alloptinplans = alloptinplans;


    sessionStorage.setItem("employeeshare", this.paidEmployeeShare);

    var totalIAFG = 0;
    for (let i = 0; i < this.iafgplansCheck.length; i++) {
      totalIAFG += parseFloat(this.iafgplansCheck[i].skuTotalPrice);
    }



    this.totalEmployeeShare =
      this.coveredEmployeeShare + this.paidEmployeeShare;
    this.cartDisplayAmount = this.paidEmployeeShare;
    this.totalEmployeeShare = parseFloat(this.totalEmployeeShare)
    this.cartDisplayAmount = this._decimalPipe.transform(
      this.cartDisplayAmount,
      "1.2-2"
    );

    if (employeeDealingPlans.length > 0 || this.iafgplansCheck.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";
      this.voluntryplansCheck = true
    } else {
      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      this.voluntryplansCheck = false
      sessionStorage.setItem("paymentMethod", "NONE");
    }

    this.directpayCCplansarr = directpayCCplans;
    this.payrollCCplansarr = payrollCCplans;
    this.companyDealingPlans = companyDealingPlans;
    this.employeeDealingPlansarr = employeeDealingPlans;



    this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    if (this.payrollCCplansarr.length > 0) {
      this.upgradeplansCheck = true
    }
    else {
      this.upgradeplansCheck = false
    }
    sessionStorage.setItem(
      "allSelectedPlans",
      JSON.stringify(all_selected_plans)
    );
    sessionStorage.setItem(
      "allSelectedOptPlans",
      JSON.stringify(alloptinplans)
    );

    this.companySelectedPlans = company_paid_selected_plans;
    this.companyCoveredPlans = company_covered_selected_plans;
    this.EmployeeSelectedPlans = employee_selected_plans
    this.allSelectedPlans = all_selected_plans;

    this.allSelectedPlans = this.allSelectedPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
    this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
    this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");

    this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
    this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
    this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");

    this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
    this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
    this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");

    this.companyCoveredCompanyShareTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTotal"
    );
    this.companyCoveredCompanySharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "companySharePlanAmountTotal"
    );
    this.companyCoveredCompanyShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTaxTotal"
    );
    this.companyCoveredEmployeeShareTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTotal"
    );
    this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "employeeSharePlanAmountTotal"
    );
    this.companyCoveredEmployeeShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTaxTotal"
    );

    this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
    this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
    this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

    this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
    this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
    this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

    //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
    this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
    this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
    this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

    //Company paid and company covered split with payroll
    this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
    this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
    this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");


    this.effectiveCompanyPlansAmountTotal =
      parseFloat(this.allCPPlansAmountTotal) +
      parseFloat(this.companyCoveredCompanySharePlanAmountTotal);
    this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
      this.effectiveCompanyPlansAmountTotal,
      "1.2-2"
    );
    this.effectiveCompanyTaxTotal =
      parseFloat(this.allCPTaxTotal) +
      parseFloat(this.companyCoveredCompanyShareTaxTotal);
    this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
      this.effectiveCompanyTaxTotal,
      "1.2-2"
    );
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyPaidTotal) +
      parseFloat(this.companyCoveredCompanyShareTotal);
    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
    this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
    this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");

    this.planssummarymainLife = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    let total: any = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    this.effectiveEmployeeTotalContibution =
      parseFloat(this.companyCoveredEmployeeShareTotal) +
      parseFloat(this.paidEmployeedTotal);
    this.effectiveEmployeeTotalContibution = adjustWith2DecimalsForUI(
      this.effectiveEmployeeTotalContibution
    );

    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyCoveredCompanyShareTotal) +
      parseFloat(this.companyPaidTotal);

    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    let payrollDeduction = sessionStorage.getItem("payrollDeduction")
      ? sessionStorage.getItem("payrollDeduction")
      : "EMPLOYEE_CHOICE";

    if (
      this.companyCoveredPlans.length > 0 &&
      payrollDeduction == "EMPLOYEE_CHOICE"
    ) {
    }
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }


  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }
  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name, plan) {
    // console.log(published, restricted, name, plan)
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }



  public covergages = ['SINGLE', 'COUPLE', 'FAMILY']

  pauseVideo(videoplayer: any) {
    videoplayer.nativeElement.play();
    setTimeout(() => {
      videoplayer.nativeElement.pause();
      if (videoplayer.nativeElement.paused) {
        this.show = !this.show;
      }
    }, 5000);
  }

  get plansVisible() {
    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }
    return selectedPlans.length > 0
  }

  get phoneForm() {
    return this.phoneform.controls;
  }

  get addressForm() {
    return this.addressform.controls;
  }

  get spouseForm() {
    return this.spouseform.controls;
  }


  get cobForm() {
    return this.cobform.controls;
  }

  get deletespouseForm() {
    return this.deletespouseform.controls;
  }

  get updatespouseForm() {
    return this.updatespouseform.controls;
  }

  get deletedependentForm() {
    return this.deletedependentform.controls;
  }

  get deleteForm2() {
    return this.maritalStatusform.get('deleteForm') as FormGroup;
  }

  get dependentForm() {
    return this.dependentform.controls;
  }

  get dependentPureForm() {
    return this.pureDependentform.controls;
  }

  get paymentMethodControls() {
    return this.paymentMethodForm.controls;
  }

  get valisignControls() {
    return this.valisignform.controls;
  }

  get paymentForm() {
    return this.paymentform.controls;
  }

  get ccForm() {
    return this.ccform.controls;
  }

  get padForm() {
    return this.padform.controls;
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['formConfig'] && changes['formConfig'].currentValue) {
      console.log("this.formConfig")
      this.genders = ['Male', 'Female', 'NonBinary']
      this.formConfiguration = this.formConfig;
      console.log('overview', this.formConfiguration)
      this.logo = this.formConfiguration.customerTiles;
      let tokens = this.formConfiguration.language_details.languageTokens;
      for (let token of tokens) {
        this.lang1[token.key] = token.value;
      }
      this.provianceList = this.formConfiguration.states.filter((list) => {
        if (list.countryId == 1)
          return list
      });
      this.configprovinceres = this.formConfig.states.sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
      this.beneficiaryValidations = this.formConfiguration.validations.beneficiaries
      console.log('beneficiaryValidations', this.beneficiaryValidations)
    }

    if (changes['customerDataInput'] && changes['customerDataInput'].currentValue && Object.keys(this.customerDataInput)) {
      console.log(this.customerDataInput.dependents, "this.customerDataInput.dependents")
      if (this.customerDataInput.dependents && Object.keys(this.customerDataInput.dependents.spouseInfo).length > 0) {
        this.isSpouseExists = true;
        this.isSpouseExistsBefore = true;
        this.availableFirstNames.push(this.customerDataInput.dependents.spouseInfo)
      }
      if (this.customerDataInput.dependents && this.customerDataInput.dependents.childrens.length > 0) {
        this.isChildExistsBefore = true;
        for (const child of this.customerDataInput.dependents.childrens) {
          this.availableFirstNames.push(child)
        }
      }
      this.isCorporateAccount = this.customerDataInput.isCorporateAccount;
    }

    console.log(this.customerDataInput, 'customerDataInput')


  }

  navigateToQuestions(route) {
    sessionStorage.setItem('isSpouse', route)
    this.router.navigate([`questions`]);
  }

  navigateToUpgradePlans() {
    sessionStorage.setItem('isSpouse', this.pendingMedicalQuestionaireCoverage)
    this.router.navigate([`upgrade-plans`]);
  }


  get dependenttypeForm() {
    return this.dependentTypeForm.controls;
  }



  formatDate1(date) {
    const date1 = parseDateOnly(date);
    if (!date1) {
      return '';
    }

    const futureDate: any = new Date(date1);
    futureDate.setDate(date1.getDate() + 30);
    const today: any = new Date();
    const diffInMs: any = futureDate - today;

    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    this.iafgDays = diffInDays;
    console.log(date, this.iafgDays)
    return toDisplayDate(date1);
  }

  /** Beneficiary payload date. Wire format, not display format. */
  formatDate(input) {
    return toLegacyUsDate(input);
  }

  removeUnderscores(input) {
    return input.replace('_', ' ').toLowerCase()
  }

  addBeneficiary(num, customerType) {
    this.beneficiaries = [...this.beneficiariesConst];
    this.beneficiaries1 = [...this.beneficiaries];
    this.deleteBenfIds = [];
    this.deleteBenfIds1 = [];
    this.beneficiaries = this.beneficiaries.filter(ben => ben.customerType.toLowerCase() == customerType)
    this.beneficiaries1 = this.beneficiaries1.filter(ben => ben.customerType.toLowerCase() == customerType)
    this.currentBeneficiary.customerType = customerType
    this.currentBeneficiary.type = 'PRIMARY'
  }

  checkMinor(beneficiary: any, index) {
    if (!beneficiary.isMinor) {
      this.beneficiaries[index].trusteeDetails.firstName = '';
      this.beneficiaries[index].trusteeDetails.lastName = '';
    }
  }


  addDependentForm() {
    this.dependentTypeForm.get('dependentType')?.setValue('')
    this.functionClearSettings();
    this.dependentType = '';
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    this.totalSummaryPrice = 0
    this.dependentform.get('effectiveDate')?.setValue('')

    const dependentType = this.dependentTypeForm.value.dependentType
    this.addDependentWithSpouse = false;
    console.log('this.dependentCoverage', this.dependentCoverage)
    this.totalCount = 0;
    this.childCoverage = '';
    if (this.enactMode === 'delete') {
      // Assuming dependentType is set elsewhere; their 'spouse' or 'child')
      const dependentData = this.dependentType === 'spouse' ? this.spouseInfo : this.childrenInfo[0]; // Adjust based on your selection logic

    }
  }

  changeDependent(e: any) {
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.showCorpPlansTable = false;
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []

    console.log(e)
    console.log(this.spouseform.get('dependentType')?.value)
    this.dependentType = this.spouseform.get('dependentType')?.value;

    this.dependentTypeForm.get('childrenCountData')?.setValue('')
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
  }

  changeCOBCoverage(e: any) {
    this.cobcoverage = e.target.value;
    this.showCorpPlansTable = false;
    this.clearAllMessages()
    this.addToPolicy = '';
    this.finalEffectiveDate = null;
    this.isExcludeSpouse = false;
    this.isExcludeAll = false;
    this.isExcludeChild = false;
    this.isExcludeChildAndSpouse = false;
    switch (this.cobcoverage) {
      case 'SINGLE':
      default:
        if (this.isSpouseExistsBefore) {
          this.isExcludeSpouse = true;
        }
        break;

      case 'COUPLE':
        console.log(this.isSpouseExistsBefore, this.isChildExistsBefore)
        if (this.isSpouseExistsBefore && this.isChildExistsBefore) {
          if (this.customerDataInput.dependents.childrens.length == 1) {
            this.isExcludeChildAndSpouse = true;
          }
          if (this.customerDataInput.dependents.childrens.length > 1) {
            this.isExcludeSpouse = true;
          }
        } else if (this.isSpouseExistsBefore && !this.isChildExistsBefore) {
          this.isExcludeAll = true;
        }
        break;

      case 'FAMILY':
        this.isExcludeAll = true;
        break;
    }

    return true;
  }

  changeMode(e: any) {
    this.functionClearSettings();
    this.mode = e.target.value;
  }


  momentDateformat(date: any) {
    return toDisplayDate(date);
  }



  handleChildDetails_v2() {
    console.log(this.pureDependentform, this.dependentform, this.addDependentWithSpouse)
    if (this.addDependentWithSpouse) {
      const spouseData_ = this.dependentTypeForm.value
      console.log(spouseData_, 'effectiveDate')
      this.dependentform.get('effectiveDate')?.setValue(spouseData_.effectiveDate, { emitEvent: false })
      if (this.dependentChildCoverage == 'close') {
        this.dependentform.get('carrierName')?.setValue(false, { emitEvent: false })
        this.dependentform.get('coveredByAnotherPlan')?.setValue(false, { emitEvent: false })
      }
    }

    if (this.dependentform.valid) {
      console.log("accessed", this.dependentform.valid, this.dependentform, this.specialNeeds)
      this.showChildForm = false;
      this.addDependentWithSpouse = false;
      if (this.editChildUpdate) {
        const updatedData = this.childrenDetails.map((item, index) => {
          if (index === this.childIndex) {
            return this.dependentform.value // Replace with new value
          }
          return item; // Return the original object for all other indices
        });
        this.childrenDetails = updatedData;
      } else {
        this.childrenDetails.push(this.dependentform.value)
      }
      if (this.dependentform.value.coveredByAnotherPlan == true) {
        this.childCovered = true
      }
      console.log('this.dependentCoverage', this.dependentCoverage)
      this.totalCount = this.totalCount + 1;
      this.handleContinue('');
      let childrenName = this.dependentform.value.fullName;
      let effectiveDate = toDisplayDate(this.dependentform.value.effectiveDate)
      if (this.dependentform.value.specialNeeds) {
        Swal.fire({ title: 'Info', text: `Your child ${childrenName} has Special needs, and needs be processed before ${effectiveDate} can be covered. Please check with you advisor on the status of enrollment.` })
      } else {
        Swal.fire({ title: 'Info', text: this.editChildUpdate ? 'Child info has been updated successfully.' : 'Children has been added successfully' })
      }
      this.addDependentWithSpouse = false;
      this.dependentform.reset();
    } else {
      this.dependentform.markAllAsTouched();
      return;
    }

    this.dependentChildCoverage = 'close'
    this.postSecondaryStudent = false;
    this.dependentform.reset();
  }


  handleChildDetails_v2New() {
    if (this.dependentType == 'child' || this.dependentType == 'multiple') {
      if (this.dependentChildCoverage == 'close') {
        this.dependentform.get('carrierName')?.setValue(false, { emitEvent: false })
        this.dependentform.get('coveredByAnotherPlan')?.setValue(false, { emitEvent: false })
      }
    }

    console.log(this.pureDependentform, this.dependentform, this.addDependentWithSpouse)


    if (this.dependentform.valid) {
      const dob = moment(this.dependentform.value.dob);
      const graduationDate = moment(this.dependentform.value.graduationDate);

      this.isGradError = graduationDate.isBefore(dob);

      if (this.isGradError) {
        return;
      }

      this.addToPolicy = ''
      this.clearAllMessages()
      console.log("accessed", this.dependentform.valid, this.dependentform, this.specialNeeds)
      this.showChildForm = false;
      this.addDependentWithSpouse = false;
      if (this.editChildUpdate) {
        const updatedData = this.childrenDetails.map((item, index) => {
          if (index === this.childIndex) {
            return this.dependentform.value // Replace with new value
          }
          return item; // Return the original object for all other indices
        });
        this.childrenDetails = updatedData;

        // here check all the children details and only include < 30 or not sn kids in normal


      } else {
        this.childrenDetails.push(this.dependentform.value)
      }
      console.log(this.dependentform.value.coveredByAnotherPlan, "this.dependentform.value.coveredByAnotherPlan")
      if (this.dependentform.value.coveredByAnotherPlan == true) {
        this.canShowPlans = true;
        this.childCovered = true
      }
      console.log('this.dependentCoverage', this.dependentCoverage)
      this.totalCount = this.totalCount + 1;
      let childrenName = this.dependentform.value.fullName;
      let effectiveDate = toDisplayDate(this.dependentform.value.dob)
      this.childEffectiveDate = moment(this.dependentform.value.dob).format('YYYY-MM-DD')
      if (this.dependentform.value.specialNeeds) {
        Swal.fire({ title: 'Info', text: `Your child ${childrenName} has Special needs, and needs be processed before ${effectiveDate} can be covered. Please check with you advisor on the status of enrollment.` })
      } else {
        Swal.fire({ title: 'Info', text: this.editChildUpdate ? 'Child info has been updated successfully.' : 'Children has been added successfully' })
      }
      this.addDependentWithSpouse = false;
      this.dependentform.reset();
      this.editChildUpdate = false;

    } else {
      this.dependentform.markAllAsTouched();
      return;
    }

    this.dependentChildCoverage = 'close'
    this.postSecondaryStudent = false;
    this.showDependentForm = false;
    this.dependentform.reset();
  }
  closeHandleChildDetails() {
    this.functionClearSettings()
    this.showChildForm = false;
  }

  updateChildDetails_v2(child, index) {
    console.log(this.childCoverage, "childcc", this.dependentChildCoverage, child)
    this.childIndex = index;
    this.showCorpPlansTable = false;
    this.showChildForm = true;
    this.addDependentWithSpouse = true;
    this.showDependentForm = true;
    this.showPlanDetails = false;
    this.editChildUpdate = true;
    if (child.coveredByAnotherPlan == true) {
      this.dependentChildCoverage = 'open';
    }
    this.dependentform.patchValue(normalizeDateFields(child))
  }


  clearAllMessages() {
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.underwritingHeading = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.secondMessage = ''
  }

  deleteChildDetails_v2(index) {
    Swal.fire({ title: 'Info', text: "Are you sure you want to delete?", showCancelButton: true }).then(res => {
      if (res.isConfirmed) {
        this.childrenDetails.splice(index, 1)
        console.log('this.dependentCoverage', this.dependentCoverage)
        this.totalCount = this.totalCount - 1;
        this.childCovered = false;
        this.addToPolicy = ''
        this.clearAllMessages()
        this.showCorpPlansTable = false;

      }
    })

  }



  getPlanSummaryObject() {
    console.log(this.oldExistingPlans);

    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }

    let object_: any = []

    console.log('selectedPlans', selectedPlans)
    for (const i of selectedPlans) {
      let oldPlanObj = this.oldExistingPlans.find(item => (item.planlevel.packageId == i.packageId && item.planlevel.parentId == i.planLevelParent))
      let obj = {
        packageName: oldPlanObj?.description ?? "",
        oldPlan: {
          plan: oldPlanObj?.name + ' ' + `(${oldPlanObj?.planCoverageUI})`,
          coverage: oldPlanObj?.planCoverageUI ?? "",
          tax: oldPlanObj?.calculatedTax?.tax ?? 0,
          price: oldPlanObj?.calculatedTax?.price ?? 0,
          total: oldPlanObj?.calculatedTax?.total ?? 0,
        },
        newPlan: {
          packageName: i?.packagename ?? "",
          plan: i.name + ' ' + `(${i.coverage})`,
          coverage: i?.planCoverageUI ?? "",
          tax: i?.tax ?? 0,
          price: i?.amount ?? 0,
          total: i?.total ?? 0,
        }
      }
      object_.push(obj)
    }

    console.log(object_)
    this.plansSummaryObj = object_;
  }

  handlePrepareNotes() {
    let notes: any = [];
    if (this.newlySelectedPlans && this.newlySelectedPlans.length > 0) {
      for (const nsp of this.newlySelectedPlans) {
        let newPlanName = nsp.name + '(' + nsp?.planCoverage + ')' || '';
        let oldPlanName = this.unSelectedPlans_ && this.unSelectedPlans_.length > 0 ? this.unSelectedPlans_[0]['name'] + '(' + this.unSelectedPlans_[0]['planCoverage'] + ')' : '';
        let coverageChange = this.coverageChange
        let coverageScenario = this.coverageChange
        let newPrice = nsp.price
        let oldPrice = this.unSelectedPlans_ && this.unSelectedPlans_.length > 0 ? this.unSelectedPlans_[0]['price'] : nsp.price
        let service = this.provisioningSites
        let dependent = this.dependentType
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"

        if (this.dependentType == 'child') {
          for (const child of this.childrenDetails) {
            if (child.specialNeeds) {
              approvalStatus = "pending"
            } else {
              approvalStatus = this.normalDependentRegistration ? "normal" : "proceed"
            }
          }
        }


        let noteString = { planChange: oldPlanName + '-' + newPlanName, coverageChange: coverageChange, coverageScenario: coverageScenario, priceChange: oldPrice + '-' + newPrice, service: service, dependent: dependent, approvalStatus: approvalStatus }
        notes.push(noteString)
      }
    }

    return notes;
  }


  handleDeletePrepareNotes() {
    let notes: any = [];
    if (this.unSelectedPlans_ && this.unSelectedPlans_.length > 0) {
      for (const nsp of this.unSelectedPlans_) {
        let newPlanName = nsp.name + '(' + nsp?.planCoverage + ')' || '';
        let oldPlanName = this.newlySelectedPlans[0]['name'] + '(' + this.newlySelectedPlans[0]['planCoverage'] + ')';
        let coverageChange = this.coverageChange
        let coverageScenario = this.coverageChange
        let newPrice = nsp.price
        let oldPrice = this.newlySelectedPlans[0]['price']
        let service = this.provisioningSites
        let dependent = this.dependentType
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"

        if (this.dependentType == 'child') {
          for (const child of this.childrenDetails) {
            if (child.specialNeeds) {
              approvalStatus = "pending"
            } else {
              approvalStatus = this.normalDependentRegistration ? "normal" : "proceed"
            }
          }
        }


        let noteString = { planChange: oldPlanName + '-' + newPlanName, coverageChange: coverageChange, coverageScenario: coverageScenario, priceChange: oldPrice + '-' + newPrice, service: service, dependent: dependent, approvalStatus: approvalStatus }
        notes.push(noteString)
      }
    }

    return notes;
  }


  async addChild() {
    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }
  }

  functionClearSettings() {
    this.dependentform.reset();
    this.validateCheck = true;
    this.spouseform.reset();
    this.isMarried = false;
    this.childCount = 0;
    this.showValidatePlans = false;
    this.showPlanDetails = false;
    this.showAfterPlanDetails = true;
    this.showSpouseInfo = false;
    this.specialpackages = []
    this.plansSummaryObj = []
    this.childCoverage = false;
    this.isCommonLaw = false;
    this.showChildForm = false;
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.normalSpouseRegistration = true;
    this.normalDependentRegistration = true;
  }

  handleMarriageDate(e: any) {

    // If the input is coming from the calendar picker, it's already a date object.
    this.marriedDate = parseDateOnly(e);
    this.finalEffectiveDate = null;
    this.clearAllMessages();
    this.spouseMarriedDate = parseDateOnly(e);
    const marriedDateFormatted = toDisplayDate(this.marriedDate);
    const date1 = moment(marriedDateFormatted, "MM-DD-YYYY"); // First date
    const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
    console.log(this.maritalStatus, this.isCommonLaw);

    const differenceInDays = date2.diff(date1, 'days');
    console.log('differenceInDays', differenceInDays);

    if (this.maritalStatus == 'married') {
      if (differenceInDays <= 30) {
        this.normalSpouseRegistration = true;
        this.isInsuranceCheck = false;
      } else {
        this.normalSpouseRegistration = false;
        this.isInsuranceCheck = true;
      }
    } else if (this.maritalStatus == 'commonLaw') {
      if (differenceInDays <= 365) {
        this.isInsuranceCheck = false;
        this.normalSpouseRegistration = true;
      } else {
        this.isInsuranceCheck = true;
        this.normalSpouseRegistration = false;
      }
    }
    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
  }

  handleChildDOBDate(e: any) {

    // If the input is coming from the calendar picker, it's already a date object.
    const dateofbirthchild = parseDateOnly(e);
    this.isGradError = false;
    const childDateFormatted = toDisplayDate(dateofbirthchild);
    const date1 = moment(childDateFormatted, "MM-DD-YYYY"); // First date
    const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
    console.log(this.maritalStatus, this.isCommonLaw);

    const differenceInDays = date2.diff(date1, 'days');
    console.log('differenceInDays', differenceInDays);

    if (differenceInDays <= 30) {
      this.normalDependentRegistration = true;
      this.isInsuranceCheck = false;
    } else {
      this.normalDependentRegistration = false;
      this.isInsuranceCheck = true;
    }
    console.log('this.normalSpouseRegistration', this.normalDependentRegistration)
  }

  addBenficiaryRow() {
    let obj = {
      "_id": Math.random() * 100,
      "firstName": "",
      "lastName": "",
      "type": "PRIMARY",
      "customerType": this.currentBeneficiary.customerType,
      "relationship": "",
      "dob": "",
      "isMinor": false,
      "percentage": "",
      "contactDetails": { contingentBeneficiary: { firstName: "", lastName: '' } },
      "trusteeDetails": { firstName: "", lastName: "" },
      "age": "",
      "gender": ""
    }
    this.beneficiaries.push(obj)
    this.beneficiaries1.push(obj)

    let seenIds = new Set();
    this.beneficiaries = this.beneficiaries.filter(beneficiary => {
      if (!seenIds.has(beneficiary._id)) {
        seenIds.add(beneficiary._id);
        return true;
      }
      if (!seenIds.has(beneficiary.id)) {
        seenIds.add(beneficiary.id);
        return true;
      }
      return false;
    });

    seenIds = new Set();
    this.beneficiaries1 = this.beneficiaries1.filter(beneficiary => {
      if (!seenIds.has(beneficiary._id)) {
        seenIds.add(beneficiary._id);
        return true;
      }
      if (!seenIds.has(beneficiary.id)) {
        seenIds.add(beneficiary.id);
        return true;
      }
      return false;
    });
  }

  checkValid(data, error) {
    if (data == "" || data == null || data == undefined) {
      Swal.fire({ title: this.lang?.Error, text: error })
      return true;
    } else {
      return false;
    }
  }

  onRelationshipChange(beneficiary: any) {
    if (beneficiary.relationship !== 'CHILD') {
      // If relationship is not CHILD, set isMinor to false and prevent setting it to true
      beneficiary.isMinor = false;
      beneficiary.trusteeDetails = { firstName: '', lastName: '' }
    }
  }

  addNewBeneficiary(beneficiary) {
    const obj = {
      "firstName": beneficiary.firstName,
      "lastName": beneficiary.lastName,
      "type": beneficiary.type,
      "customerType": beneficiary.customerType,
      "relationship": beneficiary.relationship != 'OTHERS' ? beneficiary.relationship : beneficiary.others,
      "dob": beneficiary.isMinor ? this.formatDate(beneficiary.dob) : '',
      "isMinor": beneficiary.isMinor,
      "percentage": beneficiary.percentage,
      "contactDetails": beneficiary.contactDetails == '' ? {} : beneficiary.contactDetails,
      "trusteeDetails": beneficiary.isMinor ? beneficiary.trusteeDetails : { firstName: '', lastName: '' }
    }
    if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
      return;
    }
    if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
      return;
    }
    if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
      return;
    }
    if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
      return;
    }
    if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
      return;
    }
    if (obj?.isMinor != true && obj?.isMinor != false) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
      return;
    }
    if (obj.isMinor == true) {
      if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
        return;
      }
      if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
        return;
      }
      if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
        return;
      }
    }
    if (obj?.isMinor != true && obj?.isMinor != false) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
      return;
    }
    if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
      return;
    }

    const customerId = sessionStorage.getItem('customerId')
    let endPoint = `/${customerId}/beneficiary`
    this.http.post(api.url + endPoint, obj, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log('beneficiary-add in db', obj)
        this.beneficiaryReload += 1;
        if (this.beneficiaryReload == this.beneficiaries.length) {
          Swal.fire({
            title: "Info",
            text: this.lang?.Beneficiaries_updated_successfully
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    })
  }

  updateBeneficiaries() {
    console.log(this.beneficiaries, this.beneficiaries1)
    const benf = this.beneficiaries1.filter(ben => ben?.id && !this.deleteBenfIds.includes(ben?.id))
    const benf1 = this.beneficiaries1.filter(ben => ben?._id && !this.deleteBenfIds1.includes(ben?._id))
    const benfs = [...benf, ...benf1]
    const allPercentages = benfs.map(ben => Number(ben.percentage));
    let totalPercentage = 0;
    for (let i = 0; i < allPercentages.length; i++) {
      totalPercentage += allPercentages[i];
    }
    console.log(totalPercentage, allPercentages)
    if (totalPercentage != 100) {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Total_sum_percentages_are_not_equal_to_100 })
      return;
    }
    let reload = 0;
    for (let i = 0; i < benfs.length; i++) {
      let obj = benfs[i]
      if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
        reload++;
        return;
      }
      if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
        reload++;
        return;
      }
      if (obj?.isMinor != true && obj?.isMinor != false) {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
        reload++;
        return;
      }
      if (obj.isMinor == true) {
        if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
          reload++;
          return;
        }
        if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
          reload++;
          return;
        }
        if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
          reload++;
          return;
        }
      }
      if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
        reload++;
        return;
      }
    }
    if (reload > 0) {
      return;
    }
    for (let i = 0; i < benfs.length; i++) {
      const beneficiary = benfs[i];
      const customerId = sessionStorage.getItem('customerId')
      if (beneficiary.id) {
        let endPoint = `/${customerId}/beneficiary/${beneficiary.id}`
        const obj = {
          "firstName": beneficiary.firstName,
          "lastName": beneficiary.lastName,
          "type": beneficiary.type,
          "customerType": beneficiary.customerType,
          "relationship": beneficiary.relationship != 'OTHERS' ? beneficiary.relationship : beneficiary.others,
          "dob": beneficiary.isMinor ? this.formatDate(beneficiary.dob) : '',
          "isMinor": beneficiary.isMinor,
          "percentage": beneficiary.percentage,
          "contactDetails": beneficiary.contactDetails,
          "trusteeDetails": beneficiary.isMinor && beneficiary.trusteeDetails.firstName != null ? beneficiary.trusteeDetails : { firstName: "", lastName: "" }
        }
        if (this.checkValid(obj.firstName, this.lang?.Please_enter_first_name)) {
          return;
        }
        if (this.checkValid(obj.lastName, this.lang?.Please_enter_last_name)) {
          return;
        }
        if (this.checkValid(obj.type, this.lang?.Please_enter_Type)) {
          return;
        }
        if (this.checkValid(obj.customerType, this.lang?.Please_enter_Custom_Type)) {
          return;
        }
        if (this.checkValid(obj.relationship, this.lang?.Please_Enter_Relationship)) {
          return;
        }
        if (obj?.isMinor != true && obj?.isMinor != false) {
          Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_Enter_Is_minor_or_not })
          return;
        }
        if (obj.isMinor == true) {
          if (this.checkValid(obj.dob, this.lang?.Please_enter_Date_of_Birth)) {
            return;
          }
          if (this.checkValid(obj.trusteeDetails.firstName, this.lang?.Please_Enter_Trustee_First_Name)) {
            return;
          }
          if (this.checkValid(obj.trusteeDetails.lastName, this.lang?.Please_Enter_Trustee_Last_Name)) {
            return;
          }
        }
        if (this.checkValid(obj.percentage, this.lang?.Please_enter_Percentage)) {
          return;
        }
        this.http.put(api.url + endPoint, obj, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            console.log('beneficiary is updated in db', obj)
            this.beneficiaryReload += 1;
            if (this.beneficiaryReload == this.beneficiaries.length) {
              Swal.fire({
                title: "Info",
                text: this.lang?.Beneficiaries_updated_successfully
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                } else {
                  window.location.reload()
                }
              })
            }
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        })

      } else {
        this.addNewBeneficiary(beneficiary)
      }
    }
    for (let i = 0; i < this.beneficiaries1.length; i++) {
      if (this.deleteBenfIds.includes(this.beneficiaries1[i]?.id)) {
        const customerId = sessionStorage.getItem('customerId')
        let endPoint = `/${customerId}/beneficiary/${this.beneficiaries1[i].id}`
        this.http.delete(api.url + endPoint, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            console.log('beneficiary deleted in db', this.beneficiaries1[i])
            this.beneficiaryReload += 1;
            if (this.beneficiaryReload == this.beneficiaries.length) {
              Swal.fire({
                title: "Info",
                text: this.lang?.Beneficiaries_updated_successfully
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload()
                } else {
                  window.location.reload()
                }
              })
            }
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        })
      } else {
      }
    }
  }

  deleteBeneficiary(beneficiary) {
    Swal.fire({
      title: this.lang?.Delete_Beneficiary,
      text: this.lang?.Do_you_want_to_delete_this_beneficiary,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: this.lang?.Cancel,
      denyButtonText: this.lang?.Delete,
    }).then((result) => {
      if (result.value) {
        this.deleteBenfIds = []
        this.deleteBenfIds1 = []
      } else {
        if (beneficiary.id) {
          this.deleteBenfIds = [...this.deleteBenfIds, beneficiary.id]
          this.beneficiaries = this.beneficiaries.filter(ben => ben.id != beneficiary.id)
        } else {
          this.deleteBenfIds1 = [...this.deleteBenfIds1, beneficiary._id]
          this.beneficiaries = this.beneficiaries.filter(ben => ben._id != beneficiary._id)
        }
      }
    })
  }

  getBankDetails() {
    let data = this.PADdetails;
    data['branchCode'] = this.PADdetails?.transitNumber;
    let accessToken = sessionStorage.getItem('accessToken');
    const Endpoint = '/bank/verify';
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.bank = response?.data;
        this.address = this.bank?.address;
        this.bankinformation = response?.data?.bank?.name + "\n" + response?.data?.address?.split(",").join("\n");
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response?.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error?.error?.message })
    })
  }
  viewPlansLoading(e: any) {
    this.showViewPlansLoading = false;
  }
  pdfLoaded(e: any) {
    this.loading = false;
  }

  public getLanguageTokens() {
    let body = {
      "project": "Member Portal",
      "url": "Overview"
    }
    this.http
      .post(api.lang + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.lang = {};
          this.selectedLanguage = sessionStorage.getItem('language') || 'English'
          for (let token of response.strings) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          console.log(this.lang)
        }
      )
  }

  updateAddressForm() {

    this.invalidpostalcodeprivince = false
    this.provianceList?.forEach((element: any) => {
      if (element.name == this.customerData.province) {
        this.customerData.province = element.shortName
      }
    });

    this.addressform.patchValue(normalizeDateFields(this.customerData));
    this.addressform.markAllAsTouched();
  }

  updateAddress() {

    if (this.addressform.invalid) {
      this.addressform.markAllAsTouched();
      return;
    }
    else {
      if (this.addressform.value.secondaryPhone == this.addressform.value.primaryPhone) {
        this.secondaryphonecheck = true

      }
      else {
        this.secondaryphonecheck = false
        if (this.addressform.invalid) {
          this.addressform.markAllAsTouched();
          return;
        }
        else {
          const endPoint = '/' + this.customerid + '/address';
          let data = this.addressform.value;
          data["street_address_line1"] = this.addressform.value.line1
          data["street_address_line2"] = this.addressform.value.line2
          if (data["street_address_line2"].value == '') {
            data["street_address_line2"] = ' ';
          }
          else {
            if (data["street_address_line2"].value == null) {
              data["street_address_line2"] = ' ';
            }
          }
          data["postal_code"] = this.addressform.value.postalCode
          data["dob"] = toLegacyUsDate(this.addressform.value.dob)
          data["code"] = this.valisignform.value.code
          if (this.addressForm['secondaryPhone'].value == null) {
            data['secondaryPhone'] = '';
          }
          if (this.addressform.valid && this.invalidpostalcodeprivince == false) {
            let headers = {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
            this.http.put(api.url + endPoint, data, {
              headers: headers
            }).subscribe((response: any) => {
              if (response.status == 200) {

                this.closeAddressmodal.nativeElement.click();
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
              }
              else {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
              }
            }, (error) => {

              Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })

            });
          }
        }
      }
    }

  }

  updatePhoneNoForm() {
    this.phoneform.patchValue(this.customerData);
  }

  updatePhoneNo(value: any) {
    if (this.phoneform.invalid) {
      this.phoneform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/' + this.customerid + '/address';
      let data = this.phoneform.value;
      if (this.phoneForm['secondaryPhone'].value == null) {
        data['secondaryPhone'] = '';
      }
      this.http.put(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closePhonemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });

    }

  }

  closePhoneModal() {
    this.phoneform.reset();
  }

  updateSpouseDetails() {
    console.log("data", this.updatespouseform)

    if (this.updatespouseform.invalid) {
      this.updatespouseform.markAllAsTouched();
      return;
    }
    else {
      const endPoint = '/' + this.customerid + '/customerRelative/' + this.spouseId + '/details';

      let data = this.updatespouseform.value;

      data["coverage"] = this.updatespouseform.value.healthPlan || "";
      data["carrierName"] = this.updatespouseform.value.insurer || "";
      data["relationType"] = "SPOUSE"
      if (this.updatespouseform.value.coveredByAnotherPlan === true) {
        data["coveredByAnotherPlan"] = true
      }
      else {
        data["coveredByAnotherPlan"] = false
      }

      data["dob"] = toLegacyUsDate(this.updatespouseform.value.dob)
      this.http.put(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }



  deleteSpouseDetails_1(children) {
    this.dependentTypeForm.reset()
    this.dependentType == "spouse"
    this.spouseCovered = children?.coveredByAnotherPlan;
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
  }

  deleteChildrenDetails_1(children) {
    this.dependentTypeForm.reset()
    this.dependentType == "dependent"
    this.childCovered = children?.coveredByAnotherPlan;
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
  }


  async handleDeleteDependent(depDetails: any) {
    // Show SweetAlert confirmation dialog
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");
    console.log("called333");
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = depDetails.id;

    console.log(depDetails)
    this.selectedDependentDetails = depDetails;
    this.dependentType = depDetails.relationType == "child" ? "dependent" : "spouse"
    this.spouseCovered = depDetails.relationType == "child" ? false : depDetails?.coveredByAnotherPlan
    this.childCovered = depDetails.relationType == "spouse" ? false : depDetails?.coveredByAnotherPlan
    this.currentDeleteMember = depDetails.relationType == "child" ? "child" : "spouse"
    this.dependentTypeForm.reset()
    this.dependentTypeForm.get('effectiveDate')?.setValue('')
    Swal.fire({
      allowOutsideClick: false,
      title: 'Info',
      text: 'Are you sure you want to Delete?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((res) => {
      if (res.isConfirmed) {
        // After SweetAlert confirmation, show the modal

      } else {
        $("#cancelButton22").click()
      }
    })
  }

  async handleConfirmDelete() {

    console.log("0hgggg")


    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }

    console.log('this.specialpackages', this.specialpackages)

    // 1st
    this.plansObj = []
    let phrPlanSelected = false;
    let isPhr = false;
    let oldPlans: any = []
    for (let pack of this.specialpackages) {
      let obj: any = {};
      let selected: any = {};

      if (pack.id == 10) isPhr = true;

      if (pack.selected) {
        if (pack.id == 10) phrPlanSelected = true;
        console.log("Package selected, checking groups...");  // Debugging package selection

        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    if (c.selected) {
                      selected = { ...c };
                      console.log("Selected addon:", selected);  // Debugging selected addon

                      for (let sc of selectedPlans) {
                        console.log("Comparing with selected plan:", sc);  // Debugging comparison with selected plans
                        if (c.planId == sc?.id && !sc?.products[0]?.selected) {
                          obj = {
                            ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                            newPlan: { ...sc },
                            ...(c.planCoverage != sc.coverage && c.selected && this.covergages.includes(c.planCoverage) && { coverageChange: true })
                          };
                          console.log("Plan comparison result obj:", obj);  // Debugging obj creation
                        } else {
                          this.unselected.forEach((ele) => {
                            if (ele.planId == c.planId) {
                              console.log("Unselected plans:", this.unselected);  // Debugging unselected plans
                              let obj1: any = {
                                ...(c.selected ? { oldPlan: { ...c } } : { oldPlan: {} }),
                                newPlan: {},
                              };
                              oldPlans.push(obj1);
                              console.log("Added to oldPlans:", obj1);  // Debugging addition to oldPlans
                            }
                          });
                        }
                      }
                    }
                  }
                });
              }
            }
          }
        });

        if (obj && Object.keys(obj).length > 0 && ((obj.oldPlan && Object.keys(obj?.oldPlan).length > 0) || (obj.newPlan && Object.keys(obj?.newPlan).length > 0))) {
          console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
          this.plansObj.push(obj);
          obj = {};
        }
      }

      // when package selected but completely different plan with in same package
      if (pack.selected && selected) {
        console.log("Entered package with different plan selection");  // Debugging package with different plan selection
        Object.keys(pack.groups).forEach((group: any) => {
          for (let plan of pack.groups[group]) {
            for (let plans of plan.plans) {
              if (!plans.selected) {
                Object.keys(plans.productAddonss).forEach((addon: any) => {
                  for (let c of plans.productAddonss[addon]) {
                    for (let sc of selectedPlans) {
                      console.log("=====")
                      console.log(plans, sc)
                      console.log("----")
                      console.log(c)
                      console.log("=====0")
                      if (plans.planLevel == sc.planLevel && c.planId == sc.id) {
                        obj = {
                          oldPlan: { ...selected },
                          newPlan: { ...sc },
                        };
                        console.log("Created obj for different plan selection:", obj);  // Debugging obj creation
                      }
                    }
                  }
                });

                if (Object.keys(obj).length > 0) {
                  this.unselected = this.unselected.filter((ele) => (
                    ele.planId != obj.oldPlan.planId
                  ));
                  oldPlans = oldPlans.filter(e => e.oldPlan.planId != obj.oldPlan.planId);
                  console.log("Updated unselected and oldPlans:", this.unselected, oldPlans);  // Debugging unselected and oldPlans after filtering
                  console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
                  this.plansObj.push(obj);
                  obj = {};
                }
              }
            }
          }
        });
      }

      //when package in not selected but completely diffrenet package selected
      if (!pack.selected) {
        console.log("Package not selected, checking for selected plans...");  // Debugging package not selected
        for (let sc of selectedPlans) {
          console.log("Checking if package matches:", sc.packageId == pack.id);  // Debugging package match check
          if (sc.packageId == pack.id) {
            obj = {
              newPlan: { ...sc },
              oldPlan: {}
            };
            console.log("Created obj for unselected package:", obj);  // Debugging obj creation for unselected package
          }
        }
        if (Object.keys(obj).length > 0) {
          console.log("Pushing obj to plansObj:", obj);  // Debugging push to plansObj
          this.plansObj.push(obj);
          obj = {};
        }
      }
    }

    //when plan selected and diselected
    if (oldPlans.length > 0) {
      const uniquePlanIds = new Set<number>();
      const filteredOldPlans = oldPlans.filter((plan) => {
        if (!uniquePlanIds.has(plan.oldPlan.planId)) {
          uniquePlanIds.add(plan.oldPlan.planId);
          return true;
        }
        return false;
      });

      if (filteredOldPlans.length > 0) {
        console.log("Pushing filteredOldPlans to plansObj:", filteredOldPlans);  // Debugging push of filtered old plans
        this.plansObj = [...this.plansObj, ...filteredOldPlans];
      }
    }

    //high cost drugs selected and all in selected
    let allinSelected = this.plansObj.some((plan) => { return plan.newPlan.planLevelParent == 6 });
    console.log("All-in selected:", allinSelected);  // Debugging all-in selected flag
    const allIndisallowed = [1, 10, 14, 24];
    if (allinSelected) {
      for (let pack of this.specialpackages) {
        if (pack.selected) {
          Object.keys(pack.groups).forEach((group: any) => {
            for (let plan of pack.groups[group]) {
              for (let plans of plan.plans) {
                if (plans.selected && allIndisallowed.includes(plans.planLevel)) {
                  Object.keys(plans.productAddonss).forEach((addon: any) => {
                    for (let c of plans.productAddonss[addon]) {
                      if (c.selected) {
                        console.log("High cost drug selected:", c.planId);  // Debugging high cost drug selection
                        this.plansObj.push({
                          oldPlan: { ...c },
                          newPlan: {}
                        });
                      }
                    }
                  });
                }
              }
            }
          });
        }
      }
    }

    //phr rules
    let healthAndDentalSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 1 });
    let phrSelected = this.plansObj.some((plan) => { return plan.newPlan.packageId == 10 });
    console.log("Health and Dental selected:", healthAndDentalSelected);  // Debugging health and dental selection
    console.log("Phr selected:", phrSelected);  // Debugging phr selection

    if (healthAndDentalSelected && isPhr) {
      if (!phrSelected && !phrPlanSelected) {
        console.log("Error: PHR plan not selected with Health/Dental plan");  // Debugging PHR selection error
        Swal.fire({
          title: this.lang?.Error, text: this.lang?.Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan
        });
        return;
      }
    }

    const notes = await this.handlePrepareNotes();



    let filteredPlans = this.plansObj.filter(plan =>
      Object.keys(plan.newPlan).length > 0 && Object.keys(plan.oldPlan).length > 0
    );


    console.log(this.dependentTypeForm1)
    let data: any = {}
    let slug = 'remove'

    let effDate = moment(this.dependentTypeForm1.value.effectiveDate).format('DD-MM-YYYY');
    if (this.dependentType == "spouse") {
      data = {
        "spouse": this.selectedDependentDetails,
        "dependent": [],
        "notes": this.handleGenerateNotes(filteredPlans, 'proceed', this.dependentType, slug, ''),
        "approvalStatus": "proceed",
        "coverageScenario": this.coverageChange,
        "isPlanChanges": filteredPlans.length > 0 ? true : false,
        "effectiveDate": effDate,
        "changedCoveragePlans": this.newlySelectedPlans,
        "removalDependents": [],
        "plans": filteredPlans,
        "reason": this.noReason
      }
    } else {
      data = {
        "spouse": {},
        "dependent": [this.selectedDependentDetails],
        "notes": this.handleGenerateNotes(filteredPlans, 'proceed', this.dependentType, slug, ''),
        "approvalStatus": "proceed",
        "coverageScenario": this.coverageChange,
        "isPlanChanges": filteredPlans.length > 0 ? true : false,
        "effectiveDate": effDate,
        "changedCoveragePlans": this.newlySelectedPlans,
        "removalDependents": [],
        "plans": filteredPlans,
        "reason": this.noReason
      }
    }


    console.log(data);




    // using for delete
    let endPoint = `/v2/${this.customerid}/lifeChange/${this.dependentType}/${slug}/false`



    this.http.post(api.url + endPoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        if (this.selectedDependentDetails.relationType == 'spouse') {

          Swal.fire({ title: 'Info', text: 'Spouse deleted successfully. enrollment process is begin in the background.please check after some time.' }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })

        } else {
          Swal.fire({ title: 'Info', text: 'Dependent deleted successfully. enrollment process is begin in the background.please check after some time.' }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            } else {
              window.location.reload()
            }
          })
        }

      }
      else {
        Swal.fire({ title: 'Info', text: 'Something went wrong' }).then((result) => {
          if (result.isConfirmed) {
            $("#addDependent").hide();

            window.location.reload()
          } else {
            window.location.reload()
          }
        })
      }
    }, (error) => {
      Swal.fire({ title: 'Info', text: 'Something went wrong' }).then((result) => {
        if (result.isConfirmed) {
          $("#addDependent").hide();

          window.location.reload()
        } else {
          window.location.reload()
        }
      })
    });




  }

  openCoverage(value: any) {
    this.coverage = value;
    if (this.coverage === 'open') {
      this.spouseCoverage = true;
      this.spouseForm['insurer'].setValidators([Validators.required]);
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].setValidators([Validators.required]);
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
    else {
      this.spouseForm['insurer'].reset();
      this.spouseForm['healthPlan'].reset();
      this.spouseForm['insurer'].clearValidators();
      this.spouseForm['insurer'].updateValueAndValidity();
      this.spouseForm['healthPlan'].clearValidators();
      this.spouseForm['healthPlan'].updateValueAndValidity();
    }
  }


  handleChangeCurrentCoverage(value: any) {
    this.coveredByAnotherPlan = value;
    this.finalEffectiveDate = null;
  }



  openDependentCoverage(value: any) {

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }


    this.showSpouseInfo = true;
    this.showPlanDetails = true;
    this.showAfterPlanDetails = false;
    this.dependentCoverage = value;
    console.log(this.dependentCoverage, 'depovver', this.dependentType)
    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
    if (this.dependentCoverage == 'open') {

      this.noReason = ''
      if (this.dependentType == 'spouse') {
        this.childCovered = false;
        this.spouseCovered = true;
        this.handleContinue('')

      }
      if (this.dependentType == 'multiple') {
        //check childForm has true
        console.log(this.spouseform.value, this.dependentform.value)

        this.childCovered = false;
        this.spouseCovered = true;
        console.log('this.dependentCoverage', this.dependentCoverage)
        this.handleContinue('')

      }
      if (this.dependentType == 'child') {
        this.childCovered = true;
        this.handleContinue('')
      }
      if (this.dependentType == 'spouse' || this.dependentType == 'multiple') {
        this.spouseForm['insurer'].setValidators([Validators.required]);
        this.spouseForm['insurer'].updateValueAndValidity();
      }
      else {
        this.dependentForm['carrierName'].setValidators([Validators.required]);
        this.dependentForm['carrierName'].updateValueAndValidity();
      }


    }
    else {
      if (this.normalSpouseRegistration == false) {
        let reason;
        if (this.isCommonLaw) {
          reason = 'The date of marriage is more than 365 days and the spouse has not been covered by any other insurance carrier. The request is currently pending approval from our insurance carrier.'
        } else {
          reason = 'The date of marriage is more than 30 days and the spouse has not been covered by any other insurance carrier. The request is currently pending approval from our insurance carrier.'
        }
        this.noReason = reason
        Swal.fire('Info', reason).then(res => {
          if (res.isConfirmed) {
            this.spouseCovered = false;
            this.handleContinue('')
            this.dependentForm['carrierName'].reset();
            this.dependentForm['carrierName'].clearValidators();
            this.dependentForm['carrierName'].updateValueAndValidity();
            this.spouseForm['healthPlan'].reset();
            this.spouseForm['healthPlan'].clearValidators();
            this.spouseForm['healthPlan'].updateValueAndValidity();
          }
        })
      } else {
        this.spouseCovered = false;
        this.handleContinue('');
        this.dependentForm['carrierName'].reset();
        this.dependentForm['carrierName'].clearValidators();
        this.dependentForm['carrierName'].updateValueAndValidity();
        this.spouseForm['healthPlan'].reset();
        this.spouseForm['healthPlan'].clearValidators();
        this.spouseForm['healthPlan'].updateValueAndValidity();
      }



    }



    if (value == 'open') {
      Swal.fire({
        title: 'Info',
        text: 'Do you wish to change your coverage if applicable?',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel'
      }).then(res => {
        if (res.isConfirmed) {
          this.isUpgradeOrDowngrade = 'upgrade';
          this.handleUpgradeOrDowngrade('upgrade')
        } else {
          // remains same and make plan changes as false
          this.isUpgradeOrDowngrade = 'downgrade';
          this.handleUpgradeOrDowngrade('downgrade')
        }
      })
    }


    console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
  }



  handleUpgradeOrDowngrade(value: any) {

    console.log(this.upgradeorDowngradeplans, value)
    if (value == 'upgrade') {
      const selectedPlans = this.upgradeorDowngradeplans.map(plan => {
        const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        return {
          planName: plan.name,
          addOn: plan.addon,
          action: selectedOption ? selectedOption.value : null,
          isBundle: plan.isBundle
        };
      });

      // Handle the selected plans and actions (Upgrade/Downgrade)
      selectedPlans.forEach((plan) => {
        console.log(plan, "....plan...")
        // we gonna click that element
        let element: any = plan.addOn
        if (plan.isBundle) {


          $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element, "elem677")
          if (element?.planCoverage && element?.planCoverage != '-') {
            console.log("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
            $("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          }
          else {
            console.log($("#plancheck" + element.planlevel.id))
            $("#plancheck" + element.planlevel.id).click()

          }
        }
        console.log(`Upgrading ${plan.planName}`);

      });
    } if (value == 'downgrade') {
      const selectedPlans = this.upgradeorDowngradeplansSelected.map(plan => {
        const selectedOption = document.querySelector(`input[name="plan_${plan.name}"]:checked`) as HTMLInputElement;
        return {
          planName: plan.name,
          addOn: plan.addon,
          action: selectedOption ? selectedOption.value : null,
          isBundle: plan.isBundle
        };
      });

      // Handle the selected plans and actions (Upgrade/Downgrade)
      selectedPlans.forEach((plan) => {
        console.log(plan, "....plan...")
        // we gonna click that element
        let element: any = plan.addOn
        if (plan.isBundle) {


          $("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()).click()
          console.log($("#plancheck" + element.planId + ".coverage" + element.planCoverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element, "elem677")
          if (element?.planCoverage && element?.planCoverage != '-') {
            console.log("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase())
            $("#plancheck" + element.planlevel.id + ".coverage" + element.planCoverage.toUpperCase()).click()
          }
          else {
            console.log($("#plancheck" + element.planlevel.id))
            $("#plancheck" + element.planlevel.id).click()

          }
        }
        console.log(`Upgrading ${plan.planName}`);

      });
    }
  }

  openChildCoverage(value: any) {
    console.log(value, "valiiii", this.dependentTypeForm)
    this.showAfterPlanDetails = false
    this.showSpouseInfo = true
    this.dependentChildCoverage = value;
    if (this.dependentChildCoverage === 'open') {
      this.childCoverage = true;
      this.dependentForm['carrierName'].setValidators([Validators.required]);
      this.dependentForm['carrierName'].updateValueAndValidity();

    }
  }

  handleDeleteDependentConfirmation(value: any) {
    this.clearAllMessages();
    this.finalEffectiveDate = null;
    this.deleteDependentConfirmation = value === 'open';
  }


  updateDependentForm(i: any, msg: any) {
    console.log("iii", i, "data99", this.childrenInfo);
    let childId = i.id;
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.dependentform.patchValue(normalizeDateFields(i));
    this.childCoverage = i.coveredByAnotherPlan;
    this.specialNeeds = i.specialNeeds;
    this.postSecondaryStudent = i.postSecondaryStudent;
    this.dependentForm['effectiveDate'].clearValidators();
    this.dependentForm['effectiveDate'].updateValueAndValidity();
    if (this.childCoverage === false) {
      this.dependentForm['carrierName'].clearValidators();
      this.dependentForm['carrierName'].updateValueAndValidity();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    if (this.postSecondaryStudent === false) {
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }


  deleteDependentForm(i: any, children: any) {
    let childId = this.childrenInfo[i].id;
    this.dependentType = "dependent"
    console.log("called", this.dependentType)
    this.dependentUpdate = true;
    this.dependentStatus = true;
    this.childrenId = childId;
    this.currentDeleteMember = "child";
    this.deleteChildrenDetails_1(children);
  }
  updateDependent() {

    if (this.dependentform.invalid) {
      this.dependentform.markAllAsTouched();
      return;
    }
    else {
      console.log(this.dependentform)

      let depData: any = {
        firstName: this.dependentform.get('firstName')?.value,
        lastName: this.dependentform.get('lastName')?.value,
        gender: this.dependentform.get('gender')?.value,
        dob: toApiDate(this.dependentform.get('dob')?.value),
        age: this.dependentform.get('age')?.value,
        phoneNum: this.dependentform.get('phoneNum')?.value,
        coveredByAnotherPlan: this.dependentform.get('coveredByAnotherPlan')?.value,
        carrierName: this.dependentform.get('carrierName')?.value,
        specialNeeds: this.dependentform.get('specialNeeds')?.value,
        postSecondaryStudent: this.dependentform.get('postSecondaryStudent')?.value,
        effectiveDate: toApiDate(this.dependentform.get('effectiveDate')?.value),
      };



      let depType = depData.relationType == "CHILDREN" ? "dependent" : "spouse"

      if (depType == "dependent") {
        depData['insurer'] = depData.carrierName;
        delete depData['carrierName']
      }
      let childId = this.childrenId;
      let finalData: any = {};
      const endPoint = `/v2/${this.customerid}/lifeChange/${depType}/update/false`

      console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
      console.log('this.spouseform.value.coveredByAnotherPlan', this.spouseform.value.coveredByAnotherPlan)
      let approvalStatus = this.normalSpouseRegistration ? "normal" : this.dependentform.get('coveredByAnotherPlan')?.value ? "proceed" : "pending"


      if (depType == "dependent") {
        finalData = {
          "spouse": {},
          "dependent": [depData],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "coverageScenario": this.coverageChange ?? "STC",
          "isPlanChanges": true,
          "effectiveDate": this.dependentform.get('effectiveDate')?.value,
          "changedCoveragePlans": [],
          "removalDependents": [],
          "plans": [],
          "reason": this.noReason ?? ""
        }
      }
      if (depType == "spouse") {

        finalData = {
          "spouse": depData,
          "dependent": [],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "coverageScenario": this.coverageChange ?? "STC",
          "isPlanChanges": true,
          "effectiveDate": this.dependentform.get('effectiveDate')?.value,
          "changedCoveragePlans": [],
          "removalDependents": [],
          "plans": [],
          "reason": this.noReason ?? ""
        }
      }



      let accessToken = sessionStorage.getItem('accessToken');
      this.http.post(api.url + endPoint, finalData, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.closeDependentmodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }


  async updateCobInfo() {
    if (this.addToPolicy == '') {
      this.showAddToPolicyError = true
    }
    console.log(this.cobform)
    if (this.cobform.invalid) {
      this.cobform.markAllAsTouched()
      return;
    }


    this.showAddToPolicyError = false;
    // direct submit if there is no policy change
    if (!this.isNeedToUpdate) {
      await this.updateCobData()
    } else {
      document.getElementById('addDependent')?.classList.add('d-none');

      // Show the second modal by removing d-none
      document.getElementById('showPlanSummaryBrief')?.classList.remove('d-none');
      document.getElementById('showPlanSummaryBrief')?.classList.add('d-block');
      document.getElementById('showPlanSummaryBrief')?.classList.add('show');
    }

  }

  async updateCobData() {
    let endPoint = `/customer/update-customer-details/${this.customerid}/cob`


    let existingSpouse = this.availableFirstNames.find(item => item.relationType == 'spouse');

    let validationInputData: any = {
      maritalStatus: "",
      dependentId: existingSpouse.id,
      coverage: this.cobform.get('cobCoverage')?.value,
      insurer: this.cobform.get('insurer')?.value,
      deleteDependent: this.isDependentSelected
    }
    this.http.post(api.url + endPoint, validationInputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        Swal.fire({ title: "Info", text: "Cob information for spouse updated successfully." }).then(res => {
          if (res.isConfirmed) {
            window.location.reload()
          }
        })
      } else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    })
  }


  async handlemaritalstatustype(e: any) {
    console.log(e)
    console.log(e.target.value)
    if (e.target.value == "DIVORCED" || e.target.value == "SEPERATED") {
      this.showSpouseDropDownForDelete = true;
    } else {
      this.showSpouseDropDownForDelete = false;
    }
  }


  async updateMaritalStatus() {
    if (this.maritalStatusform.invalid) {
      this.maritalStatusform.markAllAsTouched()
      return;
    }

    let endPoint = `/customer/update-customer-details/${this.customerid}/maritalStatus`


    let existingSpouse = this.availableFirstNames.find(item => item.relationType == 'spouse');

    let validationInputData: any = {
      maritalStatus: this.maritalStatusform.get('maritalStatus')?.value == "other" ? this.maritalStatusform.get('reason')?.value : this.maritalStatusform.get('maritalStatus')?.value,
      dependentId: existingSpouse.id,
      coverage: "",
      insurer: "",
      deleteDependent: this.isDependentSelected
    }
    this.http.post(api.url + endPoint, validationInputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        Swal.fire({ title: "Info", text: "Marital Status updated successfully." }).then(res => {
          if (res.isConfirmed) {
            window.location.reload()
          }
        })
      } else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    })
  }

  openGraduationDate(value: any) {
    this.graduationDate = value.currentTarget.checked;

    this.postSecondaryStudent = value.currentTarget.checked;
    if (this.postSecondaryStudent) {
      this.dependentForm['graduationDate']?.setValidators(Validators.compose([Validators.required, this.validateDateforGraduation]));
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
    else {
      this.dependentForm['graduationDate'].reset();
      this.dependentForm['graduationDate'].clearValidators();
      this.dependentForm['graduationDate'].updateValueAndValidity();
    }
  }


  closeDependentForm() {
    this.spouseform.reset();
    this.isExcludeSpouse = false;
    this.isExcludeAll = false;
    this.isExcludeChild = false;
    this.isExcludeChildAndSpouse = false;
    this.functionClearSettings()
    this.dependentTypeForm.reset();
    this.dependentType = ""
    this.dependentform.reset();
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.graduationDate = true;
    this.dependentUpdate = false;
    this.showCorpPlansTable = false;
    this.dependentCoverage = 'close';


    this.cobform.reset();
    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    this.needToUpdate = ''
    this.cobevent = ''
    this.cobeventType = ''
    this.dependentType = ''
    this.maritalStatus = ''
    this.needToUpdate = false;
    this.firstConfirmMessage = ''
    this.secondConfirmMessage = ''
    this.corpMessage = ''
    this.firstMessage = ''
    this.thirdConfirmMessage = ''
    this.underWritingMessage1 = ''
    this.underWritingMessage2 = ''
    this.secondMessage = ''
    this.deleteForm.reset()
    this.spouseform.reset()
    this.childrenDetails = []
    this.childrenDetailsForNormalReg = []
    this.addToPolicy = ''
    this.dependentform.reset()
    this.cobform.reset()

  }

  showAddDependentForm() {
    console.log("called")
    this.showCorpPlansTable = false;
    this.showDependentForm = true;
  }

  closeAddDependentForm() {
    this.showDependentForm = false;
    this.editChildUpdate = false;
  }


  closeSpouseForm() {
    console.log("called")
    this.spouseCoverage = '';
    this.coverage = 'open'
    this.dependentUpdate = false;
    this.dependentTypeForm1.reset()
    this.specialpackages = []
  }

  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  tabData() {
    this.selectedTab = 'tab1';
  }

  hicDetails() {
    this.hicList = this.customerData.healthCards_v2.cards;
  }

  viewHealthCard(link: any) {
    this.src = link.link;
    this.healthCard = true;
    if (this.src == '') {
      this.card = true;
    }
  }

  closeHealthCard() {
    this.healthCard = false;
    this.displayStyle = "none";
    this.card = false;
  }

  closeDownloadBooklet() {
    this.hidebooklet = false;
  }

  downloadHic(value: any) {
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      }
    );
  }

  checkAllCheckBox(value: any) {
    this.hicList.forEach(hic => hic.checked = value.target.checked)
  }

  isAllCheckBoxChecked() {
    return this.hicList.every(hic => hic.checked);
  }

  checkAllBooklets(value: any) {
    this.bookletList.forEach(booklet => booklet.checked = value.target.checked)
  }

  isAllBookletsChecked() {
    return this.bookletList.every(booklet => booklet.checked);
  }

  downloadSelected() {
    this.bookletList1 = this.bookletList.filter((selected: any) => selected.checked).map((selected: any) => selected);
    if (this.bookletList1.length > 0) {
      for (let i = 0; i < this.bookletList1.length; i++) {
        this.http.get(this.bookletList1[i].link, { responseType: "arraybuffer" }).subscribe(
          pdf => {
            const blob = new Blob([pdf], { type: "application/pdf" });
            const fileName = this.bookletList1[i].name + ".pdf";
            saveAs(blob, fileName);
          },
          (error) => {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
          }
        );
      }
    }
    else {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_booklets_Selected })
    }
  }

  downloadAllHpBooklets() {
    Swal.fire({
      allowOutsideClick: false,
      title: 'Alert',
      text: 'Download all booklets?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Download',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.bookletList.length > 0) {
          for (let i = 0; i < this.bookletList.length; i++) {
            this.http.get(this.bookletList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.bookletList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Booklets_Found })
        }
        this.hicList = this.customerData.healthCards_v2.cards;
        if (this.hicList.length > 0) {
          for (let i = 0; i < this.hicList.length; i++) {
            this.http.get(this.hicList[i].link, { responseType: "arraybuffer" }).subscribe(
              pdf => {
                const blob = new Blob([pdf], { type: "application/pdf" });
                const fileName = this.hicList[i].name + ".pdf";
                saveAs(blob, fileName);
              },
              (error) => {
                Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
              }
            );
          }
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.No_Health_Cards_Found })
        }
      }
      else {

      }
    });
  }

  downloadHpbooklet(value: any) {
    this.http.get(value.link, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = value.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      }
    );
  }


  getRoe(roe: any) {
    setTimeout(() => {
      if (roe.link != "") {
        if (!hasWhiteSpace(roe.link)) {
          this.roe = roe.link;

          this.viewRoe = true;
        }
        else {
          this.viewRoe = false;
        }
      }
    }, 1000);
  }

  closeRoe() {
    this.viewRoe = true;
  }

  downloadRoe(roe: any) {
    this.getRoe(roe);
    this.http.get(this.roe, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = this.roe + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    this.openRoe.nativeElement.click();
  }

  openPaymentDetails(value: any) {
    this.openUpdatePaymentForm = value;
    if (value == 'close') {
      Object.keys(this.paymentMethodControls).forEach(controlName => {
        if (controlName !== 'paymentmethod') {
          const control = this.paymentMethodControls[controlName];
          control.reset();
        }
      });
      this.bankDetails = false;
      this.resetButton = false;
      this.uploadCheque = false;
      setTimeout(() => {
        this.closePaymenttoPAD.nativeElement.click();
      }, 1000);
    }
  }

  public provincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });
    if (this.addressform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.addressform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.addressForm['postalCode'].markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
      }
      if (this.addressform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
  }

  changeTextToUppercase(event: any) {
    const inputValue = this.addressform.get('postalCode')?.value;
    this.addressform.get('postalCode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    this.postalvalue = event.target.value;
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
      this.addressForm['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  upperCase(event: any) {
    const inputValue = event?.data;
    if (inputValue != null) {
      this.paymentform.get('postalcode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    }
  }

  phoneFormat(event: any) {
    this.secondaryphonecheck = false
    if (event.target.id == 'primaryPhone') {
      const inputValue = this.addressform.get('primaryPhone')?.value;
      this.addressform.get('primaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    }
    else if (event.target.id == 'secondaryPhone') {
      const inputValue = this.addressform.get('secondaryPhone')?.value;
      this.addressform.get('secondaryPhone')?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
    }

  }

  getBankInfo() {
    if (this.paymentMethodForm.invalid) {
      this.paymentMethodForm.markAllAsTouched();
      return
    }
    else {
      let data = this.paymentMethodForm.value;
      let accessToken = sessionStorage.getItem('accessToken');
      const Endpoint = '/bank/verify';
      this.http.post(api.url + Endpoint, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.bankDetails = true;
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.Bank_Details_verified_successfully })

        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
        this.bankInfo = response?.data;
        this.address = this.bankInfo.address;
        this.bankAddress = this.bankInfo.address.split(', ');
        this.resetButton = true;
        this.uploadCheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }

  openpad() {
    this.openUpdatePaymentForm = 'close';
  }

  closeChangeToPad() {
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.previewbutton = false;
    this.paymentMethodForm.get('files')?.setValue('');
  }

  closepadinfo() {
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.paymentMethodForm.get('files')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  updateBankInfo() {
    if (this.padform.invalid) {
      this.padform.markAllAsTouched();
      return
    }
    else {
      let data = this.padform.value;
      data['branchCode'] = this.padform.value.transitNumber
      data['accountNumber'] = this.padform.value.accountNo
      data['bankCode'] = this.padform.value.bankcode
      let accessToken = sessionStorage.getItem('accessToken');

      const Endpoint = '/bank/verify';
      this.http.post(api.url + Endpoint, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.banknameres = response?.data.bank.name + "\n" + response?.data.address.split(",").join("\n");
          this.bankinfo = true;
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
        this.bank = response?.data;
        this.address = this.bank.address;
        this.bankAddress = this.bank.address.split(', ');
        this.resetbutton = true;
        this.cheque = true;
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
    }
  }

  updateBankDetails(event) {
    this.banknameres = event.target.value;
  }

  closeValisign() {
    clearInterval(this.startTimer);
  }

  timer(minute: any) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.startTimer = setInterval(() => {
      seconds--;
      if (statSec != 0) {
        statSec--;
      }
      else {
        statSec = 59;
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      }
      else {
        textSec = statSec;
      }
      this.displayTimer = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(this.startTimer);
        this.showTimer = false;
      }
    }, 1000);
  }

  viewinvoices(value: any) {
    setTimeout(() => {
      this.invoiceslink = value;
    }, 1000);
  }

  downloadinvoices(value: any) {
    this.http.get(value.file, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "Invoice" + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }
  getInvoices() {
    let Endpoint = '/' + this.fusebillId + '/invoices/list';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.customerInvoices = response?.data
        this.customerFinalInvoices = response?.data.filter(invoice => invoice.status.toLowerCase() != 'draft')
        this.customerFinalInvoicesIGBMS = response?.data.filter(invoice => invoice.status.toLowerCase() != 'draft')

        this.customerFinalInvoices.reverse()
        this.customerFinalInvoicesIGBMS.reverse()

        this.allCustomerFinalInvoices = this.customerFinalInvoices
        this.allCustomerFinalInvoicesIGBMS = this.customerFinalInvoicesIGBMS
        const draftInvoiceData = response?.data.filter(invoice => invoice.status.toLowerCase() == 'draft')[0]
        this.getCustomerDraftDate = draftInvoiceData?.month
        this.getCustomerDraftDate1 = draftInvoiceData?.month
        this.invoicedraftData = draftInvoiceData?.invoice
      }
      else {
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  getCreditcard() {
    let Endpoint = '/' + this.customerid + '/creditCards';
    this.http.get(api.url + Endpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        sessionStorage.setItem('defaultCreditCard', JSON.stringify([]))
        sessionStorage.setItem('existingCreditCards', JSON.stringify({}))
        if (response?.data[0]) {
          const data = response.data;
          let defaultCard = data?.filter((card) => card.defaultCard == true)?.[0] ?? {}
          let nonDefaultCards = data?.filter((card) => card.defaultCard != true)
          sessionStorage.setItem('defaultCreditCard', JSON.stringify(defaultCard || []))
          sessionStorage.setItem('existingCreditCards', JSON.stringify(nonDefaultCards || {}))
          this.ccDetails = response?.data[0];
          this.publicapikey = response?.data[0].publicKey;
          this.creditCardNo = response?.data[0].maskedCardNumber;
          this.fullName = this.customerData.firstName + ' ' + this.customerData.lastName;

          this.expire = response?.data[0].expirationMonth + '/' + response?.data[0].expirationYear;
        }
      }
      else {
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  viewBooklet(value: any) {
    setTimeout(() => {
      this.bookletLink = value;
    }, 1000);
    this.hidebooklet = true;
  }

  closeBooklet() {
    this.hidebooklet = false;
    this.displayBooklet = "none";
  }



  handleCalculateBackdatedPrice() {
    this.backdatedamount = 0
    this.backdatedamountUI = 0
    let backdatedMonths: any = 0
    const currentDate = moment();

    let finalEffectDate = moment(this.finalEffectiveDate).format('YYYY-MM-DD')

    const effectiveDate = moment(finalEffectDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const daysDiff = currentDate.diff(effectiveDate, 'days');
    if (daysDiff < 0) {
      backdatedMonths = 0
    }

    if (daysDiff < 31) {
      backdatedMonths = 1
    }
    let enrollmentDate = moment(finalEffectDate, 'YYYY-MM-DD');
    const monthsAgo = Math.floor(currentDate.diff(enrollmentDate, 'months', false));
    if (monthsAgo > 0) {
      backdatedMonths = monthsAgo + 1;
    }


    console.log('Effective date:', finalEffectDate, 'Parsed:', enrollmentDate.format(), 'daysdiff: ', daysDiff);

    console.log(this.currentamount, this.upcomingamount)
    console.log(monthsAgo, "monthsAgo889")
    // now calculate the price
    this.backdatedamount = Math.abs((this.upcomingamount - this.currentamount) * backdatedMonths).toFixed(2);
    this.backdatedamountUI = this.handleAmountonUI(this.backdatedamount);
    return Math.abs((this.upcomingamount - this.currentamount) * backdatedMonths).toFixed(2);
  }

  resetPaymentForm() {
    this.paymentMethodControls['bankCode'].reset();
    this.paymentMethodControls['branchCode'].reset();
    this.paymentMethodControls['accountNumber'].reset();
    this.paymentMethodControls['files'].reset();
    this.bankDetails = false;
    this.uploadCheque = false;
    this.resetButton = false;
  }

  resetPadForm() {
    this.bankinfo = false;
    this.cheque = false;
    this.resetbutton = false;
    this.padForm['bankcode'].reset();
    this.padForm['transitNumber'].reset();
    this.padForm['accountNo'].reset();
    this.padForm['file'].reset();
    this.existVoid = false;
  }

  onFileSelect(event: any) {
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();
    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();

    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';
    } else {
      this.voidCheckFileType = 'image/jpeg';
    }

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      if (this.paymentVoidCheque.size <= 1024 * (Number(api.fileSize) ?? 5) * 1024) {
        error = false;
      } else {
        error = true;
        message = 'File size is too large, maximum file size is 5MB';
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.previewbutton = true;
      };
    }
  }

  fileSelect(event: any) {
    this.fileExtension = "." + event.target.files[0].name.split(".").pop();

    if (this.fileExtension == '.pdf') {
      this.voidCheckFileType = 'application/pdf';
    } else {
      this.voidCheckFileType = 'image/jpeg';
    }

    this.paymentVoidCheque = event.target.files[0];
    this.selectedBase64 = this.convertFile(this.paymentVoidCheque);

    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];
    let error = false;
    let message = "";
    if (allowedMimes.includes(this.paymentVoidCheque.type)) {
      if (this.paymentVoidCheque.size <= 1024 * (Number(api.fileSize) ?? 5) * 1024) {
        error = false;
      } else {
        error = true;
        message = 'File size is too large, maximum file size is 5MB';
      }
    } else {
      error = true;
      message = this.lang?.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
    }
    if (error) {
      Swal.fire({
        allowOutsideClick: false,
        title: this.lang?.Error,
        html: message,
        width: "30%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          this.paymentMethodForm.get('files')?.reset();
        } else {
        }
      });
    }
    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {

        this.imagedisplay = reader.result;
        this.updatepreviewbutton = true;
        if (this.padform.get('file')?.value != '') {
          this.review = false;
        }
      };
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      if (event.target?.result) {
        result.next(btoa(event.target.result.toString()));
      }
    }
    return result;
  }

  generateCorporatePAD() {

    let inputData1 = {
      bankCode: this.paymentMethodForm.get("bankCode")?.value,
      branchCode: this.paymentMethodForm.get("branchCode")?.value,
      accountNumber: this.paymentMethodForm.get("accountNumber")?.value,
    };
    let bankAddress = this.address;
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bankInfo.bank.name,
      address: this.bankInfo.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    formData.append(
      "files",
      this.paymentVoidCheque,
      "void_cheque_" + Date.now() + fileExtension.toLowerCase()
    );
    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/' + this.customerid + '/generatePAD';
    this.http.post(api.url + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.pad = response?.data.url;
        this.filename = response?.data.filename;
        this.padfilename = response?.data.padfilename;
        this.ext = response?.data.ext;
        this.mimetype = response?.data.mimetype;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  updateCorporatePAD() {

    let inputData1 = {
      bankCode: this.padform.get("bankcode")?.value,
      branchCode: this.padform.get("transitNumber")?.value,
      accountNumber: this.padform.get("accountNo")?.value,
      amount: this.PADdetails.nextBillingPrice,
      customerId: this.customerid
    };


    let bankAddress;
    if (this.address == null) {
      bankAddress = this.bankinformation;
    }
    else {
      bankAddress = this.address;
    }
    let bankAdressArr = bankAddress.split(",")
    let provincePostal = bankAdressArr[bankAdressArr.length - 1];
    let provincePostalArr = provincePostal.split(" ");
    let bankobject = {
      name: this.bank.bank.name,
      address: this.bank.bank.address.split(",")[0],
      city: bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
      province: provincePostalArr[provincePostalArr.length - 3],
      postalCode: provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1],
    }
    if (!this.paymentVoidCheque) {
      this.paymentVoidCheque = this.voidCheckPdf;
    }
    var fileExtension = "." + this.paymentVoidCheque.name.split(".").pop();
    this.encBank = btoa(JSON.stringify(inputData1));
    var formData: any = new FormData();
    formData.append("bank", JSON.stringify(bankobject));
    formData.append(

      "files",

      this.paymentVoidCheque,

      "void_cheque_" + Date.now() + fileExtension.toLowerCase()

    );

    formData.append("session", this.encBank) || "";
    formData.append("timestamp", new Date().getTime());
    let Endpoint = '/' + this.customerid + '/generatePAD';
    this.http.post(api.url + Endpoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.pad = response?.data.url;
        this.filename = response?.data.filename;
        this.padfilename = response?.data.padfilename;
        this.ext = response?.data.ext;
        this.mimetype = response?.data.mimetype;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  closeAgreement() {

  }

  drawComplete() {
    this.showconfirm = false
  }

  drawStart() {

  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.isDrawing = false;
  }

  onMouseDown(e: any) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e: any) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.signaturecheckvalue1cc = true;
      this.context.stroke();
      this.showupdatesignatue = false;
    }
  }


  clearCreditCardSignature() {
    this.context.clearRect(
      0,
      0,
      this.sigPadElement.width,
      this.sigPadElement.height
    );
    this.context.beginPath();
    this.signaturecheckvalue1cc = false;
    sessionStorage.removeItem("signature");
    this.signaturemessagecc = true;
    this.signaturecheckcc = true;
  }

  private relativeCoords(event: any) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }

  clearSignature() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
    this.showupdatesignatue = true;
  }

  savePad() {
    const base64Data = this.sigPadElement.toDataURL();
    this.signatureImg = base64Data;
    let Endpoint = '/' + this.customerid + '/updatePAD';
    let data = {
      url: this.pad,
      signature: this.signatureImg,
      session: this.encBank,
      filename: this.filename,
      padfilename: this.padfilename,
      ext: this.ext,
      mimetype: this.mimetype,
      adminName: 'sai',
    }
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.signedPad = response?.data.url;
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  closeSignaturePad() {
    this.closePaymentmodal.nativeElement.click();
  }


  addSpouse() {
    this.spouseUpdate = false;
    if (JSON.stringify(this.spouseInfo) === '{}') {
      this.spouseStatus = true;
      this.spouseForm['martialStatus'].clearValidators();
      this.spouseForm['martialStatus'].updateValueAndValidity();
      this.spouseForm['effectiveDate'].clearValidators();
      this.spouseForm['effectiveDate'].updateValueAndValidity();
    }
    else {
      this.spouseStatus = false;
    }
    this.spouseform.reset();
  }

  addSpouseData() {
    if (this.spouseStatus) {

      if (this.spouseform.invalid) {
        this.spouseform.markAllAsTouched();
        return;
      }
      else {
        const endPoint = '/' + this.customerid + '/lifeChanges/spouse/add/true';
        this.spouseData = this.spouseform.value;
        if (this.spouseform.value.coveredByAnotherPlan != true) {
          this.spouseData["coverage"] = ""
          this.spouseData["carrierName"] = ""
        }
        else {
          this.spouseData["coverage"] = this.spouseform.value.healthPlan
          this.spouseData["carrierName"] = this.spouseform.value.insurer
        }
        if (this.spouseform.value.email == null) {
          this.spouseData["email"] = ""
        }
        this.spouseData["dob"] = toLegacyUsDate(this.spouseform.value.dob)
        this.spouseData["relationType"] = "SPOUSE"

        let data: any;
        data = {
          'spouse': this.spouseData,
          'dependent': []
        }

        this.http.post(api.url + endPoint, data, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {

            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
      }
    }
    else {
      if (this.spouseForm['effectiveDate'].invalid || this.spouseForm['martialStatus'].invalid) {

        this.spouseform.markAllAsTouched();
        return;
      }
      else {

        console.log(this.spouseform.value, 'asdsad')
        let spouseData = this.childrenInfo;
        let spouseData_: any = {}

        let data = this.spouseform.value;

        for (let spouse of spouseData) {
          if (spouse["relationType"] == "spouse") {
            spouseData_["firstName"] = spouse.firstName;
            spouseData_["lastName"] = spouse.lastName;
            spouseData_["dob"] = spouse.dob;
            spouseData_["gender"] = spouse.gender;
            spouseData_["email"] = spouse.email || "";
            spouseData_["coverage"] = spouse.healthPlan;
            spouseData_["carrierName"] = spouse.insurer;
            spouseData_["healthPlan"] = spouse.healthPlan;
            spouseData_["insurer"] = spouse.insurer;
            spouseData_["id"] = spouse.id
          }

        }

        console.log('this.normalSpouseRegistration', this.normalSpouseRegistration)
        console.log('this.spouseform.value.coveredByAnotherPlan', this.spouseform.value.coveredByAnotherPlan)
        let approvalStatus = this.normalSpouseRegistration ? "normal" : this.spouseform.value.coveredByAnotherPlan ? "proceed" : "pending"



        let finalData: any = {
          "spouse": spouseData_,
          "dependent": [],
          "notes": {
            "planChange": "classic bronze(single)-classic bronze(couple)",
            "coverageChange": "single-couple",
            "coverageScenario": "STC",
            "priceChange": "153.12-306.26",
            "service": [
              "greenshield"
            ],
            "dependent": "spouse",
            "approvalStatus": approvalStatus
          },
          "approvalStatus": approvalStatus,
          "isPlanChanges": this.newlySelectedPlans.length > 0 ? true : false,
          "effectiveDate": this.spouseForm['effectiveDate'].value,
          "changedCoveragePlans": this.newlySelectedPlans,
          "removalDependents": [],
        }


        if (this.spouseform.value.coveredByAnotherPlan === true) {
          data["coveredByAnotherPlan"] = true
        }
        else {
          data["coveredByAnotherPlan"] = false
        }

        data = {
          'spouse': data,
          'dependent': []
        }
        const endPoint = `/'+this.customerid+'/lifeChanges/${this.dependentType}/remove/false`;






        for (const key in spouseData) {
          if (spouseData[key] === null) {
            spouseData[key] = "";
          }
        }

        // data["dob"]= this.datePipe.transform(new Date(this.spouseform.value.dob).toLocaleString(),'MM-dd-yyyy')
        this.http.post(api.url + endPoint, finalData, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            this.closeSpousemodal.nativeElement.click();
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
          }
          else {
            Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          }
        }, (error) => {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
        });
      }
    }


  }

  addDependent() {
    this.dependentform.reset();
    this.dependentUpdate = false;
    this.postSecondaryStudent = false;
    this.dependentStatus = true;
    this.dependentForm['graduationDate'].clearValidators();
    this.dependentForm['graduationDate'].updateValueAndValidity();
    this.dependentData = [];
  }

  addAnotherDependent() {
    if (this.dependentform.valid) {
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }
      this.dependentData.push(this.dependentform.value);
      this.dependentform.reset();
    }
    else {
      this.dependentform.markAllAsTouched();
    }

  }




  addDependentData() {
    if (this.dependentform.valid) {
      let data: any;
      if (this.dependentform.value.coveredByAnotherPlan === false) {
        this.dependentForm["carrierName"].setValue("");
      }
      if (this.dependentform.value.postSecondaryStudent != true) {
        this.dependentForm["graduationDate"].setValue("");
      }

      this.dependentData.push(this.dependentform.value);
      if (this.dependentData['graduationDate']) {
        this.dependentData['graduationDate'] = toLegacyUsDate(this.dependentform.value.graduationDate)

      }
      else {
        this.dependentData['graduationDate'] = ""

      }
      this.dependentData['dob'] = toLegacyUsDate(this.dependentform.value.dob)
      data = {
        'spouse': {},
        'dependent': this.dependentData
      }
      const endPoint = '/' + this.customerid + '/lifeChanges/dependent/add/true';
      this.http.post(api.url + endPoint, data, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {

          this.closeSpousemodal.nativeElement.click();
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message });
        }
        else {
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
      this.closeDependentmodal.nativeElement.click();
    }
    else {
      this.dependentform.markAllAsTouched();
    }
  }

  getMonth(event: any) {
    this.expireMonth = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  getYear(event: any) {
    this.expireYear = event.target.value;
    this.validateExpire(this.expireYear, this.expireMonth);
  }

  validateExpire(year: any, month: any) {
    let date = 31
    if (month == 4 || month == 6 || month == 9 || month == 11) {
      date = 30
    }
    else if (month == 2) {
      if ((year % 4 == 0 && year % 100 !== 0) || (year % 400 == 0)) {
        date = 29;
      }
      else {
        date = 28;
      }
    }
    if (year != null && month != null) {
      const expiry = new Date(parseInt("20" + year), month - 1, date);
      const current = new Date();
      if (expiry.getTime() < current.getTime()) {
        this.invalidExpiration = true;
      }
      else {
        this.invalidExpiration = false;
      }
    }
  }

  closePaymentInfo() {
    this.paymentform.reset();
    this.paymentform.get('expireMonth')?.setValue('');
    this.paymentform.get('expireYear')?.setValue('');
  }

  closeCcInfo() {
    this.ccform.reset();
    this.ccform.get('expireMonth')?.setValue('');
    this.ccform.get('expireYear')?.setValue('');
  }

  changeToCC() {
    this.getCreditcard();
  }


  getGroups(data): any[] {
    return Array.isArray(data?.value) ? data.value : Object.values(data?.value ?? {});
  }

  saveCcPayment(value: any, value1: any) {
    if (this.paymentform.invalid) {
      this.paymentform.markAllAsTouched();
      return;
    }
    else {
      var accessToken = sessionStorage.getItem('accessToken');
      var headers = {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      };
      setTimeout(() => {
        const cardNumber = this.paymentform.get('CardNumber')?.value;
        const expirationMonth = this.paymentform.get('ExpirationMonth')?.value;
        const expirationYear = this.paymentform.get('ExpirationYear')?.value;

        let newCardDetails = {
          expiry: expirationMonth + '/' + expirationYear,
          endingNumber: "************" + cardNumber.slice(-4)
        }
        localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))

        value1.submit();
        if (this.currClient) {
          this.router.navigate([`${this.currClient}/home`]);
        } else {
          this.router.navigate(['home']);
        }
      }, 100)


    }
  }

  updateCcInfo(value: any, value1: any) {
    if (this.ccform.invalid) {
      this.ccform.markAllAsTouched();
      return;
    }
    else {
      const cardNumber = this.ccform.get('CardNumber')?.value;
      const expirationMonth = this.ccform.get('ExpirationMonth')?.value;
      const expirationYear = this.ccform.get('ExpirationYear')?.value;

      let newCardDetails = {
        expiry: expirationMonth + '/' + expirationYear,
        endingNumber: "************" + cardNumber.slice(-4)
      }


      localStorage.setItem("newCardDetails", JSON.stringify(newCardDetails))


      console.log(this.ccform)
      value1.submit();
      if (this.currClient) {
        this.router.navigate([`${this.currClient}/home`]);
      } else {
        this.router.navigate(['home']);
      }
    }
  }

  padUpdate() {
    this.padform.patchValue({});
    this.padform.get('branchCode')?.setValue('')
    this.padform.get('accountNo')?.setValue('')
    this.padform.get('bankcode')?.setValue('')
    this.padform.get('bankdetails')?.setValue('')
    this.banknameres = '';
    this.bankinfo = true;
    this.resetbutton = true;
    this.resetPadForm();
  }

  checkFirstCharacter(event: any, form: any) {
    if (event.target.value.startsWith(' ')) {
      event.target.value = event.target.value.trimStart();
    }
  }


  public formatCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {
      // Format the input with spaces every 4 digits
      inputVal = inputVal.match(/.{1,4}/g).join(' ');


    }
    this.ccform.get('CardNumber')?.setValue(inputVal);
    this.paymentform.get('CardNumber')?.setValue(inputVal);

  }
  public formatAmericaCreditCardNumber(event: any): void {
    let inputVal = event.target.value.replace(/\s+/g, ''); // Remove existing spaces

    if (inputVal.length > 0) {

      inputVal = inputVal.replace(/(\d{4})(\d{1,6})?(\d{1,5})?/, function (match, p1, p2, p3) {
        return p1 + (p2 ? ' ' + p2 : '') + (p3 ? ' ' + p3 : '');
      });
    }
    this.ccform.get('CardNumber')?.setValue(inputVal);
    this.paymentform.get('CardNumber')?.setValue(inputVal);
  }
  public isValidAmexCard(cardNumber) {
    // Remove any non-digit characters
    const cleanedCardNumber = cardNumber.replace(/\D/g, '');

    // Check if the card number has 15 digits and starts with 34 or 37
    const isAmex = /^3[47]\d{13}$/.test(cleanedCardNumber);

    return isAmex;
  }
  public isValidAmexCardNumber(val) {
    // Define the regex pattern for formatted Amex card number
    const amexPattern = /^3[47][0-9]{2} [0-9]{6} [0-9]{5}$/;
    console.log(amexPattern)
    return amexPattern.test(val.replaceAll(' ', ''));


  }
  public creditcardlblurmethod(event) {
    this.validateCreditCardNumber(event)


    let val = event.target.value;


    console.log(val.slice(0, 2))


    if (val.slice(0, 2) == 34 || val.slice(0, 2) == 37) {
      this.creditcardvalidationAmerica(val)
      this.formatAmericaCreditCardNumber(event)
    }
    else {
      this.creditcardvalidation(val)
      this.formatCreditCardNumber(event)


    }

    val = val.replaceAll(' ', '')
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2
    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }
      // Add the units element to the checksum total
      checksum = checksum + calc;
      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    if (checksum % 10 == 0) {
      this.invalidcreditcard = false;
    } else {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length < 13) {
      this.invalidcreditcard = true;
    }

    if (event.target.value.length == 0) {
      this.invalidcreditcard = false;
    }
  }
  validateCreditCardNumber(val) {
    const cardImage = document.getElementById('card-image');

    console.log(val.target.value)
    const visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    const mastPattern = /^(?:5[1-5][0-9]{14})$/;
    const amexPattern = /^(?:3[47][0-9]{13})$/;
    const discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

    const ccNum: string = val.target.value.replaceAll(' ', '')

    const isVisa = visaPattern.test(ccNum) === true;
    const isMast = mastPattern.test(ccNum) === true;
    const isAmex = amexPattern.test(ccNum) === true;
    const isDisc = discPattern.test(ccNum) === true;

    if (isVisa || isMast || isAmex || isDisc) {
      // at least one regex matches, so the card number is valid.
      if (isVisa) {
        this.cardType = 'Visa card'
        // Visa-specific logic goes here
      }
      else if (isMast) {
        this.cardType = 'Master card'
        // Mastercard-specific logic goes here
      }
      else if (isAmex) {
        this.cardType = 'Amex card';
      }
      else if (isDisc) {
        this.cardType = 'Discover card'
        // Discover-specific logic goes here
      }
    }
    else {
      this.cardType = '';
    }
  }

  creditcardvalidation(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{19,19}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true

      console.log("test")

    } else {
      this.invalidcreditcarddetails = false

    }
  }
  creditcardvalidationAmerica(value: any) {
    console.log(value)
    var creditcardRegexp = /^[0-9_ ]{17,17}$/;
    if (value && !creditcardRegexp.test(value)) {
      this.invalidcreditcarddetails = true
    } else {
      this.invalidcreditcarddetails = false

    }
  }



  changepad() {
    this.changetopad = true;
    setTimeout(() => {
      this.voidCheque1 = this.imagedisplay;
    }, 1000);
  }

  updatePadpreview() {
    this.changetopad = false;
    setTimeout(() => {
      this.voidCheque2 = this.imagedisplay;
      this.voidCheckImage = this.imagedisplay;
    }, 1000);
  }

  uploadNewVoid() {
    this.bankinfo = true;
    this.cheque = true;
    this.resetbutton = true;
    this.existVoid = false;
    if (this.padform.get('file')?.value == null) {
      this.review = false;
    }
  }

  existingVoidCheque() {
    setTimeout(() => {
      if (this.voidCheckFileType == 'application/pdf') {
        this.voidCheque2 = this.voidCheckImage;
      }
    }, 1000);
  }

  viewPadAgreement() {
    this.padView = this.padAgreement
  }

  downloadPAD(data) {
    this.http.get(data, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "PAD"
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      });
  }

  padformValid() {
    if (this.padform.invalid) {
      this.resetbutton = false;
      this.bankinfo = false;
      this.cheque = false;
      return
    }
  }

  paymentMethodFormValid() {
    if (this.paymentMethodForm.invalid) {
      this.resetButton = false;
      this.bankDetails = false;
      this.uploadCheque = false;
      return
    }
  }

  ccUpdate() {


    if (this.ccDetails.firstName == "Rakesh") {
      this.ccform.get('FirstName')?.setValue(this.customerData.firstName);
    }
    else {
      this.ccform.get('FirstName')?.setValue(this.ccDetails.firstName);
    }
    if (this.ccDetails.lastName == "Test") {
      this.ccform.get('LastName')?.setValue(this.customerData.lastName);
    }
    else {
      this.ccform.get('LastName')?.setValue(this.ccDetails.lastName);
    }

    let oldCardDetails = {
      expiry: this.expire,
      endingNumber: this.creditCardNo
    }

    // store the existing card details in the local storage
    localStorage.setItem("oldCardDetails", JSON.stringify(oldCardDetails))
  }

  changeToPAD() {
    let Endpoint = '/customer/' + this.customerid + '/paymentType/ACH/change';
    this.http.post(api.url + Endpoint, { "paymentId": 0 }, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        if (response.message == "Payment method updated successfully. Any changes related to plans and member-cards if applicable, will be reflected soon.") {
          setTimeout(() => {
          }, 40000);
        }
        let existingCreditCards = JSON.parse(sessionStorage.getItem('existingCreditCards') || '')
        if (existingCreditCards && existingCreditCards?.length > 0) {
          for (let i = 0; i < existingCreditCards.length; i++) {
            this.http.delete(api.url + `/payment/cc/${existingCreditCards[i]?.paymentMethodId0 ?? existingCreditCards[i]?.paymentMethodId}/remove`, {
              headers: {
                Authorization: 'Bearer ' + this.accessToken,
                'Content-Type': 'application/json',
              }
            })
              .subscribe((response: any) => {
                if (response.status != 200) {
                }
              })
          }
          sessionStorage.removeItem('existingCreditCards')
        }
        let defaultCreditCard = JSON.parse(sessionStorage.getItem('defaultCreditCard') || '')
        if (defaultCreditCard) {
          this.http.delete(api.url + `/payment/cc/${defaultCreditCard?.paymentMethodId0 ?? defaultCreditCard?.paymentMethodId}/remove`, {
            headers: {
              Authorization: 'Bearer ' + this.accessToken,
              'Content-Type': 'application/json',
            }
          })
            .subscribe((response: any) => {
              if (response.status != 200) {
              }
            })
          sessionStorage.removeItem('defaultCreditCard')
        }

        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
    this.bankinfo = true;
    this.resetbutton = true;
    this.cheque = false;
    this.paymentMethodForm.reset();
    this.paymentMethodForm.get('paymentmethod')?.setValue('');
    this.resetButton = false;
    this.uploadCheque = false;
    this.bankDetails = false;
    this.updatepreviewbutton = false;
    this.existVoid = true;
    this.padform.get('file')?.setValue('');
    this.voidCheckFileType = this.PADdetails.voidCheckFileType;
  }

  resolved(captchaResponse: any) {
    this.recaptchaResponse = captchaResponse;
  }

  dependentnextcard() {
    this.currentIndex = (this.currentIndex + 1) % this.childrenInfo.length;
  }

  dependentpreviouscard() {
    this.currentIndex = (this.currentIndex - 1 + this.childrenInfo.length) % this.childrenInfo.length;
  }

  getindex(i: any) {
  }


  upgradeIafgPlans() {
    this.router.navigate(['upgrade-plans'])
  }

  hasMemberData(member: any): boolean {
    return member && Object.keys(member).length > 0;
  }

  hasSpouseData(spouse: any): boolean {
    return spouse && Object.keys(spouse).length > 0;
  }

  formatNumber(number) {
    return number.toLocaleString();
  }

  filterEmptyListItems(content: string): string {
    // Create a temporary div to manipulate the HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Select all li elements and filter out empty ones
    const listItems = tempDiv.querySelectorAll('li');
    listItems.forEach((li) => {
      if (!li.textContent?.trim()) {
        li.remove(); // Remove empty <li> tags
      }
    });

    // Return the modified HTML content
    return tempDiv.innerHTML;
  }

  openVideoPopup() {
    let el: HTMLElement = this.openPopup.nativeElement;
    el.click();
  }


  openiframePopup() {
    let el: HTMLElement = this.openiframe.nativeElement;
    el.click();
  }

  openequitablePopup() {
    let el: HTMLElement = this.openequitable.nativeElement;
    el.click();
  }

  openSupportPopup() {
    let el: HTMLElement = this.opensupport.nativeElement;
    el.click();
  }

  downloadCard() {
    this.http.get(this.health_card, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = this.health_card + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
      });
  }

  onSlideChangeDependents(event: any) {

    this.currentIndexOfSwipperDependents = event[0].realIndex + 1;
    if (this.childrenInfo[event[0].realIndex].relationType == "spouse") {

      this.editSpouse = true;

      this.editChild = false;

    }

    else if (this.childrenInfo[event[0].realIndex].relationType == "child") {

      this.editSpouse = false;

      this.editChild = true;

    }

  }

  onSlideChangeDownload(event: any) {

    this.currentIndexOfSwipperDownload = event[0].realIndex + 1;

  }

  onSlideChangePlan(event: any) {

    this.currentIndexOfSwipperPlan = event[0].realIndex + 1;

  }

  onSlideChangeBenifuts(event: any) {

    this.currentIndexOfSwipperBenifits = event[0].realIndex + 1;

  }

  filterInvoices() {
    console.log('Selected filter:', this.filterInvoice);
    console.log('customerFinalInvoices:', this.customerFinalInvoices);
    console.log('customerFinalInvoicesIGBMS:', this.customerFinalInvoicesIGBMS);

    if (this.filterInvoice === 'All') {
      this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS;
      this.customerFinalInvoices = this.allCustomerFinalInvoices
      this.getCustomerDraftDate = this.getCustomerDraftDate1;
    } else {
      const selectedYear = this.filterInvoice;
      this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS.filter(invoice => {
        const dueDate = new Date(invoice.dueDate);
        return dueDate.getFullYear().toString() == selectedYear;
      });
      this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
        const dueDate = new Date(invoice.dueDate);
        return dueDate.getFullYear().toString() == selectedYear;
      });
      const draftYear = new Date(this.getCustomerDraftDate1).getFullYear().toString();
      console.log(draftYear, selectedYear)
      if (draftYear == selectedYear) {
        this.getCustomerDraftDate = this.getCustomerDraftDate1; // If it matches the selected year, keep the date
      } else {
        this.getCustomerDraftDate = ''; // Otherwise, set it to null (or any other default behavior)
      }
    }

    console.log('Filtered invoices:', this.filteredInvoices);
  }

  CustomInvoiceFilter() {
    console.log('this.filterDateSelection', this.filterDateSelection);
    if (this.filterDateSelection) {
      this.updateCustomRange();
    } else {
      console.log('No date selected');
    }
  }

  updateCustomRange() {
    const [startDate, endDate] = this.filterDateSelection.map(date => new Date(date));

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    if (isNaN(startDate) || isNaN(endDate)) {
      console.log('Invalid start or end date');
      return;
    }

    console.log('Custom date range:', startDate, 'to', endDate);

    // Filter invoices within the date range
    this.customerFinalInvoices = this.allCustomerFinalInvoices.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    this.customerFinalInvoicesIGBMS = this.allCustomerFinalInvoicesIGBMS.filter(invoice => {
      const invoiceDate = new Date(invoice.dueDate);
      invoiceDate.setHours(0, 0, 0, 0);
      return invoiceDate >= startDate && invoiceDate <= endDate;
    });

    const draftDate = new Date(this.getCustomerDraftDate1);
    draftDate.setHours(0, 0, 0, 0);
    console.log(draftDate, startDate, endDate)
    if (draftDate >= startDate && draftDate <= endDate) {
      this.getCustomerDraftDate = this.getCustomerDraftDate1;
    } else {
      this.getCustomerDraftDate = '';
    }

    $('#dropdownMenuButton').click()
  }

  onCustomClick(event: MouseEvent) {
    event.stopPropagation();
    this.filterInvoice = 'Custom';
  }


  public capitalize(str: String) {
    if (str) {
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }

  public checkDateOfBirth(event: any) {
    // Format-agnostic on purpose: this used to test /^\d{2}-\d{2}-\d{4}/, which
    // stopped matching once the pickers moved to MMM-DD-YYYY and then threw on
    // the null match. Anything the shared parser cannot read is not a date.
    const raw = event?.target?.value ?? '';
    if (raw && parseDateOnly(raw)) {
      return;
    }
    this.addressform.get('dob')?.reset();
    this.addressform.get('dob')?.markAsTouched();
  }


  handleAmountonUI(amount: any) {
    amount = parseFloat(amount);
    const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return formatted;
  }

  handleKeepDependentsToCurrent(value: any) {
    console.log("htllo",
      { enactMode: this.enactMode, specialpackages: this.specialpackages, showPlanDetails: this.showPlanDetails, isNeedToUpdate: this.isNeedToUpdate }
    )
    this.addToPolicy = value == 'open' ? 'close' : 'open';
    this.clearAllMessages();
    this.isNeedToUpdate = false;
    this.finalEffectiveDate = null;
    this.showCorpPlansTable = false;
    this.showAddToPolicyError = false;
    if (value == 'close' && this.isExcludeAll) {
      this.isExcludeChild = true;
    }


    let endPoint: any = `/customer/get-coverage-information/${this.customerid}/${this.addToPolicy == 'open' ? true : false}/${this.cobcoverage}`



    this.http.get(api.url + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        console.log(response)
        this.cobeventType = response.data.eventType == 'upgrade' ? "add" : "remove"
        this.cobevent = "spouse";


        if (response.data.needtoupdate) {
          this.isNeedToUpdate = true;
          this.needToUpdate = ''
        } else {
          this.isNeedToUpdate = false;
          this.needToUpdate = `Coverage remains unchanged.`
        }
      }
      else {
      }
    }, (error) => {
    });
  }


  handleUpdateCoverageForCob(effectiveDate: any, value: any, event: any, eventType: any, dataaaa: any) {
    console.log(dataaaa, "dataaaa")
    const startOfCurrentMonth = moment(effectiveDate).startOf('month');
    const formattedDate = startOfCurrentMonth.format('MMMM Do'); // Format for "April 1st"
    if (!this.isCorporateAccount) {
      this.processPackagesV2(dataaaa, formattedDate)
    } else {
      this.processPackagesForCorp(dataaaa, formattedDate)
    }
  }

  handleAddToPolicyV2(effectiveDate: any, value: any, event: any, eventType: any) {
    this.currentamount = 0;
    this.upcomingamount = 0;
    this.notInitialLoad = false
    this.addToPolicy = value;
    this.showAddToPolicyError = false;
    this.underWritingMessage1 = '';
    this.underWritingMessage2 = '';
    this.corpMessage = '';
    this.secondMessage = '';
    this.firstMessage = '';
    this.firstConfirmMessage = '';
    this.secondConfirmMessage = '';
    this.clearAllMessages();
    // call the api

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }
    let childCovered = 'none'
    let childCoveredCount = 0;
    let existingSpouseBefore: any = {};
    let existingChildrenBefore: any = [];
    if (this.availableFirstNames && this.availableFirstNames.length > 0) {
      existingSpouseBefore = this.availableFirstNames.find(item => item.relationType == 'spouse');
      existingChildrenBefore = this.availableFirstNames.filter(item => item.relationType != 'spouse');
    }
    if (existingChildrenBefore && existingChildrenBefore.length > 0) {
      for (const cd of existingChildrenBefore) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (existingChildrenBefore.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    let endPoint: any
    if (!this.isCorporateAccount) {
      endPoint = `/customer/${this.customerid}/customerPlans/${event}/${eventType}`
    } else {
      endPoint = `/customer/v2/${this.customerid}/customerPlans/${event}/${eventType}`
    }
    let payload = {
      enrollmentDate: moment(effectiveDate).format('YYYY-MM-DD'),
      spouseCovered: true,
      removeRoleBasedPlans: false,
      childCovered: childCovered,
      totalCount: existingChildrenBefore.length,
      isIncluded: true
    }

    console.log({ payload })

    let dataaaa: any;
    this.http.post(api.url + endPoint, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.handleContinue(response)
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        this.initialCoverage = this.currentCoverage(this.coverageChange)
        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }
        this.provisioningSites = prsStatus.toString() ?? ""

        console.log("calledoooo")
        this.isSpecialCondition = response?.data?.isSpecialCondition ?? false;
        console.log(this.normalDependentRegistration, this.normalSpouseRegistration)
        let data__ = response?.data?.packages
        dataaaa = response
        this.initialData = dataaaa;

        const startOfCurrentMonth = moment(effectiveDate).startOf('month');
        const formattedDate = startOfCurrentMonth.format('MMMM Do'); // Format for "April 1st"

        if (!this.isCorporateAccount) {
          console.log("this processpackage1")
          this.processPackages(dataaaa, formattedDate)
        } else {
          this.processPackagesForCorp(dataaaa, formattedDate)
        }

      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
    });


  }

  handleEffectiveDateChange() {
    this.childrenDetailsForNormalReg = []
    this.childrenApprovalNeed = []
    if (this.addToPolicy === null || this.addToPolicy == '' || this.addToPolicy == undefined) {
      this.showAddToPolicyError = true;
      this.finalEffectiveDate = null;
      this.clearAllMessages();
      return;
    }
    this.isNeedToUpdate = true;
    this.showPlanDetails = true;
    this.notInitialLoad = false;

    this.currentamount = 0;
    this.upcomingamount = 0;
    this.showAddToPolicyError = false;
    this.underWritingMessage1 = '';
    this.underWritingMessage2 = '';
    this.corpMessage = '';
    this.secondMessage = '';
    this.firstMessage = '';
    this.firstConfirmMessage = '';
    this.secondConfirmMessage = '';
    // call the api

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (this.totalCount == 0) {
      this.totalCount = this.totalCount + 1;
    }
    let childCovered = 'none'
    let childCoveredCount = 0;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      for (const cd of this.childrenDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.childrenDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'

      }
    }


    if ((this.coveredByAnotherPlan == "close" || !this.coveredByAnotherPlan) && childCovered == 'none') {
      this.isNeedToUpdate = false;
    }

    let endPoint: any
    if (!this.isCorporateAccount) {
      endPoint = `/customer/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
    } else {
      endPoint = `/customer/v2/${this.customerid}/customerPlans/${this.dependentType == 'child' ? 'dependent' : this.dependentType}/add`
    }
    let enrollmentDate: any;
    if (this.childrenDetails && this.childrenDetails.length > 0) {
      enrollmentDate = this.childrenDetails[0]
    }
    let payload = {
      enrollmentDate: moment(this.finalEffectiveDate).format('YYYY-MM-DD'),
      spouseCovered: this.coveredByAnotherPlan == 'open' ? true : false,
      removeRoleBasedPlans: false,
      childCovered: childCovered,
      totalCount: this.childrenDetails.length - 1,
      totalCountIncluded: this.childrenDetails.length,
      isIncluded: this.addToPolicy == 'open' ? true : false
    }


    if (this.childrenDetails && this.childrenDetails.length > 0) {

      this.childrenDetails.map((child: any) => {
        const dob = moment(parseDateOnly(child.dob));
        const today = moment();
        const daysDiff = today.diff(dob, 'days');

        let approvalNeeded = false;

        // Check backdated DOB (> 30 days ago)
        if (daysDiff > 30) {
          approvalNeeded = true;
        }

        // Additional special needs check
        if (child.specialNeeds) {
          approvalNeeded = true;
        }

        if (this.addToPolicy == 'close') {
          approvalNeeded = false;
        }


        // Format and assign DOB

        // Final backdated flag per child
        if (!approvalNeeded) {
          this.childrenDetailsForNormalReg.push(child)
        } else {
          this.childrenApprovalNeed.push(child)
        }
      });

    }


    console.log(this.childrenApprovalNeed)

    if (this.childrenApprovalNeed.length == this.childrenDetails.length) {
      payload.totalCount = this.childrenDetails.length
    } else {
      if (this.childrenApprovalNeed.length > 0) {
        payload.totalCount = Math.abs(this.childrenDetails.length - this.childrenApprovalNeed.length);
      }
    }

    if (!this.isCorporateAccount && this.dependentType == 'child') {
      if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.childrenDetailsForNormalReg.length > 0) {
        payload.totalCount = this.childrenDetailsForNormalReg.length;
        payload.totalCountIncluded = this.childrenDetails.length;
      } else {
        payload.totalCount = this.childrenDetails.length;
        payload.totalCountIncluded = this.childrenDetails.length;
      }
    }

    if (this.isCorporateAccount && this.dependentType == 'child') {
      if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.childrenDetailsForNormalReg.length > 0) {
        payload.totalCount = this.childrenDetailsForNormalReg.length;
        payload.totalCountIncluded = this.childrenDetails.length;
      } else {
        payload.totalCount = this.childrenDetails.length;
        payload.totalCountIncluded = this.childrenDetails.length;
      }
    }
    console.log(this.childrenDetailsForNormalReg)
    console.log(this.dependentType)
    if (this.dependentType == 'multiple') {
      if (this.childrenDetails.length > 0) {
        if (!this.normalSpouseRegistration) {
          if (this.childrenDetailsForNormalReg.length <= 1) {
            payload.totalCount = this.childrenDetailsForNormalReg.length - 1;
            payload.totalCountIncluded = this.childrenDetails.length;
          }
          if (this.childrenDetailsForNormalReg.length > 1) {
            payload.totalCount = this.childrenDetailsForNormalReg.length;
            payload.totalCountIncluded = this.childrenDetails.length;
          } else {
            payload.totalCount = this.childrenDetails.length;
            payload.totalCountIncluded = this.childrenDetails.length;
          }
        } else {
          payload.totalCount = this.childrenDetailsForNormalReg.length;
          payload.totalCountIncluded = this.childrenDetails.length;
        }
      }
    }

    console.log({ payload })

    let dataaaa: any;

    if (this.addToPolicy == 'open' || this.enactMode == 'cob') {
      this.http.post(api.url + endPoint, payload, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.status == 200) {
          this.handleContinue(response)
          console.log(response?.data, 'asda')

          this.coverageChange = response?.data?.coverageChange;
          this.initialCoverage = this.currentCoverage(this.coverageChange)
          console.log(this.initialCoverage, "aosodoo")
          this.coverageChange2 = response?.data?.coverageChange2;
          this.isSpecialCondition = response?.data?.isSpecialCondition ?? false;
          this.maxEnrollmentDate = response?.data?.maxEnrollmentDate;
          this.customerOldPlans = response?.data?.customerPlans;

          let prs = response?.data?.gsOrEqMemberStatus ?? {}
          let prsStatus: any = []
          const prsKeys = Object.keys(prs);
          if (prsKeys.length > 0) {
            for (const prk of prsKeys) {
              if (prs[prk] == true) {
                if (prk == 'greenShildCustomer') {
                  prsStatus.push('GreenShield')
                }
                if (prk == 'hcdSecuremePlans') {
                  prsStatus.push('HCD Secureme')
                }
                if (prk == 'equitableCustomer') {
                  prsStatus.push('Equitable')
                }
                if (prk == 'phrCustomer') {
                  prsStatus.push('PHR')
                }
                if (prk == 'waddelCustomer') {
                  prsStatus.push('Waddel')
                }
              }
            }
          }
          this.provisioningSites = prsStatus.toString() ?? ""

          console.log("calledoooo")
          console.log(this.normalDependentRegistration, this.normalSpouseRegistration)
          let data__ = response?.data?.packages
          dataaaa = response
          this.initialData = dataaaa;


          let ecDate = this.finalEffectiveDate
          const startOfCurrentMonth = moment(ecDate).startOf('month');
          const formattedDate = startOfCurrentMonth.format('MMMM Do'); // Format for "April 1st"

          if (!this.isCorporateAccount) {
            console.log("this processpackage2")
            this.processPackages(dataaaa, formattedDate)
          } else {
            this.processPackagesForCorp(dataaaa, formattedDate)
          }

        }
        else {
          this.finalEffectiveDate = null;
          Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        }
      }, (error) => {
      });
    }
  }

  handleAddToPolicy(value: any) {
    console.log("called")
    this.finalEffectiveDate = null;
    this.clearAllMessages()
    this.showCorpPlansTable = false;
    this.addToPolicy = value;
    if (value == 'close') {
      this.showPlanDetails = false;
    }
  }


  onDependentChange(e: any) {
    this.normalDependentDeletion = false;
    console.log(this.selectedDepId, "selectedDepId")
    this.isSpouseSelected = this.availableFirstNames.find(item => item.id == e.target.value && item.relationType == 'spouse')
    this.isChildSelected = this.availableFirstNames.find(item => item.id == e.target.value && item.relationType != 'spouse')
    console.log(this.isSpouseSelected, this.isChildSelected)
    if (!!this.isSpouseSelected) {
      this.dependentType = 'spouse'
      if (this.isSpouseSelected.addedToPolicy == "false") {
        this.normalDependentDeletion = true;
      }
    } if (!!this.isChildSelected) {
      this.dependentType = 'child'
      if (this.isChildSelected.addedToPolicy == "false") {
        this.normalDependentDeletion = true;
      }
    }
  }

  onEffectiveDateChange() {
    if (this.finalEffectiveDate != null) {

      console.log(this.enactMode)
      if (this.enactMode == 'delete') {
        if (this.deleteForm.invalid) {
          this.finalEffectiveDate = null
          this.deleteForm.markAllAsTouched()
          return;
        }
      }

      console.log(this.finalEffectiveDate, "avalue")
      if (this.enactMode == 'cob') {
        // call the cob related changes
        const date1 = moment(this.finalEffectiveDate).format('MM-DD-YYYY'); // First date
        const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
        const differenceInDays = date2.diff(date1, 'days');
        console.log(differenceInDays, "differenceInDays8899")
        if (differenceInDays <= 30) {
          this.normalSpouseRegistration = true;
        } else {
          this.normalSpouseRegistration = false;
        }

        if (this.isNeedToUpdate) {

          this.handleAddToPolicyV2(this.finalEffectiveDate, this.addToPolicy, this.cobevent, this.cobeventType)
        }
        return;
      }

      this.currentamount = 0;
      this.upcomingamount = 0;
      this.showAddToPolicyError = false;
      console.log(this.finalEffectiveDate)


      const childDateFormatted = this.datePipe.transform(this.finalEffectiveDate, 'MM-dd-yyyy');
      const date1 = moment(childDateFormatted, "MM-DD-YYYY"); // First date
      const date2 = moment(moment(new Date()), "MM-DD-YYYY"); // Second date
      console.log(this.maritalStatus, this.isCommonLaw);

      const differenceInDays = date2.diff(date1, 'days');
      console.log('differenceInDays', differenceInDays);




      // call the api

      sessionStorage.removeItem("plansummarymain")
      sessionStorage.removeItem("plansskumain");
      sessionStorage.removeItem("plansummaryopt");
      sessionStorage.removeItem("plansummary");
      sessionStorage.removeItem("selectedPlans");
      sessionStorage.removeItem("totalAmount");
      sessionStorage.removeItem("totalAmountUI");

      if (this.totalCount == 0) {
        this.totalCount = this.totalCount + 1;
      }
      let childCovered = 'none'
      let childCoveredCount = 0;
      if (this.childrenDetails && this.childrenDetails.length > 0) {
        for (const cd of this.childrenDetails) {
          if (cd.coveredByAnotherPlan == true) {
            childCoveredCount++;
          }
        }

        if (this.childrenDetails.length == childCoveredCount) {
          childCovered = 'full'
        } else {
          childCovered = 'partial'
        }


        if (childCoveredCount == 0) {
          childCovered = 'none'
        }
      }

      let endPoint: any
      if (!this.isCorporateAccount) {
        endPoint = `/customer/${this.customerid}/customerPlans/${this.isSpouseSelected ? 'spouse' : 'child'}/remove`
      } else {
        endPoint = `/customer/v2/${this.customerid}/customerPlans/${this.isSpouseSelected ? 'spouse' : 'child'}/remove`
      }
      let payload = {
        enrollmentDate: moment(this.finalEffectiveDate).format('YYYY-MM-DD'),
        spouseCovered: this.coveredByAnotherPlan == 'open' ? true : false,
        removeRoleBasedPlans: false,
        childCovered: childCovered,
        totalCount: this.childrenDetails.length,
        isIncluded: true
      }

      console.log({ payload })

      let dataaaa: any;

      if (!!this.isSpouseSelected) {
        if (differenceInDays <= 30) {
          this.isSpouseSelected.isBackdated = false;
        } else {
          this.isSpouseSelected.isBackdated = true;
        }
        this.isSpouseSelected.dateOfMarriage = moment(this.finalEffectiveDate).format('YYYY-MM-DD')
      } if (!!this.isChildSelected) {
        if (differenceInDays <= 30) {
          this.isChildSelected.isBackdated = false;
        } else {
          this.isChildSelected.isBackdated = true;
        }
        this.isChildSelected.dob = moment(this.finalEffectiveDate).format('YYYY-MM-DD')
      }

      if (this.finalEffectiveDate) {
        this.http.post(api.url + endPoint, payload, {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((response: any) => {
          if (response.status == 200) {
            this.handleContinue(response)
            console.log(response?.data, 'asda')
            this.coverageChange = response?.data?.coverageChange;
            let prs = response?.data?.gsOrEqMemberStatus ?? {}
            let prsStatus: any = []
            const prsKeys = Object.keys(prs);
            if (prsKeys.length > 0) {
              for (const prk of prsKeys) {
                if (prs[prk] == true) {
                  if (prk == 'greenShildCustomer') {
                    prsStatus.push('GreenShield')
                  }
                  if (prk == 'hcdSecuremePlans') {
                    prsStatus.push('HCD Secureme')
                  }
                  if (prk == 'equitableCustomer') {
                    prsStatus.push('Equitable')
                  }
                  if (prk == 'phrCustomer') {
                    prsStatus.push('PHR')
                  }
                  if (prk == 'waddelCustomer') {
                    prsStatus.push('Waddel')
                  }
                }
              }
            }
            this.provisioningSites = prsStatus.toString() ?? ""

            console.log("calledoooo")
            let data__ = response?.data?.packages
            dataaaa = response
            this.initialCoverage = this.currentCoverage(this.coverageChange)

            const startOfCurrentMonth = moment().startOf('month');
            const formattedDate = moment(this.finalEffectiveDate).format('MMMM Do'); // Format for "April 1st"

            if (!this.isCorporateAccount) {
              console.log("this processpackage3")
              this.processPackages(dataaaa, formattedDate)
            } else {
              this.processPackagesForCorp(dataaaa, formattedDate)
            }

          }
          else {
            this.finalEffectiveDate = null
            Swal.fire({ allowOutsideClick: false, title: "Info", text: response.message })
          }
        }, (error) => {
        });
      }

    }
  }



  coveragetext(coverage) {
    let text = ''
    switch (coverage) {
      case 'STC':
      default:
        text = 'from Single to Couple';
        break;
      case 'STF':
        text = 'from Single to Family';
        break;
      case 'CTF':
        text = 'from Couple to Family';
        break;
      case 'CTS':
        text = 'from Couple to Single';
        break;
      case 'FTS':
        text = 'from Family to Single';
        break;
      case 'FTC':
        text = 'from Family to Couple';
        break;
      case 'F':
        text = 'to Family';
        break;
    }

    return text;
  }

  maritalStatusText(coverage) {
    let text = ''
    switch (coverage) {
      case 'STC':
      default:
        text = 'Couple';
        break;
      case 'STF':
        text = 'Family';
        break;
      case 'CTF':
        text = 'Family';
        break;
      case 'CTS':
        text = 'Single';
        break;
      case 'FTS':
        text = 'Single';
        break;
      case 'FTC':
        text = 'Couple';
        break;
      case 'F':
        text = 'Family';
        break;
    }

    return text;
  }

  maritalStatusTextNext(coverage) {
    let text = ''
    switch (coverage) {
      case 'STC':
      default:
        text = 'FAMILY';
        break;
      case 'STF':
        text = 'FAMILY';
        break;
      case 'CTF':
        text = 'FAMILY';
        break;
      case 'FTS':
        text = 'SINGLE';
        break;
      case 'CTS':
        text = 'SINGLE';
        break;
      case 'FTC':
        text = 'FAMILY';
        break;
      case 'F':
        text = 'FAMILY';
        break;
    }

    return text;
  }

  currentCoverage(coverage) {
    let text = ''
    switch (coverage) {
      case 'STC':
      default:
        text = 'Single';
        break;
      case 'STF':
        text = 'Single';
        break;
      case 'CTF':
        text = 'Couple';
        break;
      case 'CTS':
        text = 'Couple';
        break;
      case 'FTS':
        text = 'Family';
        break;
      case 'FTC':
        text = 'Family';
        break;
      case 'F':
        text = 'Family';
        break;
    }

    return text;
  }


  // Process packages and create plan details objects
  processPackages(dataaaa: any, formattedDate: string) {
    this.proceedDeleteButtonDisabled = true;
    this.clearAllMessages();
    this.isDirectUpdate = false;
    this.currentamount = 0;
    this.currentamountUI = 0;
    this.backdatedamount = 0;
    this.backdatedamountUI = 0;
    this.specialConditionMessage = ''
    this.upcomingamount = 0;
    this.upcomingamountUI = 0;
    this.effectedPackages = [];
    let epa: any = []
    this.effectedPackageNames = [];
    this.obj1 = [];
    let prevVersionPackage: any = []

    const COUPLE_SAMEAS_FAMILY_PLANLEVELS = [10, 31, 40, 58, 59];

    let getUpdatingCoverage = this.maritalStatusText(this.coverageChange)?.toUpperCase() ?? "COUPLE";

    // first check the existing coverage for customer
    setTimeout(() => {
      this._LoaderService.show();
      let coverages = ['SINGLE', 'COUPLE', 'FAMILY']

      const dom: HTMLElement = this.elementRef.nativeElement;

      let planSummMain: any = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
      console.log(planSummMain, "planSummMain")
      if (planSummMain?.length > 0) {
        for (const psm of planSummMain) {
          if (COUPLE_SAMEAS_FAMILY_PLANLEVELS.includes(psm.planLevel)) {
            getUpdatingCoverage = this.maritalStatusTextNext(this.coverageChange)?.toUpperCase() ?? "COUPLE";
            console.log(getUpdatingCoverage)
            if (psm.isBundle) {
              const selector = `#plancheck${psm.id}.coverage${getUpdatingCoverage}`;
              console.log(`Selector: '${selector}'`);
              const selectedElement = dom.querySelectorAll(selector);
              console.log("accessed", selectedElement)
              setTimeout(function () {
                $(selectedElement).click();
              }, 1000);
            } else {
              if (psm.coverage && psm.coverage !== '-') {
                $(`#plancheck${psm.planLevel}.coverage${psm.coverage}`).click();
              } else {
                $(`#plancheck${psm.planLevel}`).click();
              }
            }
          }
        }
      }

      // Wait for click handlers to update sessionStorage
      setTimeout(() => {
        for (const package_ of dataaaa.data.customerPlans) {
          this.currentamount += package_.total;
        }

        console.log(this.isSpecialCondition, "this.isSpecialCondition12778")
        if (this.isSpecialCondition) {
          this.currentamount = 0;
          this.specialConditionMessage = 'There are upcoming coverage changes due to recent life events. Please ensure that the appropriate coverage level is updated based on the effective dates of these changes. \n Kindly contact your administrator to handle the updates manually through the underwriting queue in the admin portal.'
        }

        for (const package_ of dataaaa.data.activeButCancelledInFuturePlans) {
          if (this.isSpecialCondition) {
            this.currentamount += package_.total;
          }
        }

        for (const package_ of dataaaa.data.packages) {
          console.log(package_, 'Current Package');

          // Process each group in the package
          Object.keys(package_.groups).forEach(groupKey => {
            const groups = package_.groups[groupKey];

            groups.forEach(group => {
              group.plans.forEach(plan => {
                console.log(plan.isBundle, "Is Bundled Plan");

                // Process each product in the plan
                plan.productAddonssNames.forEach(product => {
                  if (!plan.productAddonss[product]) return;
                  const coverages = ['SINGLE', 'COUPLE', 'FAMILY']
                  const msCurrent = this.currentCoverage(this.coverageChange)
                  const msNext = this.maritalStatusText(this.coverageChange)
                  const productAddons = plan.productAddonss[product];
                  let selectedAddons: any = [];
                  let unselectedAddons: any = [];
                  for (const paon of productAddons) {
                    if (paon) {
                      if (paon.selected900 && paon.planCoverage == msCurrent.toUpperCase()) {
                        selectedAddons.push(paon);
                      } else if (!paon.selected900) {
                        if (!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage == msNext.toUpperCase()) {
                          unselectedAddons.push(paon);
                        } else if (!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()) {
                          continue
                        } else {
                          unselectedAddons.push(paon);
                        }
                      } else {
                        if (paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage == msNext.toUpperCase()) {
                          unselectedAddons.push(paon);
                        } else if (paon.selected900 && !coverages.includes(paon.planCoverage) && paon.planCoverage != msCurrent.toUpperCase()) {
                          selectedAddons.push(paon);
                        } else if (!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()) {
                          continue;
                        } else if (paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()) {
                          continue;
                        } else {
                          unselectedAddons.push(paon);
                        }
                      }
                    }
                  }

                  const selectedAddons_ = productAddons.filter((item: any) => item.selected900);
                  const unselectedAddons_ = productAddons.filter((item: any) => !item.selected900);
                  console.log(selectedAddons, "selectedAddons")
                  console.log(unselectedAddons, "unselectedaddonns")
                  // Process selected addons
                  // Process unselected addons
                  if (unselectedAddons.length > 0) {
                    if (coverages.includes(unselectedAddons[0].planCoverageUI.toUpperCase())) {
                      this.effectedPackages.push(unselectedAddons[0]);
                      epa.push(unselectedAddons[0])
                      this.effectedPackageNames.push(product);
                      console.log('Selected Addon:', selectedAddons[0]);
                      console.log('Unselected Addon Price:', unselectedAddons[0].price);
                      this.upcomingamount += unselectedAddons[0].calculatedTax.total;
                    }
                  } else if (selectedAddons.length > 0) {
                    if (coverages.includes(selectedAddons[0].planCoverageUI.toUpperCase())) {
                      console.log("nothing already covered");
                      this.upcomingamount += selectedAddons[0].calculatedTax.total;
                    } else {
                      this.effectedPackages.push(selectedAddons[0]);
                      epa.push(selectedAddons[0])
                      this.upcomingamount += selectedAddons[0].calculatedTax.total;
                    }
                  }

                });

              });
            });
          });

          console.log(this.effectedPackages, 'Effected Packages');
        }

        //Effective July 1st, your premium will be adjusted from $543.13 to $711.43. It will be reflected in your July invoice.
        console.log(this.upcomingamount, this.currentamount)
        this.upcomingamountUI = this.handleAmountonUI(Math.abs(this.upcomingamount).toFixed(2))
        if (this.enactMode == 'add' && this.coverageChange == 'F') {
          this.currentamount = this.upcomingamount
        }
        this.currentamountUI = this.handleAmountonUI(Math.abs(this.currentamount).toFixed(2))
        if (this.upcomingamount != this.currentamount || this.isSpecialCondition) {
          this.firstConfirmMessage = `Your marital status has been changed ${this.coveragetext(this.coverageChange)}.`;

          // check child
          this.backdatedDependentsChild = []
          this.backdatedDependentsSpouse = []
          let spouseDetails = this.spouseform.value;
          let childrenDetails = this.childrenDetails;

          console.log(spouseDetails, childrenDetails)

          if (this.childrenDetails && this.childrenDetails.length > 0) {
            this.childrenDetails.forEach((child: any) => {
              const dob = moment(parseDateOnly(child.dob));
              const today = moment();
              const daysDiff = today.diff(dob, 'days');

              let approvalNeeded = false;

              // Check backdated DOB (> 30 days ago)
              if (daysDiff > 30) {
                approvalNeeded = true;
              }

              // Additional special needs check
              if (child.specialNeeds) {
                approvalNeeded = true;
              }

              if (approvalNeeded) {
                this.backdatedDependentsChild.push(child)
              }
            });

          }

          if (!this.normalSpouseRegistration) {
            this.backdatedDependentsSpouse.push(spouseDetails)
          }
          const inputDate = moment(this.finalEffectiveDate);
          const today = moment().startOf('day');
          const isBackdated = inputDate.isBefore(today);
          if (isBackdated) {
            this.handleCalculateBackdatedPrice();
          }
          console.log(this.upcomingamount, this.backdatedamount)
          console.log(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount))
          let sumAmount: any = this.handleAmountonUI(Math.abs(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount)).toFixed(2))
          console.log(this.backdatedDependentsChild)
          console.log(this.childrenDetailsForNormalReg, "8899childrendetails")

          let splitPackages: any = [];
          if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.coverageChange != this.coverageChange2) {
            splitPackages = this.splitPackages();
          }
          if (!this.normalSpouseRegistration && this.coverageChange != this.coverageChange2) {
            splitPackages = this.splitPackages();
          }

          if (this.normalDependentRegistration && this.normalSpouseRegistration) {


            if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length) {
              // means one or more dependent is not covered
              this.underwritingHeading = `Your reporting of a life event change includes dependents both within and outside the ${(this.maritalStatus == 'married' || this.dependentType == 'child') ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
              if (this.coverageChange != this.coverageChange2) {
                this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
              }

            }

            this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
            this.secondConfirmMessage = `Your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI} (Including Taxes).`;
            if (this.backdatedamount > 0) {
              this.secondConfirmMessage = `Your premium for plans will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}) (Including Taxes).`;
            }
            if (this.backdatedDependentsChild && this.backdatedDependentsChild.length > 0) {
              let fullNames = this.backdatedDependentsChild.map(item => item.fullName);
              this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
              if (this.maritalStatus == 'married') {
                this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
              } else {
                this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
              }
              this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
            }
          } else {
            console.log(this.marriageType, 'this.marriageType8888')
            if (this.maritalStatus == 'married') {
              this.secondConfirmMessage = `Your reporting of life event change is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
            } else {
              this.secondConfirmMessage = `Your reporting of life event change is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
            }


            let fullNames: any = [];
            if (this.backdatedDependentsChild.length > 0) {
              fullNames = this.backdatedDependentsChild.map(item => item.fullName);
            }
            if (this.backdatedDependentsSpouse.length > 0) {
              fullNames.push(this.backdatedDependentsSpouse[0].fullName)
            }

            if (fullNames && fullNames.length > 0) {
              if (this.maritalStatus == 'married' || this.dependentType == 'child') {
                this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
              } else {
                this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
              }
            }




            if (splitPackages.length > 0) {
              this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(splitPackages[0])}.`
              this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(splitPackages[0])}.`;
              this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`

            } else {
              this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)}.`
              this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
            }

            this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
          }
          this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
          if (this.backdatedamount > 0) {
            this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI})(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
          }
          if (this.underWritingMessage2) {
            this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice once admin approves.`
          }
          this.upcomingamount = Math.abs(this.upcomingamount).toFixed(2)
        } else {
          this.addToPolicy = 'close';
          this.showPlanDetails = false;
          this.isDirectUpdate = true;
          this.firstMessage = `No need to update the coverage, as it is already included under the current plan.`
        }

        this.notInitialLoad = true;
        this._LoaderService.hide();
        this.proceedDeleteButtonDisabled = false;
      }, 2000); // wait 800ms for session update — adjust if needed

    }, 6000); // initial delay




    console.log(this.selectedPlans_, 'Selected Plans');
    console.log(this.unSelectedPlans_, 'Unselected Plans');
  }

  processPackagesV2(dataaaa: any, formattedDate: string) {
    this.proceedDeleteButtonDisabled = true;
    this.isNeedToUpdate = true
    this.clearAllMessages();
    this.isDirectUpdate = false;
    this.currentamount = 0;
    this.currentamountUI = 0;
    this.backdatedamount = 0;
    this.backdatedamountUI = 0;
    this.specialConditionMessage = ''
    this.upcomingamount = 0;
    this.upcomingamountUI = 0;
    this.effectedPackages = [];
    let epa: any = []
    this.effectedPackageNames = [];
    this.obj1 = [];
    let prevVersionPackage: any = []

    const COUPLE_SAMEAS_FAMILY_PLANLEVELS = [10, 31, 40, 58, 59];

    let getUpdatingCoverage = this.maritalStatusText(this.coverageChange)?.toUpperCase() ?? "COUPLE";

    // first check the existing coverage for customer

    this._LoaderService.show();
    let coverages = ['SINGLE', 'COUPLE', 'FAMILY']

    const dom: HTMLElement = this.elementRef.nativeElement;

    let planSummMain: any = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
    console.log(planSummMain, "planSummMain")
    if (planSummMain?.length > 0) {
      for (const psm of planSummMain) {
        if (COUPLE_SAMEAS_FAMILY_PLANLEVELS.includes(psm.planLevel)) {
          getUpdatingCoverage = this.maritalStatusTextNext(this.coverageChange)?.toUpperCase() ?? "COUPLE";
          console.log(getUpdatingCoverage)
          if (psm.isBundle) {
            const selector = `#plancheck${psm.id}.coverage${getUpdatingCoverage}`;
            console.log(`Selector: '${selector}'`);
            const selectedElement = dom.querySelectorAll(selector);
            console.log("accessed", selectedElement)
            setTimeout(function () {
              $(selectedElement).click();
            }, 1000);
          } else {
            if (psm.coverage && psm.coverage !== '-') {
              $(`#plancheck${psm.planLevel}.coverage${psm.coverage}`).click();
            } else {
              $(`#plancheck${psm.planLevel}`).click();
            }
          }
        }
      }
    }


    for (const package_ of dataaaa.data.customerPlans) {
      this.currentamount += package_.total;
    }

    console.log(this.isSpecialCondition, "this.isSpecialCondition12778")
    if (this.isSpecialCondition) {
      this.currentamount = 0;
      this.specialConditionMessage = 'There are upcoming coverage changes due to recent life events. Please ensure that the appropriate coverage level is updated based on the effective dates of these changes. \n Kindly contact your administrator to handle the updates manually through the underwriting queue in the admin portal.'
    }

    for (const package_ of dataaaa.data.activeButCancelledInFuturePlans) {
      if (this.isSpecialCondition) {
        this.currentamount += package_.total;
      }
    }

    for (const package_ of dataaaa.data.packages) {
      console.log(package_, 'Current Package');

      // Process each group in the package
      Object.keys(package_.groups).forEach(groupKey => {
        const groups = package_.groups[groupKey];

        groups.forEach(group => {
          group.plans.forEach(plan => {
            console.log(plan.isBundle, "Is Bundled Plan");

            // Process each product in the plan
            plan.productAddonssNames.forEach(product => {
              if (!plan.productAddonss[product]) return;
              const coverages = ['SINGLE', 'COUPLE', 'FAMILY']
              const msCurrent = this.currentCoverage(this.coverageChange)
              const msNext = this.maritalStatusText(this.coverageChange)
              const productAddons = plan.productAddonss[product];
              let selectedAddons: any = [];
              let unselectedAddons: any = [];
              for (const paon of productAddons) {
                if (paon) {
                  if (paon.selected900 && paon.planCoverage == msCurrent.toUpperCase()) {
                    selectedAddons.push(paon);
                  } else if (!paon.selected900) {
                    if (!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage == msNext.toUpperCase()) {
                      unselectedAddons.push(paon);
                    } else if (!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()) {
                      continue
                    } else {
                      unselectedAddons.push(paon);
                    }
                  } else {
                    if (paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage == msNext.toUpperCase()) {
                      unselectedAddons.push(paon);
                    } else if (paon.selected900 && !coverages.includes(paon.planCoverage) && paon.planCoverage != msCurrent.toUpperCase()) {
                      selectedAddons.push(paon);
                    } else if (!paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()) {
                      continue;
                    } else if (paon.selected900 && coverages.includes(paon.planCoverage) && paon.planCoverage != msNext.toUpperCase()) {
                      continue;
                    } else {
                      unselectedAddons.push(paon);
                    }
                  }
                }
              }

              const selectedAddons_ = productAddons.filter((item: any) => item.selected900);
              const unselectedAddons_ = productAddons.filter((item: any) => !item.selected900);
              console.log(selectedAddons, "selectedAddons")
              console.log(unselectedAddons, "unselectedaddonns")
              // Process selected addons
              // Process unselected addons
              if (unselectedAddons.length > 0) {
                if (coverages.includes(unselectedAddons[0].planCoverageUI.toUpperCase())) {
                  this.effectedPackages.push(unselectedAddons[0]);
                  epa.push(unselectedAddons[0])
                  this.effectedPackageNames.push(product);
                  console.log('Selected Addon:', selectedAddons[0]);
                  console.log('Unselected Addon Price:', unselectedAddons[0].price);
                  this.upcomingamount += unselectedAddons[0].calculatedTax.total;
                }
              } else if (selectedAddons.length > 0) {
                if (coverages.includes(selectedAddons[0].planCoverageUI.toUpperCase())) {
                  console.log("nothing already covered");
                  this.upcomingamount += selectedAddons[0].calculatedTax.total;
                } else {
                  this.effectedPackages.push(selectedAddons[0]);
                  epa.push(selectedAddons[0])
                  this.upcomingamount += selectedAddons[0].calculatedTax.total;
                }
              }

            });

          });
        });
      });

      console.log(this.effectedPackages, 'Effected Packages');
    }

    //Effective July 1st, your premium will be adjusted from $543.13 to $711.43. It will be reflected in your July invoice.
    console.log(this.upcomingamount, this.currentamount)
    this.upcomingamountUI = this.handleAmountonUI(Math.abs(this.upcomingamount).toFixed(2))
    if (this.enactMode == 'add' && this.coverageChange == 'F') {
      this.currentamount = this.upcomingamount
    }
    this.currentamountUI = this.handleAmountonUI(Math.abs(this.currentamount).toFixed(2))
    if (this.upcomingamount != this.currentamount || this.isSpecialCondition) {
      this.firstConfirmMessage = `Your marital status has been changed ${this.coveragetext(this.coverageChange)}.`;

      // check child
      this.backdatedDependentsChild = []
      this.backdatedDependentsSpouse = []
      let spouseDetails = this.spouseform.value;
      let childrenDetails = this.childrenDetails;

      console.log(spouseDetails, childrenDetails)

      if (this.childrenDetails && this.childrenDetails.length > 0) {
        this.childrenDetails.forEach((child: any) => {
          const dob = moment(parseDateOnly(child.dob));
          const today = moment();
          const daysDiff = today.diff(dob, 'days');

          let approvalNeeded = false;

          // Check backdated DOB (> 30 days ago)
          if (daysDiff > 30) {
            approvalNeeded = true;
          }

          // Additional special needs check
          if (child.specialNeeds) {
            approvalNeeded = true;
          }

          if (approvalNeeded) {
            this.backdatedDependentsChild.push(child)
          }
        });

      }

      if (!this.normalSpouseRegistration) {
        this.backdatedDependentsSpouse.push(spouseDetails)
      }
      const inputDate = moment(this.finalEffectiveDate);
      const today = moment().startOf('day');
      const isBackdated = inputDate.isBefore(today);
      if (isBackdated) {
        this.handleCalculateBackdatedPrice();
      }
      console.log(this.upcomingamount, this.backdatedamount)
      console.log(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount))
      let sumAmount: any = this.handleAmountonUI(Math.abs(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount)).toFixed(2))
      console.log(this.backdatedDependentsChild)
      console.log(this.childrenDetailsForNormalReg, "8899childrendetails")

      let splitPackages: any = [];
      if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.coverageChange != this.coverageChange2) {
        splitPackages = this.splitPackages();
      }
      if (!this.normalSpouseRegistration && this.coverageChange != this.coverageChange2) {
        splitPackages = this.splitPackages();
      }

      if (this.normalDependentRegistration && this.normalSpouseRegistration) {


        if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length) {
          // means one or more dependent is not covered
          this.underwritingHeading = `Your reporting of a life event change includes dependents both within and outside the ${(this.maritalStatus == 'married' || this.dependentType == 'child') ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
          if (this.coverageChange != this.coverageChange2) {
            this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
          }

        }

        this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
        this.secondConfirmMessage = `Your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI} (Including Taxes).`;
        if (this.backdatedamount > 0) {
          this.secondConfirmMessage = `Your premium for plans will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}) (Including Taxes).`;
        }
        if (this.backdatedDependentsChild && this.backdatedDependentsChild.length > 0) {
          let fullNames = this.backdatedDependentsChild.map(item => item.fullName);
          this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
          if (this.maritalStatus == 'married') {
            this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
          } else {
            this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
          }
          this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
        }
      } else {
        console.log(this.marriageType, 'this.marriageType8888')
        if (this.maritalStatus == 'married') {
          this.secondConfirmMessage = `Your reporting of life event change is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
        } else {
          this.secondConfirmMessage = `Your reporting of life event change is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
        }


        let fullNames: any = [];
        if (this.backdatedDependentsChild.length > 0) {
          fullNames = this.backdatedDependentsChild.map(item => item.fullName);
        }
        if (this.backdatedDependentsSpouse.length > 0) {
          fullNames.push(this.backdatedDependentsSpouse[0].fullName)
        }

        if (fullNames && fullNames.length > 0) {
          if (this.maritalStatus == 'married' || this.dependentType == 'child') {
            this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
          } else {
            this.secondConfirmMessage = `Your reporting of life event change for(${fullNames.join(',')})  is outside the 360 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
          }
        }

        if (splitPackages.length > 0) {
          this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(splitPackages[0])}.`
          this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(splitPackages[0])}.`;
          this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`

        } else {
          this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)}.`
          this.firstConfirmMessage = `Your marital status will update ${this.coveragetext(this.coverageChange)}.`;
        }
        this.underWritingMessage2 = "Once approved you'll be advised of the premium change."
      }
      this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
      if (this.backdatedamount > 0) {
        this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI})(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
      }
      if (this.underWritingMessage2) {
        this.firstMessage = `Effective ${formattedDate}, your premium for plans will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}(Including Taxes). It will be reflected in your ${formattedDate.split(' ')[0]} invoice once admin approves.`
      }
      this.upcomingamount = Math.abs(this.upcomingamount).toFixed(2)
    } else {
      this.addToPolicy = 'close';
      this.showPlanDetails = false;
      this.isDirectUpdate = true;
      this.firstMessage = `No need to update the coverage, as it is already included under the current plan.`
    }

    this.notInitialLoad = true;
    this._LoaderService.hide();
    this.proceedDeleteButtonDisabled = false;
    // wait 800ms for session update — adjust if needed

    // initial delay




    console.log(this.selectedPlans_, 'Selected Plans');
    console.log(this.unSelectedPlans_, 'Unselected Plans');
  }


  processPackagesForCorp(dataaaa: any, formattedDate: any) {
    this.showCorpPlansTable = true;
    console.log(this.childrenDetailsForNormalReg, "8899childrendetails")
    this._LoaderService.show();
    // get all the upgraded plans
    this.effectedPackageNames = []
    this.upcomingamount = 0
    this.backdatedamount = 0;
    this.currentamount = 0
    this.upcomingamountUI = 0
    this.backdatedamountUI = 0;
    this.currentamountUI = 0
    this.clearAllMessages()
    let coverages = ['SINGLE', 'COUPLE', 'FAMILY']
    let currentCoverage = this.currentCoverage(this.coverageChange)?.toUpperCase() ?? "SINGLE";
    let getUpdatingCoverage = this.maritalStatusText(this.coverageChange)?.toUpperCase() ?? "COUPLE";
    this._LoaderService.hide()

    setTimeout(() => {

      let planSummMain: any = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
      console.log(planSummMain, "planSummMain")
      // Wait for click handlers to update sessionStorage
      this.payrollDeduction = false;
      this.upcomingamount = 0;
      this.currentamount = 0;
      this.upcomingamountWithoutTax = 0;
      this.currentamountWithoutTax = 0;
      this.upcomingamountTax = 0;
      this.currentamountTax = 0;
      this.effectedPackageNames = [];
      let isCoveredByCompany: any = false;

      const updatedPlans: any[] = JSON.parse(sessionStorage.getItem('plansummarymain') ?? '[]');
      console.log(updatedPlans)
      console.log(this.customerSelectedPlans)
      if (updatedPlans.length > 0) {
        for (const psm of updatedPlans) {
          // check if the same plan exists in the customer plans

          if (psm.paidByCompany && coverages.includes(psm.coverage)) {
            isCoveredByCompany = false;
            this.payrollDeduction = true;
            if (!this.effectedPackageNames.includes(psm.planproductname))
              this.effectedPackageNames.push(psm.planproductname);
          }
          if (psm.coveredByCompany && coverages.includes(psm.coverage)) {
            isCoveredByCompany = true;
            this.payrollDeduction = true;
            if (!this.effectedPackageNames.includes(psm.planproductname))
              this.effectedPackageNames.push(psm.planproductname);
          }
          this.upcomingamount += psm.total;
          this.upcomingamountWithoutTax += psm.planPrice;
          this.upcomingamountTax += psm.tax;

        }
      }

      for (const package_ of dataaaa.data.customerPlans) {
        this.currentamount += package_.total;
        this.currentamountWithoutTax += package_.totalPrice;
        this.currentamountTax += package_.totalTax;

      }


      console.log(this.upcomingamount, this.currentamount)
      this.upcomingamount = Math.abs(this.upcomingamount).toFixed(2)


      console.log(this.upcomingamount, this.currentamount)


      if (this.isSpecialCondition) {
        this.currentamount = 0;
      }

      for (const package_ of dataaaa.data.activeButCancelledInFuturePlans) {
        if (this.isSpecialCondition) {
          this.currentamount += package_.total;
        }
      }

      this.currentamount = Math.abs(this.currentamount).toFixed(2)
      this.upcomingamountUI = this.handleAmountonUI(Math.abs(this.upcomingamount).toFixed(2));
      this.currentamountUI = this.handleAmountonUI(Math.abs(this.currentamount).toFixed(2))
      console.log(this.normalDependentRegistration, this.normalSpouseRegistration)

      this.firstConfirmMessage = `Your marital status will change ${this.coveragetext(this.coverageChange)}`;




      this.backdatedDependentsChild = []
      this.backdatedDependentsSpouse = []
      let spouseDetails = this.spouseform.value;
      let childrenDetails = this.childrenDetails;

      console.log(spouseDetails, childrenDetails)

      if (this.childrenDetails && this.childrenDetails.length > 0) {
        this.childrenDetails.forEach((child: any) => {
          const dob = moment(parseDateOnly(child.dob));
          const today = moment();
          const daysDiff = today.diff(dob, 'days');

          let approvalNeeded = false;

          // Check backdated DOB (> 30 days ago)
          if (daysDiff > 30) {
            approvalNeeded = true;
          }

          // Additional special needs check
          if (child.specialNeeds) {
            approvalNeeded = true;
          }

          if (approvalNeeded) {
            this.backdatedDependentsChild.push(child)
          }
        });

      }

      if (!this.normalSpouseRegistration) {
        this.backdatedDependentsSpouse.push(spouseDetails)
      }

      const inputDate = moment(this.finalEffectiveDate);
      const today = moment().startOf('day');
      const isBackdated = inputDate.isBefore(today);
      if (isBackdated) {
        this.handleCalculateBackdatedPrice();
      }


      let sumAmount = Math.abs(parseFloat(this.upcomingamount) + parseFloat(this.backdatedamount)).toFixed(2)

      let splitPackages: any = [];
      if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length && this.coverageChange != this.coverageChange2) {
        splitPackages = this.splitPackages();
      }
      if (!this.normalSpouseRegistration && this.coverageChange != this.coverageChange2) {
        splitPackages = this.splitPackages();
      }

      if (this.normalDependentRegistration && this.normalSpouseRegistration) {
        if (this.upcomingamount !== this.currentamount && this.upcomingamount > 0 || this.isSpecialCondition) {
          // check if any other dependent is not covered
          if (this.childrenDetailsForNormalReg.length != this.childrenDetails.length) {
            // means one or more dependent is not covered
            this.underwritingHeading = `Your reporting of a life event change includes dependents both within and outside the ${(this.maritalStatus == 'married' || this.dependentType == 'child') ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
            if (this.coverageChange != this.coverageChange2) {
              this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
            }

          }
          this.secondMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}.`
          console.log(isCoveredByCompany, "isCoveredByCompany9900")
          if (isCoveredByCompany) {
            this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}. It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
            this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be paid through payroll deduction`;
          } else {
            this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${this.upcomingamountUI}.`
            // if backdated add the upcoming amount
            this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be 100% paid by company`;
          }
          if (this.backdatedamount > 0) {
            if (isCoveredByCompany) {
              this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}). It will be reflected in your ${formattedDate.split(' ')[0]} invoice.`
              this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be paid through payroll deduction`;
            } else {
              this.firstMessage = `Effective ${formattedDate}, your premium will be adjusted from $${this.currentamountUI} to $${sumAmount}($${this.upcomingamountUI} and $${this.backdatedamountUI}).`
              // if backdated add the upcoming amount
              this.corpMessage = `Your ${this.dependentType}'s premium of amount $${this.handleAmountonUI(Math.abs(this.upcomingamount - this.currentamount).toFixed(2))} will be 100% paid by the company`;
            }
          }

        }
        if (this.upcomingamount !== this.currentamount && this.upcomingamount == 0) {
          this.showCorpPlansTable = false;
          this.secondMessage = `No Need to pay the premium as the coverage is already covered`;
          this._LoaderService.hide()
          this.addToPolicy = 'close';
          this.showPlanDetails = false;
        }

        if (this.upcomingamount == 0) {
          this.addToPolicy = 'close';
          this.showPlanDetails = false;
          this.firstMessage = `Your marital status was changed ${this.coveragetext(this.coverageChange)}`;
          this.secondMessage = `your insurer doesn't provide the coverage to ${this.enactMode == 'add' ? "upgrade" : "downgrade"}.`;
        }
      } else {
        // check if normal dependent exists

        let fullNames: any = [];
        if (this.backdatedDependentsChild.length > 0) {
          fullNames = this.backdatedDependentsChild.map(item => item.fullName);
        }
        if (this.backdatedDependentsSpouse.length > 0) {
          fullNames.push(this.backdatedDependentsSpouse[0].fullName)
        }

        this.underwritingHeading = `Your reporting of 'life event change' for ${fullNames.join(',')} is outside the ${this.maritalStatus == 'married' ? "30" : "360"} day window. Request for Coverage for your dependents has to be approved by the insurance carrier(s) pending underwriting, which may take up to 6 weeks.`
        if (this.upcomingamount == this.currentamount && this.upcomingamount != 0) {
          this.showCorpPlansTable = false;
          this.firstMessage = `Your marital status was changed ${this.coveragetext(this.coverageChange)}`;
          this.secondMessage = `your insurer doesn't provide the coverage to ${this.enactMode == 'add' ? "upgrade" : "downgrade"}.`;
          this.addToPolicy = 'close';
          this.showPlanDetails = false;
        } else {
          this.secondConfirmMessage = `Your policies ${this.enactMode == 'add' ? "upgrade" : "downgrade"} ${this.coveragetext(this.coverageChange)} is pending approval from underwriting`
          this.underWritingMessage1 = 'This can take upto 6 weeks to complete.'
          this.underWritingMessage2 = "Once approved your future invoice will reflect the new amount."
          if (splitPackages.length > 0) {
            this.underwritingHeading = `Your reporting of a life event change includes dependents both within and outside the ${this.maritalStatus == 'married' ? "30" : "360"}-day eligibility window. As a result, coverage for one or more dependents requires approval from the insurance carrier(s), which may take up to 6 weeks pending underwriting.`
            this.secondConfirmMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgrade" : "downgrade"} ${this.coveragetext(splitPackages[0])}.`
            this.underWritingMessage1 = `A further upgrade ${this.coveragetext(splitPackages[1])} coverage is pending underwriting approval for additional dependents reported outside the eligibility window.`
            this.underWritingMessage2 = "This can take upto 6 weeks to complete. \n Once approved your future invoice will reflect the new amount."
          } else {
            this.secondConfirmMessage = `Your policies (${this.effectedPackageNames.join(',')}) will be ${this.enactMode == 'add' ? "upgrade" : "downgrade"} ${this.coveragetext(this.coverageChange)}.`
            if (this.coverageChange == this.coverageChange2) {
              // nothing
            } else {
              this.underWritingMessage1 = `The ${fullNames.join(',')} addition requires approval from the insurance carrier(s), pending underwriting, which may take up to 6 weeks.`
              this.underWritingMessage2 = ""
            }
          }
        }
      }

      this.showPlanDetails = false;
      this.showAfterPlanDetails = true;
      this._LoaderService.hide();
      this.notInitialLoad = true;

    }, 8000); // initial delay
  }


  async addDependent_v2Configuration() {
    console.log(this.childrenDetails)
    console.log(this.spouseform)
    if (this.dependentType == 'spouse' || this.dependentType == 'multiple') {
      if (this.spouseform.invalid) {
        this.spouseform.markAllAsTouched()
        return;
      }
    }


    if (this.finalEffectiveDate == null && this.addToPolicy == 'open') {
      Swal.fire({ title: "Info", text: "Please select effective date" }).then(res => {
        if (res.isConfirmed) {
          return;
        }
      })
    } else {
      this.showAddToPolicyError = false;
      // direct submit if there is no policy change
      if (this.addToPolicy == 'close') {
        await this.addDependent_v2Confirmation()
      } else {
        document.getElementById('addDependent')?.classList.add('d-none');

        // Show the second modal by removing d-none
        document.getElementById('showPlanSummaryBrief')?.classList.remove('d-none');
        document.getElementById('showPlanSummaryBrief')?.classList.add('d-block');
        document.getElementById('showPlanSummaryBrief')?.classList.add('show');
      }
    }


  }



  async deleteDependent_v2Configuration() {
    if (this.enactMode == 'delete') {
      if (this.deleteForm.invalid) {
        this.deleteForm.markAllAsTouched()
        return;
      }
    }


    if (this.finalEffectiveDate == null) {
      Swal.fire({ title: "Info", text: "Please select effective date" }).then(res => {
        if (res.isConfirmed) {
          return;
        }
      })
    } else {
      document.getElementById('addDependent')?.classList.add('d-none');

      // Show the second modal by removing d-none
      document.getElementById('showPlanSummaryBrief')?.classList.remove('d-none');
      document.getElementById('showPlanSummaryBrief')?.classList.add('d-block');
      document.getElementById('showPlanSummaryBrief')?.classList.add('show');
    }


  }
  async closeaddDependent_v2Confirmation() {
    console.log(this.obj1, "this.obj1plas")

    document.getElementById('addDependent')?.classList.add('d-block');
    document.getElementById('addDependent')?.classList.remove('d-none');

    // Show the second modal by removing d-none
    document.getElementById('showPlanSummaryBrief')?.classList.remove('d-block');
    document.getElementById('showPlanSummaryBrief')?.classList.add('d-none');
    document.getElementById('showPlanSummaryBrief')?.classList.remove('show');
  }
  async addDependent_v2Confirmation() {
    let validationInputData: any = {};
    console.log(this.spouseform.value)
    let spouseDetails: any = {}
    if (this.spouseform.value.fullName != null && this.spouseform.value.fullName != undefined && this.spouseform.value.fullName != '') {
      const fullName = this.spouseform.value.fullName.trim().split(/\s+/);
      console.log(fullName, "ajjjj")
      spouseDetails = {
        ...this.spouseform.value,
        firstName: fullName[0],
        lastName: fullName.slice(1).join(' '),
        dob: moment(this.spouseform.value.dob).format('YYYY-MM-DD'),
        gender: "Female",
        isBackdated: this.normalSpouseRegistration == true ? false : this.addToPolicy == 'open' ? true : false,
        maritalStatus: this.maritalStatus,
        dateOfMarriage: moment(this.spouseform.value.dateOfMarriage).format('YYYY-MM-DD')
      };
      if (this.enactMode == "delete" || this.enactMode == 'maritalChange') {
        spouseDetails.isBackdated = false;
      }
    }
    if (this.childrenDetails && this.childrenDetails.length > 0) {

      this.childrenDetails.forEach((child: any) => {
        const dob = moment(parseDateOnly(child.dob));
        const today = moment();
        const daysDiff = today.diff(dob, 'days');

        let approvalNeeded = false;

        // Check backdated DOB (> 30 days ago)
        if (daysDiff > 30) {
          approvalNeeded = true;
        }

        // Additional special needs check
        if (child.specialNeeds) {
          approvalNeeded = true;
        }

        if (this.addToPolicy == 'close') {
          approvalNeeded = false;
        }

        // Graduation date logic
        if (child.graduationDate) {
          const graduationDate = moment(child.graduationDate, 'MM-DD-YYYY');
          child.graduationDate = graduationDate.format('YYYY-MM-DD');
          this.isGradError = graduationDate.isBefore(dob);
        }

        // Split full name
        if (child.fullName) {
          child.firstName = child.fullName.split(' ')[0];
          child.lastName = child.fullName.trim().split(/\s+/).slice(1).join(' ');
        }

        // Format and assign DOB
        child.dob = dob.format('YYYY-MM-DD');

        // Final backdated flag per child
        child.isBackdated = approvalNeeded;
      });

    }
    let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
    let plans: any = []
    if (this.isCorporateAccount) {

      let plansummaryLIFEFinal: any = []
      let plansummary: any;
      let provisioning: any = false;
      let iafgPlansAvailability: any = false;
      let plansummaryMain: any = JSON.parse(sessionStorage.getItem("allSelectedPlans") ?? "[]")

      let plansummaryLIFE: any = JSON.parse(sessionStorage.getItem("planssummarymainLife") ?? "[]")
      let planDetailsArrayBlock = JSON.parse(sessionStorage.getItem("planssummarymainLife") ?? "[]")



      plansummaryLIFE.forEach((element: any, index: number) => {

        element.member.maximumCoverageWithoutEvidence = element.member.defaultRange

        if (element.spouse && element.spouse.maximumCoverageWithoutEvidence) {
          element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange

        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$" + element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] = element.guaranteedAcceptanceDetails.total
        element['totalPrice'] = element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$" + element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$" + element.guaranteedAcceptanceDetails.tax
        plansummaryLIFEFinal.push(element)

      });
      planDetailsArrayBlock.forEach((element: any, index: number) => {
        if (element.id == 13) {
          iafgPlansAvailability = true
        }
        else {
          iafgPlansAvailability = false
        }

      });

      plansummary = plansummaryMain.concat(plansummaryLIFEFinal)

      plansummary = plansummary.sort(function (a: any, b: any) {
        return (a.packageId - b.packageId);
      })
      console.log(plansummary)
      let taxesInfo = {}
      plansummary.forEach((element: any) => {

        if (element.packageId == 1) {
          provisioning = true
        }

        element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.tax = this._decimalPipe.transform(element.tax, "1.2-2")?.replace(/,/g, "")
        element.amount = this._decimalPipe.transform(element.amount, "1.2-2")?.replace(/,/g, "")
        element.planLevelName = element.groupName
        taxesInfo = this.determineTaxes(element?.products?.[0]?.calculatedTax?.planProductInfos ?? [])
        element.taxApplicable = element.tax > 0
        Object.assign(element, taxesInfo);
        plans.push(element)
      });
    }
    validationInputData['plans'] = this.isCorporateAccount ? plans : plansMain
    validationInputData['spouseDetails'] = spouseDetails.fullName != '' ? spouseDetails : {};
    validationInputData['childrenDetails'] = this.childrenDetails
    validationInputData['isPolicyChange'] = this.addToPolicy == 'open' ? true : (this.enactMode == 'delete' || this.enactMode == 'maritalChange') ? true : false
    if (this.enactMode == 'delete' || this.enactMode == 'maritalChange') {
      validationInputData['isPolicyChange'] = this.normalDependentDeletion ? false : true;
    }
    validationInputData['coverageScenario'] = this.coverageChange
    validationInputData['isCorporateCustomer'] = this.isCorporateAccount ? true : false
    validationInputData['payrollDeduction'] = this.payrollDeduction
    validationInputData['differenceAmount'] = parseFloat(Math.abs(this.upcomingamountWithoutTax - this.currentamountWithoutTax).toFixed(2)) ?? 0;
    validationInputData['eventType'] = this.cobeventType == 'add' ? 'upgrade' : 'downgrade'
    validationInputData['effectiveDate'] = moment(this.finalEffectiveDate).format('YYYY-MM-DD')
    validationInputData['maxEnrollmentDate'] = this.maxEnrollmentDate
    validationInputData['coverageChange2'] = this.coverageChange2
    validationInputData['isSpecialCondition'] = this.isSpecialCondition
    validationInputData['customerPlans'] = this.customerOldPlans



    if (this.enactMode == 'delete' || this.enactMode == 'maritalChange') {
      if (this.dependentType == 'spouse') {
        validationInputData['spouseDetails'] = this.isSpouseSelected ? this.isSpouseSelected : {};
      } else {
        validationInputData['childrenDetails'] = this.isChildSelected ? [this.isChildSelected] : [];
      }
    }
    if (this.enactMode == 'cob') {
      validationInputData['isPolicyChange'] = true;
      console.log(this.availableFirstNames, "this.availableFirstNames")
      console.log(this.cobevent, this.cobeventType)
      if (this.cobevent == 'spouse') {
        console.log(this.cobform.value)
        spouseDetails = this.availableFirstNames.find(item => item.relationType == 'spouse');
        validationInputData['spouseDetails'] = spouseDetails
      }
    }
    let event: any;
    if (this.enactMode == 'add') {
      event = 'add';
    } else if (this.enactMode == 'delete' || this.enactMode == 'maritalChange') {
      event = 'remove';
    } else {
      if (this.enactMode == "cob") {
        event = this.cobeventType
      }
    }
    validationInputData['isCancelAll'] = false;
    if (this.dependentType == 'child') {
      validationInputData['spouseDetails'] = {}
    }
    if (this.dependentType == 'spouse') {
      validationInputData['childrenDetails'] = []
    }
    let endPoint: any;
    if (this.enactMode == 'cob') {
      endPoint = `/customer/v2new/${this.customerid}/lifeChange/${this.cobevent}/${event}/false`
    } else {
      endPoint = `/customer/v2new/${this.customerid}/lifeChange/${this.dependentType}/${event}/false`
    }
    console.log(validationInputData, endPoint)


    let dataaaa: any;
    this.http.post(api.url + endPoint, validationInputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (this.backdatedDependentsChild.length > 0 || this.backdatedDependentsSpouse.length > 0) {
        Swal.fire({ title: "Info", text: 'Changes will be reflected soon once the admin approved.' }).then(res => {
          if (res.isConfirmed) {
            window.location.reload()
          }
        })
      } else {
        Swal.fire({ title: "Info", text: this.enactMode == 'cob' ? 'COB details updated successfully' : `Dependent has been ${this.enactMode == 'delete' ? "removed" : "added"} successfully` }).then(res => {
          if (res.isConfirmed) {
            window.location.reload()
          }
        })
      }
    })


  }


  public determineTaxes(taxArray: any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };
    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }

      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = tax.price + (taxObj.pst ?? 0);
        taxObj.pstTaxRate = (tax.taxRate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = tax.price + (taxObj.hst ?? 0);
        taxObj.hstTaxRate = (tax.taxRate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = tax.price + (taxObj.gst ?? 0);
        taxObj.gstTaxRate = (tax.taxRate) * 100;
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0, -1);
      taxObj.taxName = taxObj.taxName?.trim();
    }

    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }

    return taxObj;
  }
}

export function postalcodeValidator(control: FormControl): { [key: string]: any } | null {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null
}

export function notSameAsPrimaryValidator(primaryControlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const primaryControl = control.root.get(primaryControlName);
    if (!primaryControl || !primaryControl.value || control.value === primaryControl.value) {
      return { 'notSameAsPrimary': true };
    }
    return null;
  };
}
function phoneNumbersMustBeDifferent(control: AbstractControl): { [key: string]: boolean } | null {
  const primaryPhoneNumber = control.get('primaryPhone')?.value;
  const secondaryPhoneNumber = control.get('secondaryPhone')?.value;

  if (secondaryPhoneNumber == "") {
    return { phoneNumbersMatch: false };
  }
  else if (primaryPhoneNumber === secondaryPhoneNumber) {
    return { phoneNumbersMatch: true };
  }
  return null;
}


export function childrenminimumAgeValidator(control: AbstractControl): any {
  const birthDate = parseDateOnly(control.value);
  if (!birthDate) {
    return null;
  }
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();

  console.log(age)
  if (age > 21) {
    return { childrenminimumAge: true };
  }
}

function hasWhiteSpace(s: any) {
  return /\s/g.test(s);
}
